/**
 * Chinese (Simplified) translations for the Conductor UI.
 * Mirrors the key structure of en.ts exactly.
 */
const zh = {
  long_content: {
    notice: '正文较长（{count} 字符），已切换为纯文本模式。原文完整保留。',
    view: '分页查看原文',
    summary: '返回摘要',
    copy: '复制完整原文',
    previous: '上一页',
    next: '下一页',
    page: '第 {page} / {pages} 页',
    copied: '已复制完整原文',
    copy_failed: '复制失败，请允许浏览器访问剪贴板后重试。',
    truncated: '当前仅显示前 {count} 字符。',
    paged_notice: '内容较长（{count} 字符），已分页显示。',
    page_nav: '文档分页',
    toc: '跳转到章节',
  },

  // ── Common / Shared ──────────────────────────────────────────────
  common: {
    cancel: '\u53D6\u6D88',
    copy: '\u590D\u5236',
    copied: '\u5DF2\u590D\u5236!',
    loading: '\u52A0\u8F7D\u4E2D...',
    save: '\u4FDD\u5B58',
    delete: '\u5220\u9664',
    remove: '\u79FB\u9664',
    approve: '\u6279\u51C6',
    reject: '\u62D2\u7EDD',
    export: '\u5BFC\u51FA',
    error: '\u9519\u8BEF',
    or: '\u6216',
    from: '\u6765\u81EA',
    on: '\u4E8E',
    saving: '\u4FDD\u5B58\u4E2D...',
    conductor: 'Conductor',
    wecom: '\u4F01\u4E1A\u5FAE\u4FE1',
    web: '\u7F51\u9875',
    close: '\u5173\u95ED',
    close_aria: '\u5173\u95ED',
    unlimited: '\u4E0D\u9650',
  },

  // ── Login Page ───────────────────────────────────────────────────
  login: {
    title: 'Conductor',
    subtitle: 'AI \u9A71\u52A8\u7684\u5F00\u53D1\u52A9\u624B',
    username_label: '用户名 / 邮箱 / 手机号',
    password_label: '\u5BC6\u7801',
    username_placeholder: '\u7528\u6237\u540D/\u90AE\u7BB1/\u624B\u673A\u53F7',
    password_placeholder: '\u8BF7\u8F93\u5165\u5BC6\u7801',
    signing_in: '\u767B\u5F55\u4E2D...',
    sign_in: '\u767B\u5F55',
    sign_in_wecom: '\u4F01\u4E1A\u5FAE\u4FE1\u767B\u5F55',
    username_required: '\u7528\u6237\u540D\u4E0D\u80FD\u4E3A\u7A7A',
    password_required: '\u5BC6\u7801\u4E0D\u80FD\u4E3A\u7A7A',
    wecom_no_account: '\u672A\u627E\u5230\u4E0E\u6B64\u4F01\u4E1A\u5FAE\u4FE1\u8EAB\u4EFD\u5173\u8054\u7684\u8D26\u6237\u3002\u8BF7\u5148\u4F7F\u7528\u7528\u6237\u540D/\u5BC6\u7801\u767B\u5F55\u3002',
    wecom_login_failed: '\u4F01\u4E1A\u5FAE\u4FE1\u767B\u5F55\u5931\u8D25\uFF1A{error}',
    wecom_qr_failed: '\u52A0\u8F7D\u4F01\u4E1A\u5FAE\u4FE1\u4E8C\u7EF4\u7801\u767B\u5F55\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5\u3002',
    error_invalid_credentials: '\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF',
    error_account_locked: '\u8D26\u53F7\u56E0\u591A\u6B21\u767B\u5F55\u5931\u8D25\u5DF2\u88AB\u9501\u5B9A\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458',
    forgot_link: '忘记密码？',
    register_entry: '新用户注册',
    register_code_label: '邀请码',
    register_code_placeholder: '请输入邀请码',
    register_code_required: '请输入邀请码',
    register_continue: '继续注册',
  },

  // ── Forgot / Reset Password ──────────────────────────────────────
  forgotPassword: {
    title: '重置密码',
    subtitle_choose: '选择已登记的方式接收重置说明',
    tab_email: '邮箱',
    tab_phone: '手机号',
    back_to_login: '← 返回登录',
    email_label: '邮箱地址',
    email_placeholder: 'you@example.com',
    email_hint: '我们将向该邮箱发送一个重置链接',
    send_link: '发送重置链接',
    phone_subtitle: '通过短信验证码重置',
    phone_label: '手机号',
    phone_placeholder: '请输入登记的手机号',
    code_label: '验证码',
    code_placeholder: '6 位验证码',
    send_code: '获取验证码',
    resend_countdown: '重新发送 ({seconds}s)',
    new_password_label: '新密码',
    new_password_placeholder: '至少 8 位，含字母和数字',
    confirm_password_label: '确认新密码',
    confirm_password_placeholder: '再次输入新密码',
    submit_phone: '重置密码',
    email_sent_title: '请查收邮箱',
    email_sent_sub: '如果该账号存在，我们已发送重置说明',
    email_sent_body: '已向 {email} 发送重置链接，请在 30 分钟内点击邮件中的链接完成密码重置。',
    resend: '没收到？重新发送',
    err_email_required: '请输入邮箱地址',
    err_phone_required: '请输入手机号',
    err_code_required: '请输入验证码',
    err_password_policy: '密码至少 8 位，且需同时包含字母和数字',
    err_passwords_mismatch: '两次输入的密码不一致',
    generic_error: '操作失败，请稍后重试',
    reset_title: '设置新密码',
    reset_sub: '为您的账号设置一个新密码',
    reset_hint: '建议混合大小写字母、数字与符号',
    reset_submit: '确认重置',
    reset_missing_token: '该重置链接无效或已过期（有效期 30 分钟）。请重新发起“忘记密码”。',
    reset_request_again: '重新申请重置链接',
    reset_success: '密码已重置，请使用新密码登录',
  },

  // ── Chat Page ────────────────────────────────────────────────────
  chat: {
    // P-COND-DF0BDCAF2C0A ST3: upload failed, composer restored.
    upload_failed_restored: '上传失败：{detail}。内容已放回输入框，请确认后重新发送。',
    header: {
      conductor: 'Conductor',
      dispatch_approvals: '\u6D3E\u53D1\u5BA1\u6279',
      collab_approvals: '\u534F\u4F5C\u5BA1\u6279',
      approvals: '\u5BA1\u6279',
      admin: '\u7BA1\u7406',
      admin_panel: '\u7BA1\u7406\u9762\u677F',
      logout: '\u9000\u51FA',
      manage_menu: '\u7BA1\u7406',
      user_manual: '\u7528\u6237\u8BF4\u660E\u4E66',
      skill_center: "技能中心",
      desktop_download: '\u4E0B\u8F7D\u684C\u9762\u7AEF',
    },
    status: {
      connected: '\u5DF2\u8FDE\u63A5',
      connecting: '\u8FDE\u63A5\u4E2D...',
      disconnected: '\u5DF2\u65AD\u5F00',
      reconnect: '\u91CD\u65B0\u8FDE\u63A5',
    },
    toggle: {
      archived: '\u5DF2\u5F52\u6863',
      active: '\u6D3B\u8DC3',
    },
    refresh_title: '\u5237\u65B0\u4F1A\u8BDD',
    show_active: '\u663E\u793A\u6D3B\u8DC3\u4F1A\u8BDD',
    show_archived: '\u663E\u793A\u5DF2\u5F52\u6863\u4F1A\u8BDD',
    no_projects: '\u60A8\u6682\u65E0\u6240\u5C5E\u9879\u76EE\u3002\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458\u5C06\u60A8\u52A0\u5165\u5177\u4F53\u9879\u76EE\u3002',
    toggle_sidebar: '\u5207\u6362\u4FA7\u8FB9\u680F',
    // SP-U2 首次进入空状态引导
    empty_title: '\u6B22\u8FCE\uFF01\u8FD8\u6CA1\u6709\u4F1A\u8BDD',
    empty_hint: '\u521B\u5EFA\u7B2C\u4E00\u4E2A\u4F1A\u8BDD\uFF0C\u5F00\u59CB\u4E0E\u9879\u76EE\u4EE3\u7406\u534F\u4F5C\u3002',
    empty_cta: '\u521B\u5EFA\u7B2C\u4E00\u4E2A\u4F1A\u8BDD',
    empty_secondary: '\u63D0\u793A\uFF1A\u53EF\u5728\u5DE5\u4F5C\u533A\u8BBE\u7F6E\u4E2D\u9080\u8BF7\u540C\u4E8B\u6216\u5B8C\u5584\u534F\u4F5C\u8D44\u6599\u3002',
    start_new_conversation: '\u5F00\u59CB\u65B0\u4F1A\u8BDD',
    // P-COND-F4E1C7B13B15 ST2 — 零项目引导卡片（ChatPage 主区）。
    // 文案照搬已批准的设计稿 l1-empty-project-guide.html。
    zero_project: {
      title: '还没有任何项目',
      sub: '会话必须归属于一个项目。请先创建项目，之后就能在该项目下开始会话。',
      step_1: '点击下方「创建项目」，填写项目名称与代码位置。',
      step_2: '选择工作模式（开发 / 协作）与复杂度档位，系统据此生成工作区。',
      step_3: '创建完成后打开项目，项目频道会推送一条上手指引。',
      cta: '创建项目',
      new_conversation: '新建会话',
      hint: '需要先有项目，才能创建会话。',
    },
    projects_unavailable: {
      title: '项目列表加载失败',
      sub: '暂时没能取到你的项目列表（已自动重试一次）。检查网络后可以再试一次。',
      retry: '重新加载',
    },
    collab: {
      welcome_title: '\u6B22\u8FCE\u4F7F\u7528\u534F\u4F5C\u5DE5\u4F5C\u533A',
      welcome_text: '\u4E0A\u4F20\u8D44\u6599\u5E76\u63CF\u8FF0\u4F60\u7684\u9700\u6C42\uFF0CAgent \u534F\u52A9\u4F60\u8D77\u8349\u3001\u6574\u7406\u548C\u5F52\u6863\u672C\u90E8\u95E8\u7684\u5DE5\u4F5C\u3002',
      tasks_heading: '\u8BD5\u8BD5\u8FD9\u4E9B\u4EFB\u52A1\uFF1A',
      task_1: '\u8D77\u8349\u4E00\u4EFD\u5E02\u573A\u5206\u6790\u62A5\u544A',
      task_2: '\u6574\u7406\u5E76\u5F52\u6863\u90E8\u95E8\u89C4\u8303\u6587\u4EF6',
      task_3: '\u5C06\u4F1A\u8BAE\u7EAA\u8981\u8F6C\u5316\u4E3A\u884C\u52A8\u8BA1\u5212',
      cta: '\u5F00\u59CB\u534F\u4F5C\u4F1A\u8BDD',
      secondary_hint: '\u534F\u4F5C\u6A21\u5F0F\uFF1A\u672C\u90E8\u95E8\u6587\u4EF6\u53EF\u8BFB\u5199\uFF0C\u8DE8\u90E8\u95E8\u5185\u5BB9\u53EA\u8BFB\u3002',
    },
    dev: {
      tasks_heading: '\u8BD5\u8BD5\u8FD9\u4E9B\u4EFB\u52A1\uFF1A',
      task_1: '\u5F00\u53D1\u4E0E\u6D4B\u8BD5\uFF1A\u5B9E\u73B0\u529F\u80FD\u3001\u4FEE\u590D\u7F3A\u9677\u3001\u7F16\u5199\u6D4B\u8BD5',
      task_2: '\u4EA7\u54C1\u4E0E\u8BBE\u8BA1\uFF1A\u62C6\u89E3\u9700\u6C42\u3001\u9875\u9762\u539F\u578B',
      task_3: '\u8FD0\u7EF4\u4E0E\u90E8\u7F72\uFF1A\u65E5\u5FD7\u6392\u67E5\u3001\u53D1\u5E03\u4E0E\u56DE\u6EDA',
    },
    error: {
      unknown: '\u672A\u77E5\u9519\u8BEF',
      create_failed: '\u521B\u5EFA\u4F1A\u8BDD\u5931\u8D25\uFF1A{detail}',
      retry: '\u91CD\u8BD5',
      dismiss_aria: '\u5173\u95ED',
    },
    streaming: {
      call_count: "调用次数",
      state_done: "已确认完成",
      state_error: "执行失败",
      state_running: "运行中",
      state_unknown: "结果未确认",
      reason_cancelled: "已取消，未取得结果",
      reason_timeout: "已超时，未取得结果",
      reason_truncated: "记录截断，未取得结果",
      reason_missing_result: "未取得执行结果",
      exit_code: "退出码 {code}",
      skill_read: "已观察到技能读取：{name}（文件读取，不代表流程完成）",
      skills_unconfirmed: "技能读取：未确认",
      thinking_aria: 'Agent \u601D\u8003\u4E2D',
      // AISS-240 long-task progress line. {m}/{s} = minutes / zero-padded
      // seconds; elapsed_short is used for the sub-minute case.
      elapsed: '\u5DF2\u8FD0\u884C {m} \u5206 {s} \u79D2',
      elapsed_short: '\u5DF2\u8FD0\u884C {s} \u79D2',
      idle: '\u6700\u8FD1\u6D3B\u52A8 {m} \u5206 {s} \u79D2\u524D',
      idle_short: '\u6700\u8FD1\u6D3B\u52A8 {s} \u79D2\u524D',
      progress_aria: '\u4EFB\u52A1\u8FDB\u884C\u4E2D',
      // Live reasoning strip (P-COND-257F4A39271B). {n} = reasoning char count.
      reasoning_live: '思考中…',
      reasoning_done: '思考过程',
      reasoning_chars: '（{n} 字）',
      reasoning_toggle_aria: '展开或收起思考过程',
      // Thinking hint (P-COND-177E21301650), shown only after the backend's
      // `thinking_status` frame. {s} = whole seconds since that frame.
      thinking_elapsed: 'AI 正在思考（{s} 秒）',
    },
  },

  // ── 阶段零·理解既有项目卡片 (workspace-modes SP-U2) ──────────
  stage0: {
    badge: '\u9636\u6BB5\u96F6',
    title: '\u6B63\u5728\u7406\u89E3\u60A8\u7684\u73B0\u6709\u9879\u76EE',
    body: '\u4EE3\u7406\u6B63\u5728\u53CD\u5411\u7406\u89E3\u60A8\u7684\u73B0\u6709\u4EE3\u7801\u5E93\uFF0C\u4EE5\u4FBF\u5728\u9700\u6C42\u91C7\u96C6\u4E4B\u524D\u638C\u63E1\u5176\u7ED3\u6784\u4E0E\u610F\u56FE\u3002\u8BF7\u5728\u4F1A\u8BDD\u4E2D\u67E5\u770B\u5176\u7406\u89E3\u6982\u8FF0\u3002\u82E5\u7406\u89E3\u65E0\u8BEF\uFF0C\u8BF7\u70B9\u51FB\u786E\u8BA4\u4EE5\u8FDB\u5165\u9700\u6C42\u9636\u6BB5\u3002',
    confirm: '\u786E\u8BA4\u7406\u89E3\u6B63\u786E',
    confirm_hint: '\u8FDB\u5165\u9636\u6BB5\u4E00\uFF08\u7528\u6237\u9700\u6C42\uFF09',
    correct: '\u7406\u89E3\u4E0D\u6B63\u786E',
    correct_hint: '\u5728\u4E0B\u65B9\u8F93\u5165\u6846\u5411\u4EE3\u7406\u53D1\u9001\u7EA0\u6B63\u53CD\u9988',
  },

  // ── Conversation List ────────────────────────────────────────────
  conv_list: {
    // 不含前导 '+' —— '+' 由组件（ConversationList `.l2-new-conv-btn`）提供。
    // Contract Pack：二者只可存其一，否则渲染出「+ + 新建会话」。
    new_conversation: '\u65B0\u5EFA\u4F1A\u8BDD',
    all_projects: '所有项目',
    back_to_projects: '返回所有项目',
    // L1 项目行（`.proj-card`）—— 计数与状态文案。
    // 均带 {count} 占位符：中文「6 个项目」与英文「6 projects」词序不同，
    // 由组件拼 `{n} {t(...)}` 会把词序写死在 TSX 里。
    projects_count: '{count} 个项目',
    proj_conv_count: '{count} 个会话',
    proj_no_convs: '尚无会话',
    proj_status_running: '运行中',
    proj_status_dirty: '有变更',
    proj_status_synced: '已同步',
    // `.proj-org` 组织标签的悬浮/无障碍说明。标签本身只显示组织名（数据），
    // 单看是个无语义的灰色胶囊，故用 title 说明它是「所属组织」。
    proj_org_title: '所属组织：{name}',
    // L2 头部工作区模式标签（`.l2-mode-tag`）。判定来自 project.mode_paths
    // （AD-63），只有「开发」「协作」两种；「统筹」是会话级 dev_submode，
    // 绝不出现在项目级标签上。
    mode_dev: '开发',
    mode_collab: '协作',
    mode_dev_title: '开发模式：本项目工作区用于分支开发',
    mode_collab_title: '协作模式：本项目工作区用于多部门知识协作',
    // 会话行只读收藏指示（`.conv-fav-heart`，与筛选盘同一爱心路径）。
    // 红心本身无操作，收藏/取消在 ⋮ 菜单里。
    favorited: '已收藏',
    project_channel: '项目频道',
    project_channel_sub: '公告与通知',
    project_channel_unread: '有未读公告',
    search_placeholder: '\u641C\u7D22\u4F1A\u8BDD ID / \u5206\u652F / \u6807\u9898 / \u5185\u5BB9',
    search_clear: '清空搜索',
    // L2 会话区段标题 + 折叠筛选盘的开关
    recent_conversations: '最近会话',
    filters_toggle: '筛选',
    loading: '\u52A0\u8F7D\u4F1A\u8BDD\u4E2D...',
    loading_more: '\u52A0\u8F7D\u66F4\u591A...',
    empty_archived: '\u6CA1\u6709\u5DF2\u5F52\u6863\u7684\u4F1A\u8BDD',
    empty_active: '\u672A\u627E\u5230\u4F1A\u8BDD',
    // L1 零项目提示（由父组件传入的 `hasNoProjects` 触发）
    empty_no_projects: '暂无项目。',
    empty_no_projects_note: '项目层不提供「新建会话」入口——会话属于某个具体项目。',
    new_conversation_preview: '\u65B0\u4F1A\u8BDD',
    branched_from: '分支自 {title}',
    branched_from_title: '回到原会话',
    branch_count: '{count} 个分支',
    branch_toggle_title: '展开 / 收起分支会话',
    start_new_title: '\u5F00\u59CB\u65B0\u4F1A\u8BDD',
    archive_title: '\u5F52\u6863\u4F1A\u8BDD',
    restore_title: '\u6062\u590D\u4F1A\u8BDD',
    delete_title: '\u5220\u9664\u4F1A\u8BDD',
    edit_theme_title: '\u53CC\u51FB\u7F16\u8F91\u4E3B\u9898',
    delete_confirm: '\u786E\u5B9A\u6C38\u4E45\u5220\u9664\u6B64\u4F1A\u8BDD\u53CA\u5176\u6240\u6709\u6D88\u606F\uFF1F\u6B64\u64CD\u4F5C\u4E0D\u53EF\u64A4\u9500\u3002',
    archived_badge: '\u5DF2\u5F52\u6863',
    branch: '\u5206\u652F',
    link: '\u4F1A\u8BDD ID',
    git_status_clean: '未修改 · 无待提交内容',
    git_status_pending: '待提交 · 有改动未 commit',
    git_status_committed: '已提交（本地）· 方案3 正常',
    agent_running: '执行中 · agent 正在处理',
    favorite_title: '\u6536\u85CF\u4F1A\u8BDD',
    unfavorite_title: '\u53D6\u6D88\u6536\u85CF',
    favorite_filter: '\u6536\u85CF',
    unknown_project: '\u672A\u77E5\u9879\u76EE',
    date_filter_label: '\u65F6\u95F4\u8303\u56F4',
    date_all: '\u5168\u90E8',
    date_7d: '7\u5929',
    date_30d: '30\u5929',
    date_90d: '90\u5929',
    show_more_convs: '\u663E\u793A\u66F4\u591A ({count})',
    show_less_convs: '\u6536\u8D77',
    view_all_project: '\u67E5\u770B\u5168\u90E8',
    menu_open: '\u64CD\u4F5C',
    menu_group_conversation: '\u4F1A\u8BDD',
    menu_group_git: 'Git \u64CD\u4F5C',
    menu_rename: '\u91CD\u547D\u540D\u4E3B\u9898',
    menu_copy_id: '\u590D\u5236\u4F1A\u8BDD ID',
    menu_copy_branch: '\u590D\u5236\u5206\u652F\u540D',
    menu_favorite: '\u6536\u85CF',
    menu_unfavorite: '\u53D6\u6D88\u6536\u85CF',
    menu_archive: '\u5F52\u6863',
    menu_unarchive: '\u6062\u590D',
    menu_delete: '\u5220\u9664',
    menu_push: 'Push \u63A8\u9001',
    menu_merge: 'Merge \u5408\u5E76',
    menu_push_disabled_hint: '\u5C1A\u65E0\u6539\u52A8',
    menu_merge_disabled_hint: '\u9700\u5148 push',
    menu_merge_master_hint: 'master \u7531 push \u664B\u7EA7\uFF0C\u65E0\u9700 merge',
  },

  // ── Chat Container ──────────────────────────────────────────────
  chat_container: {
    title_menu_open: '会话操作',
    branch_status: {
      active: '未推送',
      pushed: '已推送 · 待合并',
      pushed_final: '已推送',
      merged: '已合并',
    },
    mode_badge: {
      operation: '统筹',
      operation_tip: '统筹（dev 子模式）：整理零散分支、清理 worktree/clone、合并内容，非新功能开发',
      branch_tip: '当前会话的功能分支',
    },
    readonly_channel: '项目公告频道为只读，仅展示系统公告与定时任务结果。要交办工作，请新建一个会话。',
    readonly_forked: '此会话已转为只读，请到派生会话继续。',
    branch_notice: '本会话与原会话共用分支 {branch}，可以继续开发，改动会提交到同一分支。请避免两边同时修改同一批文件。',
    branch_notice_no_branch: '本会话与原会话共用同一工作目录，可以继续开发。请避免两边同时修改同一批文件。',
    branch_notice_dismiss: '关闭提示',
    ask_failed: '发问失败：{detail}',
    welcome_title: '\u6B22\u8FCE\u4F7F\u7528 Conductor',
    welcome_text: '\u4ECE\u4FA7\u8FB9\u680F\u9009\u62E9\u4F1A\u8BDD\u6216\u521B\u5EFA\u65B0\u4F1A\u8BDD\u5F00\u59CB\u3002',
    loading_messages: '\u52A0\u8F7D\u6D88\u606F\u4E2D...',
    share: '\u5206\u4EAB',
    share_with_team: '与团队共享',
    share_sheet_title: '\u5206\u4EAB',
    copy_conversation_id: '复制会话 ID',
    copy_conversation_id_sub: '发给同事即可定位',
    share_with_team_sub: '转为团队会话',
    members_sub: '查看与管理成员',
    export_sub: '选择格式',
    files: '文件',
    export_ellipsis: '\u5BFC\u51FA\u2026',
    members_count: '\u6210\u5458 ({count})',
    members_title: '\u6210\u5458',
    owner: '\u62E5\u6709\u8005',
    member: '\u6210\u5458',
    select_user: '\u9009\u62E9\u8981\u6DFB\u52A0\u7684\u7528\u6237...',
    adding: '\u6DFB\u52A0\u4E2D...',
    add: '\u6DFB\u52A0',
    failed_remove_member: '\u79FB\u9664\u6210\u5458\u5931\u8D25\u3002',
    failed_add_member: '\u6DFB\u52A0\u6210\u5458\u5931\u8D25\u3002',
    share_dialog_title: '\u5206\u4EAB\u7ED9\u56E2\u961F',
    share_dialog_body: '\u8FD9\u5C06\u5141\u8BB8\u60A8\u5C06\u56E2\u961F\u6210\u5458\u6DFB\u52A0\u5230\u6B64\u4F1A\u8BDD\u3002\u6240\u6709\u5386\u53F2\u6D88\u606F\u5C06\u5BF9\u60A8\u6DFB\u52A0\u7684\u4EBA\u53EF\u89C1\u3002\u6B64\u64CD\u4F5C\u4E0D\u53EF\u64A4\u9500\u3002',
    convert_and_share: '\u8F6C\u6362\u5E76\u5206\u4EAB',
    export_conversation: '\u5BFC\u51FA\u4F1A\u8BDD',
    toggle_member_list: '\u5207\u6362\u6210\u5458\u5217\u8868',
  },

  // ── Input Area ──────────────────────────────────────────────────
  input: {
    plusMenu: {
      title: "添加到本次消息",
      aria: "添加到本次消息",
      back: "返回",
      close: "关闭",
      files: "添加文件",
      filesSub: "上传或从中转站选择",
      skills: "技能",
      skillsSub: "选择完成任务的方法",
      skillsSelected: "已选 /{slug}",
      skillsTitle: "选择技能",
      mcp: "连接",
      mcpTag: "MCP",
      mcpSub: "{usable} 个可用 · {needs} 个需处理",
      mcpLoading: "正在读取连接…",
    },
    send: '\u53D1\u9001',
    cancel: '\u53D6\u6D88',
    // 运行中按钮统一称"停止"——任务已完成的部分不会被撤销，"取消"语义错误。
    stop: '\u505C\u6B62',
    attach_files: '\u9644\u52A0\u6587\u4EF6',
    cancel_response: '\u53D6\u6D88\u56DE\u590D',
    // native_loop 运行中 textarea 解锁后的 placeholder + 补充发送失败提示。
    supplement_hint: '\u8FFD\u52A0\u4FE1\u606F\u7ED9 agent\u2026',
    supplement_failed: '\u8FFD\u52A0\u4FE1\u606F\u53D1\u9001\u5931\u8D25\uFF1A{detail}',
    // 上一条补充尚未被 agent 受理时，补充发送按钮置灰的解释性 title。
    supplement_pending_hint: '\u4E0A\u4E00\u6761\u8865\u5145\u8FD8\u672A\u88AB agent \u53D7\u7406\uFF0C\u53D7\u7406\u540E\u53EF\u7EE7\u7EED\u8FFD\u52A0',
    quote_chip: '引用',
    quote_chip_ask: '发问',
    quote_remove: '移除引用',
    quote_bar_label: '引用 {count} 段',
    supplement_quote_blocked: '有待发送的引用，请在本轮结束后发送',
    quote_truncated: '已截断至 {max} 字',
    quote_note_add: '加意见',
    quote_note_edit: '修改意见',
    quote_note_placeholder: '对这段的意见…（Enter 确认 · Shift+Enter 换行 · Esc 取消）',
    quote_note_prefix: '意见：',
    branch_context_label: '分支背景',
    branch_context_ask_label: '发问片段',
    branch_context_remove: '移除分支背景',
    // 后端 409：槽位仍被占用（上一条尚未被消费）。
    supplement_conflict: '\u4E0A\u4E00\u6761\u8865\u5145\u5C1A\u672A\u88AB\u53D7\u7406\uFF0C\u8BF7\u7A0D\u540E\u518D\u53D1',
    send_message: '\u53D1\u9001\u6D88\u606F (Enter)',
    message_input: '\u6D88\u606F\u8F93\u5165',
    planning: '\u89C4\u5212',
    coding: '开发',
    // P-COND-056A6CA445F9 (3tier) — 规划/开发 切换按钮的悬停提示（取代两处硬编码英文）
    planning_title: '当前：规划模式（项目只可写规划/文档/测试目录；电脑上的操作不受限；/force 在此模式下无效）· 点击切换到开发模式',
    coding_title: '当前：开发模式 · 点击切换到规划模式',
    system_default: '\u9ED8\u8BA4\u6A21\u578B',
    model_locked: '模型已由管理员锁定为默认值',
    // Provider 胶囊为红点（health_state = 'invalid'）时的 title
    // （P-COND-33ACB5C7F124 ST-3；P-COND-1F526B8A2BA5 ST3 收窄语义）。
    // 原先这一条同时服务「失效」和「限流」两种信号，只能说「暂时不可用」
    // 这种两边都不得罪的话。现在后端能区分了，这一条专指不会自愈的失效，
    // 可以直说需要重新登录；限流走下面的 provider_cooling。胶囊仍可点。
    provider_unavailable: '{name} 凭据已失效（该 Provider 的账号全部需要重新登录或更换密钥），请切换到其他 Provider',
    // 与 provider_unavailable 是两种完全不同的处置：限流带 TTL，会自己恢复，
    // 用户什么都不做也行，发送按钮不禁用。此前两者共用「已失效」文案，把一个
    // 半小时后自愈的限流说成需要重新登录，等于白白把用户赶去重新授权。
    provider_cooling: '{name} 限流冷却中（该 Provider 的账号均已达速率上限），稍后会自动恢复，也可切换到其他 Provider',
    // 组合器警告条旁边的逃生阀：健康图是 mount 时快照，刚充值的用户必须能
    // 不刷新页面就重新体检。禁用发送按钮之所以安全，全靠这个按钮。
    provider_health_refresh: '刷新',
    placeholder: '\u8F93\u5165\u6D88\u606F... (Shift+Enter \u6362\u884C)',
    collab_placeholder: '描述你的协作任务，例如：起草一份市场分析报告… (Shift+Enter 换行)',

    file_too_large: '{name} \u8D85\u51FA {max} \u5927\u5C0F\u9650\u5236',
    max_files_exceeded: '最多允许 {max} 个文件，请先删除部分文件',
    file_type_archive: '{name}：压缩文件暂不支持，请解压后上传其中的文件',
    file_type_unsupported: '{name}：不支持该文件类型',
    video_too_long: '{name} 时长超过 {minutes} 分钟，请剪短后再上传',
    video_badge: '▶ 视频',
    video_privacy_hint: '视频会被 AI 看到，请勿录入密码等敏感信息。上限 {size} / {minutes} 分钟。',
    uploading_percent: '上传中 {percent}%',
    upload_cancel: '取消上传',
    total_size_exceeded: '文件总大小超过 {max}，请先删除部分文件',
    effort: {
      label: '推理投入',
      low: '低',
      medium: '中',
      high: '高',
      extra: '增强',
      max: '最强',
      default_badge: '默认',
      default_hint: '默认 高',
    },
    length: {
      label: '长度',
      standard: '标准',
      long: '长',
      max: '最长',
      default_badge: '默认',
      default_hint: '默认 标准',
    },
    thinking: {
      label: '思考',
      on: '开',
      off: '关',
      desc: '启用扩展推理',
      tooltip: '思考 \u2014 面对更复杂的任务时可进行更深入的推理',
    },
    tooltip: {
      supervisor: '\u5728\u6D88\u606F\u524D\u52A0\u4E0A /supervisor\uFF08\u4F7F\u7528\u76D1\u7763\u4EE3\u7406\uFF09',
      orchestrator: '\u5728\u6D88\u606F\u524D\u52A0\u4E0A /orchestrator\uFF08\u591A\u7EC4\u4EF6\u6784\u5EFA \u2014 \u9700\u8981\u8BA1\u5212\uFF09',
      long: '\u5728\u6D88\u606F\u524D\u52A0\u4E0A /long\uFF08\u6807\u8BB0\u4E3A\u957F\u65F6\u95F4\u8FD0\u884C\uFF09',
      force: '\u5728\u6D88\u606F\u524D\u52A0\u4E0A /force\uFF08\u8DF3\u8FC7\u6D3E\u5355\u5BA1\u6279\uFF09',
      model: '\u4E3A\u672C\u6761\u6D88\u606F\u9009\u62E9\u6A21\u578B\u3002\u201C\u7CFB\u7EDF\u9ED8\u8BA4\u201D\u9075\u5FAA\u9879\u76EE\u8BBE\u7F6E\u548C\u5168\u5C40\u9ED8\u8BA4\u503C\u3002',
      options: '\u9009\u9879',
    },
  },

  // ── Message ─────────────────────────────────────────────────────
  message: {
    role: {
      you: '\u4F60',
      conductor: 'Conductor',
      system: '\u7CFB\u7EDF',
    },
    source: {
      wecom: '\u4F01\u4E1A\u5FAE\u4FE1',
      web: '\u7F51\u9875',
    },
    assistant_typing: '\u52A9\u624B\u6B63\u5728\u8F93\u5165',
    responding_to: '\u56DE\u590D {name}',
    failed_load_image: '\u56FE\u7247\u52A0\u8F7D\u5931\u8D25',
    loading_image: '\u52A0\u8F7D\u56FE\u7247\u4E2D...',
    start_implementation: '\u5F00\u59CB\u5B9E\u65BD',
    starting: '\u542F\u52A8\u4E2D...',
    retry: '\u91CD\u8BD5',
    download_failed: '\u4E0B\u8F7D\u5931\u8D25',
    send_failed: '\u53D1\u9001\u5931\u8D25',
    resend: '\u70B9\u51FB\u91CD\u53D1',
    resending: '\u53D1\u9001\u4E2D\u2026',
    resend_capped: '\u5DF2\u91CD\u8BD5\u591A\u6B21\u4ECD\u5931\u8D25\uFF0C\u5DF2\u505C\u6B62\u91CD\u53D1\u3002\u8BF7\u6362\u4E00\u79CD\u95EE\u6CD5\u6216\u91CD\u7F6E\u4F1A\u8BDD\u540E\u518D\u8BD5\u3002',
    more_actions: '\u66F4\u591A\u64CD\u4F5C',
    menu_doc: '\uD83D\uDCC4 \u751F\u6210\u6587\u4EF6 doc',
    menu_feedback: '\uD83D\uDC1E \u53CD\u9988\u95EE\u9898',
    menu_multi_review: '🔍 多模型复核',
    menu_quote: '引用这条',
    menu_branch: '从这里分支新会话',
    menu_branch_scope: '同一项目 · 同一分支（{branch}）',
    menu_branch_scope_no_branch: '同一项目 · 同一分支',
    branch_failed: '创建失败：{detail}',
    branch_error_forbidden: '无权访问源会话',
    branch_error_invalid: '分支请求无效',
    branch_error_unknown: '请稍后重试',
    branch_seed_label: '分支背景 · 来自会话 #{id}',
    branch_seed_expand: '展开',
    branch_seed_collapse: '收起',
  },

  // ── 多模型复核（第三方模型独立审核 proposal） ─────
  multiReview: {
    title: '多模型复核',
    subtitle: '选择 1–{max} 个模型，只读检查代码并独立给出意见；不会修改文件，也不会替你批准。',
    loading: '正在加载可用模型…',
    no_targets: '深度复核未启用或无可用模型，请联系管理员',
    // P-COND-368144D76579 — ReviewTargetsResponse.unavailable_reason
    unavailable_disabled: '当前环境尚未启用深度复核。需要管理员开启后才能选择模型；方案仍可正常审批。',
    unavailable_no_project: '当前会话未关联项目，无法选择复核模型。',
    unavailable_no_authorized_model: '本项目授权范围内没有可用的复核模型，请联系管理员检查模型授权。',
    unavailable_error: '模型列表加载失败，尚不能判断是否可用。请稍后重试。',
    no_credentials: '所有模型都缺少可用凭证，请先在管理端配置。',
    unavailable: '不可用',
    selected_count: '已选 {n} / {max}',
    remaining_today: '今日剩余 {n} 次',
    cap_reached: '最多可选 {max} 个模型',
    readonly_note: '复核不会修改任何文件。',
    billing_note: '按实际用量计费',
    cost_cap: '，单个模型上限约 ${x}',
    footer_end: '。',
    cancel: '取消',
    start: '开始复核',
    running: '复核中…',
    load_failed: '加载模型列表失败',
    run_failed: '复核失败',
    // 复核中（可关窗）
    bg_title: '复核已在后台运行',
    bg_body: '可以关闭本窗口继续其它工作，结果会直接出现在会话中。',
    in_progress: '进行中…',
    close_window: '关闭窗口',
    // 逐模型失败
    failed_title: '{n} 个模型复核未完成',
    failed_tag: '失败',
    retry: '重试',
    close: '关闭',
    reason_no_credential: '缺少可用凭证',
    reason_empty_content: '模型返回内容为空',
    reason_unknown: '未知原因',
    // 传输层错误分类
    err_timeout: '复核用时超过等待上限，请求已中断；后台可能仍在运行，结果会稍后作为系统消息出现在会话中。',
    err_credential: '凭证无效或权限不足，请检查管理端的模型凭证配置。',
    err_quota: '今日复核次数或组织额度已用完，请稍后再试。',
    all_failed_note: '本次复核已结束，结果已记录到对话中。',
    // 后台深度复核（只读子任务，ST10）
    agent_pending_title: '深度复核已在后台运行',
    agent_pending_body: '复核以只读方式运行，可能需要数分钟；全部完成或超时后结果会以卡片形式出现在会话中。可以关闭此窗口。',
    cancel_agent: '停止复核',
    pending_bar: '多模型复核进行中',
    pending_bar_count: '多模型复核进行中 · {count} 个模型',
    pending_cancel: '停止复核',
    cancel_done: '已请求停止，等待确认。',
    cancel_failed: '未能提交停止请求',
    // 复核进行中实时状态（P-COND-6B1B3E09FD79 ST2）
    elapsed_sec: '已 {s} 秒',
    elapsed_min: '已 {m} 分 {s} 秒',
    elapsed_hour: '已 {h} 小时 {m} 分',
    live_queued: '排队中',
    live_running: '运行中',
    live_completed: '已完成',
    live_failed: '失败',
    live_stop_pending: '停止待确认',
    live_stopped: '已停止',
    live_last_running: '最近状态：运行中',
    live_view_process: '查看过程 →',
    // 复核操作区 + 顶部简短条（P-COND-158AE9229655，设计 mmreview-stop-panel-v2）
    strip_title: '复核中 · {done} / {total} 个模型已完成',
    strip_stop_pending: '停止待确认 · {n} 个模型',
    strip_stop_failed: '停止请求失败 · 可重试',
    strip_stopped: '复核已结束 · {done} 完成 / {stopped} 停止',
    strip_completed: '复核已完成 · {done} / {total}',
    strip_unavailable: '复核中 · 状态暂不可用',
    strip_view: '查看复核 ↓',
    strip_awaiting_proposal: '审查已结束 · 等待方案提交',
    strip_awaiting_approval: '方案等待审批中',
    auto_strip_running: '独立审查中',
    auto_strip_stopped: '独立审查已停止 · 方案将直接提交',
    panel_awaiting_proposal: '审查已结束，等待方案提交',
    panel_awaiting_approval: '方案等待审批中（审查结论见方案的「独立审查」一栏）',
    auto_panel_running: '独立审查中',
    auto_panel_stopped: '已停止，方案将直接提交',
    note_awaiting_proposal: '方案提交后会出现在对话里。',
    note_awaiting_approval: '审批结束后这里会自动收起。',
    auto_note_running: '另一个模型正在核对方案；停止后方案将直接提交，不再等待审查。',
    auto_note_stopped: '独立审查已停止，本版方案未经复核，请人工判断。',
    panel_running: '多模型复核进行中',
    panel_stop_pending: '已请求停止，等待确认',
    panel_stop_failed: '未能提交停止请求',
    panel_stopped: '本次复核已结束',
    panel_completed: '复核已完成',
    panel_unavailable: '状态暂不可用',
    panel_note: '停止仅影响本次复核，已完成的结果会保留。',
    note_stop_pending: '尚未确认全部停止；已完成的结果会保留，仍可查看执行过程。',
    note_stop_failed: '尚未确认停止。请重试，或打开执行过程查看当前情况。',
    note_stopped: '已确认停止未完成的模型；已完成的模型结果保留在对话里。',
    note_completed: '结果已显示在对话里。',
    note_unavailable: '暂时无法获取最新状态，以下是最近一次已知状态。仍可停止复核。',
    stop: '停止复核',
    stop_waiting: '等待确认',
    stop_retry: '重试停止',
    details_summary: '模型进度与执行过程',
    // 复核结果卡片（ST3）
    result_title: '多模型复核结果',
    result_view_process: '查看调查过程 ›',
    result_expand: '展开全文',
    result_collapse: '收起',
    status_approved: '通过',
    status_issues: '需修改',
    status_unknown: '无法判定',
    status_timeout: '超时',
    status_cancelled: '已停止',
    status_cancel_unconfirmed: '尚未确认停止',
    status_failed: '未完成',
    // 复核结果卡片 v2 摘要行 + 子会话返回（P-COND-DEF54F26332F ST3）
    summary_models: '{n} 个模型',
    summary_issues: '{n} 个模型认为需修改',
    finding_direction: '方向 {n}',
    finding_blocker: '阻断 {n}',
    finding_suggest: '建议 {n}',
    summary_approved: '{n} 通过',
    summary_incomplete: '{n} 未完成',
    summary_unknown: '{n} 无法判定',
    role_label: '多模型复核',
    back_to_parent: '← 返回原会话',
    back_to_parent_titled: '← 返回原会话 · {title}',
  },

  // ── Feedback (\u4F1A\u8BDD\u5185\u53CD\u9988\u95EE\u9898 \u2192 \u89C2\u6D4B\u4E2D\u5FC3) ─────
  feedback: {
    title: '\u53CD\u9988\u95EE\u9898',
    kv_project: '\u9879\u76EE',
    kv_conversation: '\u4F1A\u8BDD',
    kv_user: '\u7528\u6237',
    placeholder: '\u63CF\u8FF0\u4F60\u9047\u5230\u7684\u95EE\u9898\uFF08\u53EF\u7559\u767D\uFF09',
    hint: '\u63D0\u4EA4\u540E\u5C06\u81EA\u52A8\u9644\u5E26\u672C\u4F1A\u8BDD\u6700\u540E 2 \u8F6E\u5BF9\u8BDD\uFF0C\u4F9B\u8FD0\u7EF4/\u89C2\u6D4B\u4E2D\u5FC3\u6392\u67E5\u3002',
    cancel: '\u53D6\u6D88',
    submit: '\u63D0\u4EA4',
    submitting: '\u63D0\u4EA4\u4E2D\u2026',
    submitted: '\u5DF2\u63D0\u4EA4',
    submit_error: '\u63D0\u4EA4\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5\u3002',
  },

  // ── Message List ────────────────────────────────────────────────
  message_list: {
    load_more: '\u52A0\u8F7D\u66F4\u591A\u6D88\u606F',
    loading: '\u52A0\u8F7D\u4E2D',
    empty: '\u8FD8\u6CA1\u6709\u6D88\u606F\u3002\u5F00\u59CB\u5BF9\u8BDD\u5427\uFF01',
    assistant_typing: '\u52A9\u624B\u6B63\u5728\u8F93\u5165',
    release: '\u91CA\u653E',
    pull_to_refresh: '\u4E0B\u62C9\u5237\u65B0',
  },

  // ── Streaming Progress ──────────────────────────────────────────
  progress: {
    starting: '\u542F\u52A8\u4E2D',
    connection_lost: '\u8FDE\u63A5\u5DF2\u65AD\u5F00 \u2014 \u7B49\u5F85\u91CD\u65B0\u8FDE\u63A5',
    last_prefix: '\u6700\u540E\uFF1A',
    completed: '\u5728 {seconds} \u79D2\u5185\u5B8C\u6210 | {summary}',
    elapsed: '\u5DF2\u8FC7 {seconds} \u79D2',
    processing: '\u5904\u7406\u4E2D',
    // 停止后保留的已完成记录横幅（ChatContainer::TaskStoppedBanner）。
    stopped_at: '\u4EFB\u52A1\u4E8E {time} \u88AB\u505C\u6B62',
    stopped_expand: '\u70B9\u51FB\u5C55\u5F00\u5DF2\u5B8C\u6210\u8BB0\u5F55',
    stopped_collapse: '\u70B9\u51FB\u6536\u8D77\u5DF2\u5B8C\u6210\u8BB0\u5F55',
    stopped_tools: '\u5DF2\u8C03\u7528\u7684\u5DE5\u5177',
    stopped_text: '\u5DF2\u4EA7\u51FA\u7684\u5185\u5BB9',
  },

  // ── 运行中补充信息状态区（ChatContainer::SupplementTray）────────────
  supplement: {
    rejected_note: '执行端未接受这条补充，正文已保留，可复制。',
    status_unknown_codex: '送达状态待确认',
    status_unknown: '未确认受理',
    unknown_note: '送达状态待确认，请勿自动重发。旧执行退出后才可处理。',
    end: '结束本次',
    continue: '确认风险后继续',
    continue_note: '决定已记录，请发送新消息继续；不会重放送达未知的补充。',
    text_only: '运行中补充仅支持文字，附件请保留到下一条消息。',
    title: '\u672C\u6B21\u4EFB\u52A1\u7684\u8865\u5145\u4FE1\u606F ({count})',
    status_pending: '\u5F85\u53D7\u7406',
    status_accepted: '\u5DF2\u53D7\u7406 {time}',
    status_undelivered: '\u672A\u9001\u8FBE',
    pending_note: '正在等待执行端回执；本条确认后可继续发送补充。',
    undelivered_note: '\u4EFB\u52A1\u5DF2\u7ED3\u675F\uFF0C\u8FD9\u6761\u6CA1\u80FD\u8D76\u4E0A\uFF08\u5185\u5BB9\u4FDD\u7559\u53EF\u590D\u5236\u91CD\u53D1\uFF09',
  },

  // ── Export Modal ────────────────────────────────────────────────
  export_modal: {
    title_conversation: '\u5BFC\u51FA\u4F1A\u8BDD',
    title_proposal: '\u5BFC\u51FA\u63D0\u6848',
    include_roles: '\u5305\u542B\u89D2\u8272',
    role_user: '\u7528\u6237',
    role_assistant: '\u52A9\u624B',
    role_system: '\u7CFB\u7EDF',
    last_n_messages: '\u6700\u8FD1 N \u6761\u6D88\u606F',
    all_messages: '\u6240\u6709\u6D88\u606F',
    more_options: '\u66F4\u591A\u9009\u9879',
    format: '\u683C\u5F0F',
    format_md: 'Markdown (.md)',
    format_html: 'HTML (.html)',
    format_pdf: 'PDF (.pdf)',
    format_docx: 'Word (.docx)',
    downloading: '\u4E0B\u8F7D\u4E2D...',
    download: '\u4E0B\u8F7D',
    export_failed: '\u5BFC\u51FA\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5\u3002',
    close: '\u5173\u95ED',
  },

  // ── Conversation Files Panel (P-COND-490FE79403B8 ST2) ──────────
  files_panel: {
    video_unplayable: '浏览器无法播放该视频，可下载后查看。',
    title: '本会话文件',
    close: '关闭',
    back: '返回',
    group_agent: 'Agent 生成',
    group_uploaded: '我上传的',
    group_design: '设计稿',
    group_planning: '规划文档',
    group_documents: '项目文档',
    empty: '本会话暂无文件',
    loading: '加载中…',
    load_error: '加载文件失败',
    download: '下载',
    open: '打开',
    close_preview: '关闭预览',
    preview_error: '预览加载失败',
    preview_unsupported: '此类型暂不支持预览，可下载查看',
    preview_too_large: '文件较大，请下载查看',
    group_project_all: '项目文件',
    project_all_hint: '不限本会话 · 默认折叠',
    group_my_dept: '本部门',
    group_company_shared: '全公司共享',
    no_dept_hint: '你尚未加入部门，只显示全公司共享',
    other_depts_hidden: '其他部门的文件夹不在这里显示',
    remote_unreachable: '远端主机不可达，无法列出项目文件',
    folder_empty: '此文件夹为空或不存在',
    view_rendered: '渲染',
    view_source: '源码',
    view_table: '表格',
    view_layout: '版式',
    sheet_tabs: '工作表',
    sheet_empty: '此工作表为空',
    sheet_truncated: '仅显示前 {rows} 行 / 共 {total} 行，完整内容请下载',
    sheet_truncated_cols: '仅显示前 {cols} 列 / 共 {total} 列，完整内容请下载',
    maximize: '最大化',
    restore: '还原',
    open_new_window: '新窗口打开',
    back_to_list: '返回列表',
    link_back: '返回',
    link_outside_scope: '不在面板可浏览范围内（仅 docs/、planning/ 等项目文档目录）',
    link_not_found: '链接指向的文件不存在或已移动',
    sort_by: '排序',
    sort_modified: '修改日期',
    sort_name: '名称',
    sort_group: '排序方式',
    view_by: '展示方式',
    view_name: '文件名',
    view_thumb: '文件名 + 缩略图',
    view_menu: '显示',
    load_more: '加载更多（还有 {n} 个）',
    converting: '正在转换为 PDF 预览…',
    annotate: '标注并带入输入框',
    annotate_title: '标注图片',
    annotate_pen: '自由线',
    annotate_rect: '矩形',
    annotate_ellipse: '椭圆',
    annotate_arrow: '箭头',
    annotate_text: '文字',
    annotate_text_placeholder: '输入文字，回车确认',
    annotate_color: '颜色',
    annotate_undo: '撤销',
    annotate_clear: '清空',
    annotate_note_placeholder: '补充说明（可选）',
    annotate_cancel: '取消',
    annotate_done: '带入输入框',
    annotate_load_error: '图片加载失败，无法标注',
    quote_lines: '引用第 {start}–{end} 行',
    quote_truncated: '…(已截断，共 {n} 行)',
    annotate_page: '标注此页',
    annotate_current_page: '标注当前页（第 {n} / {total} 页）',
    page_label: '第{n}页',
    pdf_loading: '正在加载 PDF…',
    preview_office_too_large: '文件超过 20MB，无法在线预览，请下载后查看',
    preview_office_timeout: '文件较大，转换超时，请稍后重试或下载后查看',
    preview_office_failed: '文件可能已损坏或加密，无法预览，请下载后查看',
    annotate_short: '标注 {n}/{total}',
    annotate_visible: '标注可见区域',
    snapshot_busy: '正在截图…',
    snapshot_failed: '截图失败，请重试',
    quote_selection: '引用所选文字',
    screen_label: '第{n}屏',
  },

  // ── New Conversation Dialog ─────────────────────────────────────
  new_conv: {
    title: '\u65B0\u5EFA\u4F1A\u8BDD',
    project: '\u9879\u76EE',
    base_branch: '\u57FA\u7840\u5206\u652F',
    loading_branches: '\u52A0\u8F7D\u5206\u652F\u4E2D...',
    branch_hint: '新功能请基于 feat 分支开发；master 仅用于运维/热修复。',
    branch_hint_local: '选择要开发的分支，将直接在该分支上提交（worktree 路由）。新功能建议使用 feat 分支。',
    // P-COND-CA40B4848921 ST3 — per git-mode base-branch label + hint.
    base_branch_with_mode: '基础分支（{mode}）',
    branch_mode_self_integration: '自管 · 集成线',
    branch_mode_self_feature: '自管 · 功能分支',
    branch_mode_self_release: '自管 · 发布线',
    branch_mode_cloud: '云仓项目',
    branch_hint_self_integration: '所有会话直接提交到这条共用开发线。/push 合回 {branch}；/merge 把 {branch} 发布到 master。',
    branch_hint_self_feature: '提交到这条功能分支。/push 合回该分支；/merge 合进集成线 {integration}。',
    branch_hint_self_feature_direct: '提交到这条功能分支。/push 合回该分支；/merge 合进发布线 master。',
    branch_hint_self_release: '直接提交到发布线，/push 后即为最终状态，无需 /merge。',
    branch_hint_cloud: '将为本会话新建独立分支；/push 后请在 Codeup 发起 MR。',
    branch_search_placeholder: '搜索分支...',
    selected: '已选',
    dev_submode: '模式',
    dev_submode_branch: '分支开发',
    dev_submode_operation: '统筹(operation)',
    dev_submode_branch_hint: '在所选分支上进行常规功能开发。',
    dev_submode_operation_hint: '统筹型 agent：梳理零散分支、清理、合并内容——不做新功能开发。',
    collab_submode: '协作场景',
    collab_submode_general: '通用',
    collab_submode_planning: '策划',
    collab_submode_design: '设计',
    collab_submode_production: '文档',
    collab_submode_general_hint: '通用场景：文本编辑、合同审核、通知公文、流程管理等，全部技能均可按需使用。',
    collab_submode_planning_hint: '内容创作与调研：市场调研、新媒体情报、创意文案。',
    collab_submode_design_hint: '视觉设计与品牌：插画、版式、VI 规范、图片生成。',
    collab_submode_production_hint: '文档/文件批量生成：PPT、Word 报告、Excel 数据表格。',
    // Fork lineage (方案3 clone reuse) — source selector labels
    source_label: '基于',
    source_branch: '基础分支（克隆）',
    source_conversation: '现有会话（待提交）',
    // Forkable conversation dropdown (Req 3)
    fork_conv_placeholder: '选择来源会话',
    fork_conv_empty: '无可复用的会话',
    fork_conv_loading: '加载会话中...',
    fork_status_pending: '待提交',
    fork_status_committed: '已提交',
    fork_status_clean: '未修改',
    fork_readonly_warning: '新会话将承继旧会话未提交的代码修改，旧会话将变为只读，不能提交代码',
    // Create new branch (Req 5/6)
    create_branch: '\uFF0B \u521B\u5EFA\u65B0\u5206\u652F',
    create_branch_title: '\u521B\u5EFA\u65B0\u5206\u652F',
    create_branch_base: '\u57FA\u4E8E\u5206\u652F',
    create_branch_name: '\u65B0\u5206\u652F\u540D\u79F0',
    create_branch_name_placeholder: '\u4F8B\u5982\uFF1Afeat_login_redesign',
    create_branch_name_hint: '\u5206\u652F\u540D\u9700\u5305\u542B\u201Cfeat\u201D\u3002\u4F8B\u5982\uFF1Afeat_login_redesign',
    create_branch_submit: '\u521B\u5EFA',
    create_branch_creating: '\u521B\u5EFA\u4E2D...',
    create_branch_error: '\u521B\u5EFA\u5206\u652F\u5931\u8D25',
    group_chat: '\u7FA4\u804A',
    group_hint: '\u591A\u7528\u6237\u4F1A\u8BDD\u3002\u6210\u5458\u53EF\u4EE5\u5355\u72EC\u5207\u6362\u4EE3\u7406\u6A21\u5F0F\u3002',
    add_members: '\u6DFB\u52A0\u6210\u5458',
    members_later: '\u521B\u5EFA\u540E\u53EF\u6DFB\u52A0\u6210\u5458\u3002',
    loading_users: '\u52A0\u8F7D\u7528\u6237\u4E2D...',
    sync_wecom: '\u540C\u6B65\u5230\u4F01\u4E1A\u5FAE\u4FE1',
    wecom_sync_hint: '\u6D88\u606F\u5C06\u5728\u7F51\u9875\u548C\u4F01\u4E1A\u5FAE\u4FE1\u4E4B\u95F4\u540C\u6B65\u3002\u6BCF\u4E2A\u9879\u76EE\u53EA\u80FD\u6709\u4E00\u4E2A\u4F01\u4E1A\u5FAE\u4FE1\u4F1A\u8BDD\u3002',
    web_only_hint: '\u4EC5\u7F51\u9875\u4F1A\u8BDD\uFF08\u4E0D\u540C\u6B65\u4F01\u4E1A\u5FAE\u4FE1\uFF09\u3002',
    create: '\u521B\u5EFA',
    // SP-U2 workspace mode selector (shown only for mode-enabled projects)
    workspace_mode: '\u5DE5\u4F5C\u533A\u6A21\u5F0F',
    mode_unset: '\u65E0\uFF08\u4E0D\u7ED1\u5B9A\uFF09',
    mode_dev: '\u5F00\u53D1\uFF08dev \u5DE5\u4F5C\u533A\uFF09',
    mode_collab: '\u534F\u4F5C\uFF08collab \u5DE5\u4F5C\u533A\uFF09',
    mode_hint: '\u5C06\u672C\u4F1A\u8BDD\u7ED1\u5B9A\u5230\u5DE5\u4F5C\u533A\u6A21\u5F0F\u3002\u7559\u7A7A\u5219\u4E0D\u7ED1\u5B9A\u6A21\u5F0F\u3002',
    default_provider: '\u9ED8\u8BA4\uFF08\u9879\u76EE\u8BBE\u7F6E\uFF09',
    no_token: '\uFF08\u672A\u914D\u7F6E Token\uFF09',
  },

  // ── Continuation Dialog ─────────────────────────────────────────
  continuation: {
    title: '\u7EE7\u7EED\u4F1A\u8BDD\uFF1F',
    start_fresh: '\u91CD\u65B0\u5F00\u59CB',
    continue: '\u7EE7\u7EED',
  },

  // ── Code Block ──────────────────────────────────────────────────
  code_block: {
    copy_title: '\u590D\u5236\u5230\u526A\u8D34\u677F',
  },

  // ── Continuation Dialog ─────────────────────────────────────────
  continuation_dialog: {
    title: '\u7EE7\u7EED\u5BF9\u8BDD\uFF1F',
    start_fresh: '\u5F00\u542F\u65B0\u5BF9\u8BDD',
    continue: '\u7EE7\u7EED',
    close: '\u5173\u95ED',
    aria_label: '\u7EE7\u7EED\u63D0\u793A',
  },

  // ── Project Selector ────────────────────────────────────────────
  project_selector: {
    all_projects: '\u6240\u6709\u9879\u76EE',
    select_project: '\u9009\u62E9\u9879\u76EE',
  },

  // ── Approval Page ───────────────────────────────────────────────
  approval: {
    header: '\u6A21\u677F\u5BA1\u6279',
    nav_admin: '\u7BA1\u7406',
    nav_chat: '\u804A\u5929',
    tabs: {
      pending: '\u5F85\u5904\u7406',
      approved: '\u5DF2\u6279\u51C6',
      rejected: '\u5DF2\u62D2\u7EDD',
      all: '\u5168\u90E8',
    },
    stats: {
      approved_today: '\u4ECA\u65E5\u6279\u51C6',
      rejected_today: '\u4ECA\u65E5\u62D2\u7EDD',
      total: '\u603B\u8BA1',
    },
    empty: '\u6CA1\u6709\u5339\u914D\u6B64\u7B5B\u9009\u6761\u4EF6\u7684\u63D0\u6848\u3002',
    table: {
      title: '\u6807\u9898',
      type: '\u7C7B\u578B',
      action: '\u64CD\u4F5C',
      source: '\u6765\u6E90',
      status: '\u72B6\u6001',
      date: '\u65E5\u671F',
    },
    sections: {
      summary: '\u6458\u8981',
      target_file: '\u76EE\u6807\u6587\u4EF6',
      agent_reasoning: '\u4EE3\u7406\u63A8\u7406',
      challenge_review: '\u8D28\u7591\u5BA1\u67E5',
      changes: '\u53D8\u66F4',
      proposed_content: '\u63D0\u8BAE\u5185\u5BB9',
      current_content: '\u5F53\u524D\u5185\u5BB9',
      admin_note: '\u7BA1\u7406\u5458\u5907\u6CE8',
    },
    admin_note_placeholder: '\u7BA1\u7406\u5458\u5907\u6CE8\uFF08\u53EF\u9009\uFF09',
    badges: {
      fast_track: '\u5FEB\u901F\u901A\u9053',
      large: '\u5927\u578B',
    },
    operation_failed: '\u64CD\u4F5C\u5931\u8D25',
  },

  // ── Org Shell Navigation ─────────────────────────────────────────
  orgNav: {
    section: {
      platform: '平台',
      current_org: '当前组织',
      settings: '设置',
      account: '账号',
    },
    nav: {
      all_orgs: '所有组织',
      platform_settings: '平台设置',
      overview: '概览',
      usage: '用量',
      subscription: '订阅管理',
      members: '成员',
      projects: '项目',
      audit: '审计日志',
      coming_soon: '即将推出',
      org_settings: '组织设置',
      profile: '个人资料',
      back_to_chat: '返回对话',
      my_devices: '我的设备',
      skill_center: "技能中心",
      desktop_grants: '桌面权限审批',
      org_skills: '技能',
      desktop_audit: '桌面审计日志',
    },
    role: {
      platform_admin: '平台管理员',
      owner: '所有者',
      admin: '管理员',
      member: '成员',
    },
    aria: {
      open_menu: '打开菜单',
      close_menu: '关闭菜单',
      user_menu: '用户菜单',
      main_nav: '主导航',
      current_org: '当前组织',
      select_org: '选择组织',
    },
    logged_out: '未登录',
  },

  // ── Admin Shell Navigation ───────────────────────────────────────
  adminNav: {
    org_management: '组织管理',
    pricing: '套餐价格配置',
  },

  // ── Subscription Pricing config (P-COND-LRT ST3) ────────────────────
  pricing: {
    crumb: '配置 / 套餐价格',
    title: '套餐价格配置',
    sub: '按订阅档位 × 周期编辑订阅价格（normalized-USD，整周期价；留空 = 不可购买）。保存后立即生效，无需重启。',
    loading: '加载中…',
    error_load: '加载套餐价格失败',
    error_save: '保存失败',
    saved: '已保存',
    save: '保存',
    saving: '保存中…',
    reset: '重置',
    tier_col: '档位',
    not_purchasable: '不可购买',
    invalid_positive: '价格必须为正数或留空',
    period: {
      monthly: '月付',
      quarterly: '季付',
      semiannual: '半年付',
      annual: '年付',
    },
  },

  // ── Plan-tier quota config (P-COND-LRT) ─────────────────────────────
  planQuota: {
    crumb: '配置 / 套餐额度',
    title: '套餐额度配置',
    sub: '配置各套餐每月的内部用量上限（enforcement）。',
    info: '此为内部用量上限（归一化 USD 成本基准），用于用量闸门与超额控制，不直接展示给终端用户；用户侧仅呈现套餐定性差异与人民币价格。留空（null）= 不限量。',
    loading: '加载中…',
    error_load: '加载套餐额度失败',
    error_save: '保存失败',
    saved: '已保存',
    save: '保存配置',
    saving: '保存中…',
    reset: '重置',
    tier_col: '套餐挡位',
    limit_col: '月度用量上限',
    note_col: '说明',
    unit: 'norm-USD',
    null_unlimited: 'null · 不限量',
    unlimited_placeholder: '不限量',
    invalid_positive: '上限必须为正数或留空',
    reload_note: '保存后即时生效（配置热重载，无需重启）。变更写入审计日志。',
    tier: {
      internal: 'internal 内部',
      trial: 'trial 试用',
      standard: 'standard 标准',
      enterprise: 'enterprise 企业',
    },
    desc: {
      internal: '内部账号，永不计费',
      trial: '注册试用默认额度',
      standard: '中小团队',
      enterprise: '大团队',
    },
  },

  // ── Model pricing standards (P-COND-LRT) ────────────────────────────
  modelPricing: {
    crumb: '配置 / 模型定价',
    title: '模型定价标准',
    sub: '配置各 Provider 各模型的 token 单价（USD / 1M tokens）及成本归一化系数。',
    loading: '加载中…',
    error_load: '加载模型定价失败',
    error_save: '保存失败',
    saved: '已保存',
    save: '保存全部定价',
    saving: '保存中…',
    reset: '重置',
    coefficients_title: '成本归一化系数（coefficients）',
    param_col: '参数',
    value_col: '数值',
    model_col: '模型',
    invalid_nonneg: '所有数值必须为非负数',
    reload_note: '保存后热重载生效（lru_cache 以 mtime 失效），无需改代码或重启。变更写审计日志。',
    field: {
      input: 'input',
      output: 'output',
      cache_write: 'cache_write',
      cache_read: 'cache_read',
    },
  },

  // ── Org Subscription management (P-COND-LRT) ────────────────────────
  orgSub: {
    title: '订阅管理',
    lead: '查看当前套餐、续费延期与订单历史。当前为沙箱测试支付环境。',
    loading: '加载中…',
    error_load: '加载订阅信息失败',
    retry: '重试',
    current_plan: '当前套餐',
    active_badge: '生效中',
    k_tier: '套餐挡位',
    k_period: '订阅期限',
    k_price: '当前套餐价格',
    k_expiry: '到期日期',
    list_price_note: '显示为套餐标准价；升级中途的按比例差价以结算页为准。',
    compare_renew: '套餐对比与续费',
    sandbox_badge: '沙箱支付',
    sandbox_note: '⚠ 当前为沙箱/测试支付，不会产生真实扣款。真实支付网关接入后此提示将移除。',
    order_history: '订单历史',
    no_orders: '暂无订单。',
    pay_success: '支付成功 — 订阅已更新。',
    pay_failed: '支付未完成。',
    pay_error: '支付请求失败，请重试。',
    cmp: {
      feature: '对比项',
      standard: 'Standard 标准版',
      enterprise: 'Enterprise 企业版',
      projects: '可管理项目数',
      projects_std: '最多 5 个',
      projects_ent: '不限',
      seats: '组织成员席位',
      seats_std: '10 人',
      seats_ent: '不限',
      concurrency: '并发派单',
      concurrency_std: '标准',
      concurrency_ent: '高并发优先队列',
      token_quota: 'token 额度',
      token_quota_std: '标准月度额度',
      token_quota_ent: '企业版 token 额度 = 4X 标准版',
      support: '技术支持',
      support_std: '工单支持',
      support_ent: '专属对接 + 优先响应',
      price: '订阅价格',
    },
    form: {
      tier: '套餐挡位',
      period: '订阅期限',
      pay: '前往支付',
      paying: '处理中…',
      order_amount: '应付金额',
    },
    tier: {
      internal: '内部版',
      trial: '试用版',
      standard: 'Standard 标准版',
      enterprise: 'Enterprise 企业版',
    },
    period: {
      monthly: '月度',
      quarterly: '季度',
      semiannual: '半年',
      annual: '年度',
    },
    status: {
      paid: '已支付',
      pending: '待支付',
      failed: '支付失败',
      cancelled: '已取消',
    },
    order: {
      id: '订单号',
      tier: '套餐',
      amount: '金额',
      period: '期限',
      status: '状态',
      time: '时间',
    },
  },

  // ── Org Pages (batch A) ─────────────────────────────────────────────
  org: {
    overview: {
      crumb_org: '组织',
      crumb_overview: '概览',
      loading: '加载中…',
      title_fallback: '加载中…',
      desc: '组织级仪表板 — 关键指标与最近活动。',
      error_prefix: '加载失败：',
      retry: '重试',
      kpi: {
        members: '成员',
        projects: '项目',
        monthly_points: '本月点数（已用 / 配额）',
        monthly_ratio: '本月已用比例',
        monthly_cost: '本月费用',
      },
      project_tooltip: '仅显示你可访问的项目',
      points_unit: ' 点',
      points_unlimited: ' 点 · 无限',
      ratio_empty_title: '该组织未设置月度额度',
      ratio_empty: '无限 / 未设额度',
      quota_section: {
        title: '额度使用',
        sub: '配额按点数计 · 月度=套餐总额，日/周=节流护栏（未设上限时不展示）',
      },
      activity_section: {
        title: '最近活动',
        sub: '最近 7 天关键事件 · 完整日志见审计页',
      },
      audit_unavailable: '最近 7 天审计接口暂未开放',
      audit_unavailable_desc: '后端 audit-log GET 路由将在后续 Tier 接入。',
      no_activity: '最近 7 天无活动',
      tier_today: '今日',
      tier_week: '本周',
      tier_month: '本月',
    },
    usage: {
      crumb_usage: '用量',
      title: '用量统计 / Token Usage',
      desc: '按月统计的成员 Token 消耗与费用。',
      error_prefix: '加载失败：',
      retry: '重试',
      period_label: '月份',
      kpi: {
        monthly_points: '本月点数（已用 / 配额）',
        monthly_ratio: '本月已用比例',
        member_count: '成员数',
        monthly_cost: '本月总费用 (USD)',
      },
      points_unlimited: ' 点 · 无限',
      ratio_unlimited: '无限 / 未设额度',
      quota_section: {
        title: '额度使用',
        sub: '配额按点数计 · 月度=套餐总额，日/周=节流护栏（未设上限时不展示）',
      },
      detail_section: {
        title: '成员用量明细',
        sub_period: '周期 {period}',
        sub_default: '按用户聚合',
      },
      table: {
        user: '用户',
        model: '模型',
        input: '输入',
        output: '输出',
        cache_create: '缓存创建',
        cache_read: '缓存读取',
        cost_usd: '成本 (USD)',
        points: '点数',
      },
      model_label: '模型',
      model_filter_all: '全部模型',
      no_data: '本月暂无用量数据',
    },
    members: {
      crumb_members: '成员',
      title: '组织成员',
      desc: '管理组织内的成员与角色。所有者保护机制：至少 1 个所有者，移除前需先转移。',
      loading: '加载中…',
      error_prefix: '加载失败：',
      retry: '重试',
      search_placeholder: '搜索 用户名 / 邮箱 / 部门 / 职务…',
      search_aria: '搜索成员',
      role_filter_aria: '角色筛选',
      role_all: '全部角色',
      role_admin: '管理员',
      role_member: '成员',
      status_filter_aria: '状态筛选',
      status_all: '全部状态',
      status_joined: '已加入',
      status_pending: '待接受',
      add_member: '+ 添加成员',
      table: {
        account: '账号',
        role: '角色',
        department: '部门',
        title_col: '职务',
        manager: '直属上级',
        status: '状态',
        joined_at: '加入时间',
        actions_aria: '操作',
      },
      role_label: {
        owner: '所有者',
        admin: '管理员',
        member: '成员',
      },
      status_label: {
        joined: '已加入',
        pending: '待接受',
      },
      owner_remove_title: '所有者不可移除 — 请先转移所有权',
      resending: '重发中…',
      resend: '重发邀请',
      revoking: '撤销中…',
      revoke: '撤销',
      edit_role: '编辑角色',
      edit_info: '编辑信息',
      remove: '移除',
      more: '更多 ▾',
      less: '收起 ▴',
      empty: {
        unavailable: '成员列表暂不可用',
        unavailable_desc: '后端 GET /api/v1/orgs/{org_id}/members 路由将在后续 Tier 接入。',
        no_members: '尚无成员',
        no_members_desc: '可通过"+ 添加成员"邀请第一位组织成员。',
        no_match: '未找到匹配的成员',
        no_match_desc: '调整筛选条件后重试。',
      },
      error: {
        resend_not_available: '重发功能暂未上线',
        no_permission: '权限不足',
        resend_failed: '重发失败，请重试',
        revoke_not_found: '邀请已不存在',
        revoke_failed: '撤销失败，请重试',
        revoke_confirm: '确定撤销该邀请？此操作不可撤销。',
      },
      departments: {
        section_title: '部门管理',
        section_hint:
          '部门来源 = 已登记部门 ∪ 已被成员使用的部门。新增部门后，collab 项目会自动补建 domains/<部门>/ 目录。',
        add_btn: '+ 新增部门',
        empty: '尚无部门，点击"+ 新增部门"登记第一个部门。',
        loading: '加载部门中…',
        load_failed: '部门列表加载失败',
        modal_title: '新增部门',
        name_label: '部门名称',
        name_placeholder: '例: 财务部',
        name_hint: '非空，≤100 字符；不可与已有部门重复。',
        submit: '创建并选中',
        submitting: '创建中…',
        cancel: '取消',
        error_exists: '部门已存在',
        error_invalid: '部门名称必须非空且不超过 100 字符',
        error_generic: '创建失败，请重试',
        select_unrestricted: '（不限部门 / 全部部门）',
        select_add: '+ 新增部门…',
        select_hint:
          '必须从列表选择，不能手动输入。留空 = 不限部门（在默认权限下等同可访问全部部门目录）。',
        // P-COND-3F91C4A8D2E5 ST3 — 部门移除入口（chip 上的 ×）。
        remove_aria: '移除部门 {name}',
        remove_title: '移除该部门',
        rename_btn: '改名',
        rename_aria: '部门 {name} 改名',
        rename_title: '部门改名',
        rename_label: '新名称',
        rename_hint: '改名按部门 ID 进行，成员、邀请、项目授权里的旧名会一起更新。',
        rename_submit: '保存',
        rename_submitting: '保存中…',
        rename_same: '新名称与原名称相同',
        rename_exists: '已有同名部门',
        rename_forbidden: '只有组织管理员可以改名',
        rename_failed: '改名失败，请重试',
        rename_reverted: '改名失败：collab 文件侧出错，已恢复原名称。',
        rename_partial: '改名只完成了一部分，已记入审计，需要管理员人工修复。',
        rename_done: '已把「{old}」改名为「{name}」',
        // 确认文案必须写明真实影响面：成员保留、授权移除、目录文件保留。
        remove_confirm:
          '确定移除部门「{name}」？\n\n' +
          '· {members} 名成员将变为无部门（成员本身保留）\n' +
          '· {invitations} 个待兑换邀请将清除部门\n' +
          '· {projects} 个项目的该部门授权将被移除\n' +
          '· 目录与文件保留，不会被删除\n\n' +
          '成员的部门归属无法从界面恢复。',
        remove_impact_failed: '影响面预览失败，已取消移除：{error}',
        remove_failed: '移除部门失败，请重试',
        // P-COND-05EF0D660DAA ST3 — 部门可见性「暂停 / 恢复」列表。
        list_label: '部门列表',
        pause_hint:
          '暂停某个部门后，该部门成员将看不到也选不了本组织的协作项目。已生成的文件不会被删除；恢复后原有的授权路径原样回来。在项目里单独给个人开过权限的，以个人权限为准，不受部门暂停影响。',
        paused_badge: '已暂停',
        pause_btn: '暂停',
        resume_btn: '恢复',
        toggling: '处理中…',
        pause_aria: '暂停部门 {name}',
        resume_aria: '恢复部门 {name}',
        pause_failed: '暂停部门失败，请重试',
        resume_failed: '恢复部门失败，请重试',
        toggle_not_found: '该部门不存在，或你没有管理本组织的权限',
        // 暂停前的二次确认（设计稿标注：「点「暂停」会弹出二次确认，并显示
        // 受影响人数与项目名单。」）。恢复是纯还原动作，单击即可，不弹确认。
        // 只写成员与项目：暂停不触碰待兑换邀请，写进来就是不实之词。
        pause_confirm:
          '确定暂停部门「{name}」？\n\n' +
          '· {members} 名成员将看不到也选不了本组织的协作项目\n' +
          '· 受影响的协作项目 {projects} 个：{project_list}\n' +
          '· 已生成的文件不会被删除；恢复后原有的授权路径原样回来\n' +
          '· 在项目里单独给个人开过权限的，以个人权限为准，不受影响',
        pause_confirm_projects_none: '无',
        pause_confirm_projects_sep: '、',
        pause_confirm_projects_more: ' 等（另有 {count} 个）',
        pause_impact_failed: '影响面预览失败，已取消暂停：{error}',
      },
    },
    projects: {
      crumb_projects: '项目',
      title: '组织项目',
      desc: '本组织下的所有项目。点击项目名进入详情管理成员权限。',
      loading: '加载中…',
      error_prefix: '加载失败：',
      retry: '重试',
      search_placeholder: '搜索项目…',
      search_aria: '搜索项目',
      status_filter_aria: '状态筛选',
      create_btn: '+ 新建项目',
      create_btn_title: '创建组织级项目',
      create_btn_no_perm: '需要组织管理员或平台管理员权限',
      create_btn_at_cap: '已达项目上限 {count}，请联系平台管理员提升配额',
      status: {
        all: '全部状态',
        active: '活跃',
        archived: '已归档',
        planning: '规划中',
        suspended: '已停用',
      },
      table: {
        project: '项目',
        access_method: '接入方式',
        status: '状态',
        approval: '审批',
        created_at: '创建时间',
        actions_aria: '操作',
      },
      access_method_label: {
        local: '本地 (local)',
        ssh_agent: 'SSH Agent',
        api: 'API 隧道',
        docker: 'Docker',
        ssh_docker: 'SSH + Docker',
        desktop: '我的电脑 (Desktop)',
      },
      approval: {
        required: '需审批',
        direct: '直接执行',
      },
      detail_link: '详情',
      empty: {
        title: '未找到项目',
        no_projects: '该组织暂无项目。',
        no_match: '调整筛选条件试试。',
        no_permission: '该组织的项目仅管理员可查看与管理。',
      },
    },
    components: {
      quota: {
        unlimited_label: ' · 无限 / 未设额度',
        over_label: '已超额 {pct}%',
        subscription_period: '订阅周期',
        current_period_start: '当前周期开始',
        subscription_expires: '订阅到期',
        period: {
          monthly: '月付',
          quarterly: '季付',
          semiannual: '半年付',
          annual: '年付',
        },
      },
    },
    audit: {
      title: '审计日志',
      breadcrumb: '审计日志',
      desc: '组织内所有关键事件的不可变记录 (P1: 8 类 · 全部保留 ≥1 年)。',
      filter: {
        region_label: '审计过滤',
        action_type: '事件类型',
        actor: '执行人',
        actor_placeholder: '姓名 / 邮箱',
        target: '对象',
        target_placeholder: '目标项目 / 用户',
        time_range: '时间范围',
      },
      action_options: {
        all: '全部 (8 类)',
      },
      time_options: {
        day1: '最近 24 小时',
        day7: '最近 7 天',
        day30: '最近 30 天',
        custom: '自定义…',
      },
      table: {
        time: '时间 (+08:00)',
        event: '事件',
        actor: '执行人',
        target: '对象',
        details: '详情',
      },
      empty: {
        filtered_title: '当前筛选条件下无匹配记录',
        no_records_title: '该时间范围内暂无审计记录',
        filtered_desc: '可尝试调整事件类型或时间范围。',
        unavailable_title: '审计日志 API 即将上线',
        unavailable_desc: '后端 GET /api/admin/audit 路由将在后续 Tier 接入，敬请期待。',
        forbidden_title: '您无权查看此组织的审计日志',
        forbidden_desc_admin: '后端返回 403 — 请检查您的会话权限。',
        forbidden_desc_member: '审计日志仅对组织管理员开放。如需查看，请联系组织所有者授权。',
      },
      error_prefix: '加载失败：{msg}',
      pager: {
        showing: '显示 {start}-{end} / 共 {total} 条',
        zero: '共 0 条',
        prev: '‹ 上一页',
        next: '下一页 ›',
      },
    },
    settings: {
      title: '组织设置',
      breadcrumb: '设置',
      error_prefix: '加载失败：{msg}',
      retry: '重试',
      readonly_banner: '您以组织成员身份查看此页面，所有编辑操作需要组织管理员权限。',
      section: {
        ownership: {
          title: '⚠️ 所有权管理',
          sub: '所有者操作高度敏感，需企业微信 IM 双因素验证。仅当前所有者可见。',
          transfer_btn: '转移所有者…',
        },
        basic: {
          title: '基本信息',
          name_label: '组织名称',
          slug_label: 'Slug (URL)',
          slug_hint: 'slug 创建后不可修改',
          desc_label: '描述',
          desc_placeholder: '（无）',
          edit_btn: '编辑',
          edit_title_enabled: '编辑表单将在 T6c 接入 (EditOrgModal)',
          edit_title_disabled: '需平台管理员权限',
        },
        quota: {
          title: '配额限制',
          loading: '加载配额信息…',
          unlim: '不限',
          kpi_tooltip: '此指标需平台管理员权限',
          label_plan: '套餐',
          label_status: '状态',
          label_trial_ends: '试用期至',
          label_providers: '允许的模型供应商',
          kpi_members: '成员数',
          kpi_projects: '项目数',
          kpi_monthly_budget: '月度 Token 上限',
          kpi_member_limit: '成员上限',
          kpi_project_limit: '项目上限',
          edit_quota_btn: '编辑配额',
          edit_quota_contact: '编辑配额（联系平台管理员）',
          edit_quota_title_enabled: '编辑配额',
          edit_quota_title_disabled: '联系平台管理员',
          locked_title: '需平台管理员权限查看商业化配置',
          locked_desc: '套餐 / 状态 / Token 上限等字段目前仅对平台管理员开放。',
        },
        subscribe: {
          title: '自助订阅 / 升级',
          stub_hint:
            '沙箱支付（演示）：当前为支付桩，确认后不会真实扣款。正式支付网关待接入。',
          tier_label: '目标套餐',
          period_label: '计费周期',
          period_monthly: '按月',
          period_quarterly: '按季',
          period_half_year: '半年',
          period_yearly: '按年',
          create_intent_btn: '去结算',
          amount_label: '应付金额',
          session_label: '结算会话',
          first_purchase: '首次购买',
          upgrade: '升级（按比例补差价）',
          sandbox_pay_btn: '立即支付（沙箱）',
          cancel_btn: '取消',
          subscribed: '订阅成功',
          expires: '到期',
        },
        // P-COND-4E646C4E5E39 Sub-Task 4 — 跨组织项目引用授权。
        // 中文文案与设计稿逐字一致（SOLE 设计契约）：
        //   planning/design/_sessions/31bfa815/P-COND-6D957190C0D9/org-grants-section.html
        grants: {
          incoming_title: '我方已授权的组织',
          incoming_hint:
            '以下组织可在其项目中只读引用本组织的项目。一键取消后，对方容器内相关目录立即失效。',
          outgoing_title: '我方发起的接入申请',
          outgoing_hint:
            '获对方批准后，本组织管理员即可在项目页的「引用其他项目（只读）」中选择对方项目。',
          // 状态标签：incoming 站在「授权方」视角，outgoing 站在「申请方」视角，
          // 所以同一个 approved 分别读作「已授权」与「已获授权」。
          tag_in_approved: '已授权',
          tag_in_pending: '待确认',
          tag_in_rejected: '已拒绝',
          tag_in_revoked: '已取消',
          tag_out_approved: '已获授权',
          tag_out_pending: '待对方确认',
          tag_out_rejected: '已被拒绝',
          tag_out_revoked: '已被取消',
          meta_in_pending: '{date} 申请 · 申请人 {who} · 事由：{reason}',
          meta_in_approved: '{date} 由 {who} 批准',
          meta_in_closed: '{date} 已结束',
          meta_out_approved: '{date} 获批',
          meta_out_pending: '{date} 已提交，等待对方管理员确认',
          meta_out_closed: '{date} 已结束',
          revoke_btn: '一键取消',
          approve_btn: '同意',
          reject_btn: '拒绝',
          view_refs_btn: '查看引用',
          apply_btn: '＋ 申请接入其他组织',
          confirm_revoke:
            '确定取消对「{name}」的授权吗？对方容器内相关目录将立即失效。',
          processing: '处理中…',
          loading: '加载中…',
          unknown_org: '（未知组织）',
          no_reason: '（未填写）',
          error_prefix: '授权列表加载失败：{msg}',
          incoming_empty_title: '尚未授权任何组织',
          incoming_empty_desc: '当其他组织申请接入时，申请会出现在这里等待你确认。',
          outgoing_empty_title: '尚未发起接入申请',
          outgoing_empty_desc:
            '向对方管理员索取组织标识（slug）后，点击下方按钮发起申请。',
        },
        danger: {
          title: '危险区域',
          sub: '停用后组织进入隔离状态，可由平台管理员恢复。',
          deactivate_btn: '停用组织…',
        },
      },
      loading: '加载中…',
    },
    profile: {
      title: '个人资料',
      breadcrumb_account: '账号',
      breadcrumb_profile: '个人资料',
      error_prefix: '加载失败：{msg}',
      retry: '重试',
      loading: '加载中…',
      basic_info: {
        title: '基本信息',
        name_label: '姓名',
        username_label: '用户名',
        user_id_label: 'user_id',
        email_label: '邮箱',
        phone_label: '电话',
        wecom_label: '企业微信 ID (wecom_userid)',
        role_label: '全局角色',
        save_btn: '保存',
        save_success: '已保存',
        badge_platform_admin: '平台管理员',
        badge_member: '普通用户',
      },
      contact: {
        verified: '✓ 已验证',
        not_set: '—（未设置）',
        change: '修改',
        add: '添加',
        step1: '第 1 步：输入新地址并发送验证码',
        step2: '第 2 步：输入收到的验证码',
        email_placeholder: '输入新邮箱地址',
        phone_placeholder: '输入新手机号',
        send_code: '发送验证码',
        code_hint: '验证码将发送到新地址，10 分钟内有效',
        resend: '重新发送',
        resend_countdown: '重新发送 ({n}s)',
        code_placeholder: '6 位验证码',
        confirm: '确认修改',
      },
      password: {
        title: '修改密码',
        current_label: '当前密码',
        new_label: '新密码',
        confirm_label: '确认新密码',
        submit: '更新密码',
        success: '密码已更新',
        mismatch: '两次输入的新密码不一致',
        policy_hint: '至少 8 个字符，必须同时包含字母和数字',
      },
      memberships: {
        title: '组织成员关系',
        col_org: '组织',
        col_slug: 'Slug',
        col_role: '角色',
        col_created: '创建时间',
        empty_title: '尚未加入任何组织',
        empty_desc: '可访问"所有组织"或联系平台管理员加入一个组织。',
        error_title: '组织列表暂不可用',
        error_desc: '请稍后重试，或检查与后端的网络连接。',
      },
    },
    projectDetail: {
      loading: '加载中…',
      not_found: {
        breadcrumb_projects: '项目',
        breadcrumb_not_found: '未找到',
        title: '项目不存在',
        desc: '该项目可能已被停用或不属于本组织。',
        back_btn: '← 返回项目列表',
      },
      error_prefix: '加载失败：{msg}',
      retry: '重试',
      desc_fallback: '项目详情 — 成员权限、配额、危险操作。',
      kpi: {
        members: '成员',
        // 协作项目专用：access.yaml `users:` 段的条目数 —— 协作项目的准入
        // 名单在 access.yaml，不在 project_members（后者恒为空）。
        authorized_users: '已授权个人',
        approval_mode: '审批模式',
        status: '状态',
        default_tier: '默认权限层级',
        approval_required: '需审批',
        direct_execute: '直接执行',
        tier_tooltip: '非平台管理员调用者看不到此字段',
      },
      basic: {
        title: '基本信息',
        sub: '已创建项目的接入方式不可更改。',
        name_label: '项目名',
        name_aria: '项目名 (只读)',
        method_label: '接入方式',
        method_aria: '接入方式 (只读)',
        path_label: '项目路径',
        path_aria: '项目路径 (只读)',
        ssh_label: 'SSH 主机',
        ssh_aria: 'SSH 主机 (只读)',
        approval_label: '需要审批',
        approval_aria: '需要审批 (只读)',
        approval_yes: '是 — 双阶段调度门',
        approval_no: '否 — 直接执行',
        created_label: '创建时间',
        created_aria: '创建时间 (只读)',
      },
      members: {
        title: '成员管理',
        sub: '权限层级控制 Claude agent 可执行的操作 (read_only → code_changes → full_autonomy)。read_only 仅可使用规划模式。',
        add_btn: '+ 添加项目成员',
        col_username: '用户名',
        col_role: '项目角色',
        col_tier: '权限层级',
        col_can_select_model: '可选择模型?',
        can_select_title: '允许该成员在新会话/消息中自由选择模型',
        can_select_locked: '管理员恒可选（锁定）',
        // col_deny_access / deny_access_* removed with the 成员管理 表格的
        // 拒绝访问 列 (P-COND-9C4E17B0D2A5 ST3) —— 该列的门控嵌在 isDevLike 内，
        // 对真 collab 项目零可达；能力已移入目录权限编辑器 users: 行。
        role_owner: '所有者',
        role_member: '成员',
        edit_btn: '编辑',
        edit_title: '编辑角色与权限层级',
        remove_btn: '移除',
        removing: '移除中…',
        remove_title_owner: '项目所有者不可移除 — 请先转移所有权',
        remove_title_member: '移除该成员（软删除）',
        confirm_remove: '确定要将「{name}」移出本项目吗？该操作为软删除，可重新添加。',
        empty_title: '暂无项目成员',
        empty_desc: '该项目还没有成员。点击「+ 添加项目成员」从组织成员中添加。',
        error_title: '成员列表暂不可用',
        dismiss: '知道了',
        owner_protect: '无法移除「{name}」：该成员是项目所有者，请先转移所有权。',
      },
      quota: {
        title: '配额',
        sub: '项目级配额继承自组织级 (Phase 3 v1.1)。',
        default_model: '默认模型',
        model_not_set: '未配置',
        model_tooltip: '未配置 — 沿用全局默认',
        cost_title: '本月费用',
        cost_not_set: '未配置',
        cost_tooltip: '项目级费用聚合尚未暴露 — 仅有组织级 month_to_date_cost',
        approval_mode: '审批模式',
        two_phase: '双阶段调度门',
        direct: '直接执行',
      },
      settings: {
        title: '项目设置',
        sub: '可编辑的项目配置 — 描述、默认权限层级、默认模型、状态与审批模式。',
        error_prefix: '保存失败：{msg}',
        saved: '设置已保存。',
        save_btn: '保存设置',
        saving: '保存中…',
        save_title_enabled: '保存项目设置',
        save_title_disabled: '没有改动 — 修改任意字段后即可保存',
        desc_label: '项目描述',
        tier_label: '默认权限层级',
        // P-COND-056A6CA445F9 (3tier) — 存量旧层级的置顶禁用选项
        tier_legacy_option: '旧层级（已停用，按 read_only 生效）',
        model_label: '默认模型',
        model_default_option: '留空沿用全局默认',
        model_select_default_label: '项目级可选模型默认',
        model_select_default_inherit: '跟随组织/成员默认（fail-open）',
        model_select_default_allow: '允许（项目级默认：可选模型）',
        model_select_default_deny: '禁止（项目级默认：不可选模型）',
        provider_label: '模型供应商配置',
        provider_section_sub:
          '选择本项目可用的模型供应商与默认模型。组织/项目管理员均可在此配置。',
        provider_platform_default: '平台默认',
        provider_default_radio: '默认供应商',
        provider_not_in_org: '未授权',
        provider_none_error: '至少需勾选一个可用供应商。',
        provider_hint:
          '勾选 = 该供应商对本项目可用（新会话「选供应商」仅列勾选项）；默认模型初始值为平台管理员设定的「平台默认」，可在此覆盖为项目级默认；默认供应商 = 自动任务及新会话初始所用供应商。架构模式/backend 由所选模型自动推导。',
        status_label: '状态',
        approval_label: '需要审批',
        approval_yes: '是 — 双阶段调度门',
        approval_no: '否 — 直接执行',
        planning_label: '规划文件夹',
        max_turns_label: '最大轮次',
        max_turns_placeholder: '留空沿用全局默认',
        collab_scope_note: '协作项目 — 仅显示适用配置项',
        git_card_title: 'Git 生命周期与管理模式',
        git_card_sub: '配置本项目是否启用 Git 生命周期，以及远端项目的分支管理模式。',
        git_label: 'Git 生命周期',
        git_mode_label: '管理模式',
        git_mode_b: '方式B — Codeup 托管',
        git_mode_a: '方式A — 自管',
        git_help_toggle: '这些设置是什么？点击展开说明',
        git_help_enabled:
          'Git 生命周期启用：每次派单在独立的 per-conversation clone 中工作，改动可用 git 追踪并一键回退。',
        git_help_disabled:
          'Git 生命周期停用：直接在远端项目工作区修改，不建分支、不做快照 — 可随时切回，快速撤销上述机制。',
        git_help_mode_b:
          '方式B（Codeup 托管）：每次派单自动创建 feat_YYYYMMDD 分支并推送到 Codeup，适合需要 PR / 评审的团队协作。',
        git_help_mode_a:
          '方式A（自管）：会话直接提交到所选基础分支，不自动建 feat_ 分支；多个会话共享同一条线，适合自行管理分支的项目（如 thegym）。仍可手动创建 feat_ 基础分支；设置集成线后，功能分支 /merge 先合进集成线，再由集成线 /merge 发布到 master。',
        git_branch_default_label: '默认分支',
        git_branch_default_placeholder: '留空则使用 master',
        git_branch_default_hint:
          '设置后，统筹会话和方式A 会话未指定分支时使用此默认分支。留空 → master。',
        git_integration_branch_label: '集成线（可选）',
        git_integration_branch_placeholder: '例如 feat_main；留空表示无集成线',
        git_integration_branch_hint:
          '设置后两级晋级：功能分支 /merge 合进集成线，集成线 /merge 发布到 master；统筹会话不会自动推进 master。留空 → 功能分支 /merge 直接合进 master。',
        git_ready_title_ready: '仓库已就绪',
        git_ready_title_not_ready: '仓库未就绪，开关暂未生效',
        git_ready_title_failed: '准备过程中出错，开关暂未生效',
        git_ready_title_check_ok: '检查通过：启用后将自动完成灰色步骤',
        git_ready_title_check_blocked: '检查未通过：请先处理红色项',
        git_ready_title_skipped: '当前项目无需准备仓库（非方式A 自管的远端项目）',
        git_ready_not_run: '未执行',
        git_ready_changes_label: '已在主机上完成的改动：',
        git_ready_changes_none: '无',
        git_ready_suggest_label: '建议忽略以下目录（不进入版本库）：',
        git_ready_ignore_continue: '忽略这些并继续',
        git_ready_keep_label: '保留进版本库：{dir}（看起来是源码）',
        git_ready_check_btn: '检查就绪状态',
        git_ready_checking: '正在检查…',
        git_ready_saving_hint: '正在主机上准备仓库，可能需要约 1 分钟，请勿关闭页面…',
        git_ready_timeout: '请求超时：主机端可能仍在处理，请稍后点「检查就绪状态」确认。',
        git_ready_step_path: '项目目录',
        git_ready_step_repo_root: '仓库位置',
        git_ready_step_preflight: '预演',
        git_ready_step_host_only_tracked: '托管文件',
        git_ready_step_push_target: '推送目标',
        git_ready_step_ignore: '忽略规则',
        git_ready_step_baseline: '首次提交',
        git_ready_step_branch: '默认分支',
        git_ready_step_origin: '备份仓库',
        git_ready_step_rules: '规则文件',
        modes_label: '启用协作/开发模式',
        modes_off_hint: '停用 — 项目仅使用单一工作区根目录（当前行为）。',
        modes_dev_hint: '开发模式根目录 (dev)：{path}',
        modes_locked_hint: '已启用（配置后不可更改）',
        modes_path_error: '无法推导工作区路径：项目路径必须为绝对路径。',
        ip_label: 'IP 白名单',
        scripts_label: '允许脚本',
        scripts_placeholder: '每行一个脚本路径，留空表示不限制',
        skill_overrides_label: '技能层级覆盖',
        extra_mounts_label: '额外挂载',
        enabled: '启用',
        disabled: '停用',
      },
      danger: {
        title: '危险操作',
        sub: '转移所有权或停用项目 — 仅项目所有者、组织管理员或平台管理员可执行。',
        transfer_title: '转移项目所有者',
        transfer_sub: '将所有权转给本组织的另一名活跃成员（输入其 user_id）。',
        transfer_btn: '转移所有者…',
        processing: '处理中…',
        deactivate_title: '停用项目',
        deactivate_sub: '软删除 — 项目历史保留，无法恢复需联系平台管理员。',
        deactivate_btn: '停用项目',
        dismiss: '知道了',
        transfer_prompt: '转移项目所有者：请输入新所有者的 user_id（必须是本组织的活跃成员）。',
        user_id_empty: 'user_id 不能为空。',
        transfer_success: '已转移项目所有者。',
        deactivate_confirm: '确定要停用项目「{name}」吗？这是软删除——项目历史保留，但成员将失去访问，需联系平台管理员恢复。',
        deactivate_success: '项目已停用。',
        deactivate_forbidden: '停用项目当前仅限平台管理员执行（后端尚无组织级停用路由）。',
      },
      selfService: {
        panel_title: '知识自建入口',
        panel_sub: '上传原始规范文档，为协作工作区新增行业 Skill、部门 SOP 或工作流定义。',
        skill_card_title: '行业 Skill',
        skill_card_sub: '为本组织补充行业能力（合同审核 / 预算核算 / 招聘 JD…）。',
        skill_target: '→ .claude/skills/<slug>/SKILL.md',
        skill_add_btn: '+ 新增 Skill',
        skill_field_slug: 'Skill 标识 (slug)',
        skill_field_slug_placeholder: '例：contract-review',
        skill_field_hint: '补充说明 (hint)',
        skill_field_hint_placeholder: '可选 — 给转化 agent 的额外上下文',
        skill_field_file: '规范文档',
        skill_dialog_title: '新增行业 Skill',
        skill_uploading: '上传中…',
        skill_upload_btn: '上传并转化',
        sop_card_title: '部门 SOP',
        sop_card_sub: '上传部门规范 / 制度文件（PDF / DOCX / MD，密级 P1）。',
        sop_target: '→ domains/<部门>/standards/',
        sop_add_btn: '+ 上传 SOP',
        sop_field_dept: '部门',
        sop_field_dept_placeholder: '选择部门',
        sop_field_file: 'SOP 文档',
        sop_dialog_title: '上传部门 SOP',
        sop_uploading: '上传中…',
        sop_upload_btn: '上传',
        sop_list_label: '已归档文件（部门：',
        sop_empty: '暂无 SOP 归档。',
        workflow_card_title: '工作流',
        workflow_card_sub: '按骨架定义流程（目标 / 触发 / 步骤 / 负责人）。',
        workflow_target: '→ workflows/<名称>.md',
        workflow_add_btn: '+ 定义工作流',
        workflow_field_name: '流程名称',
        workflow_field_name_placeholder: '例：monthly-close',
        workflow_field_hint: '补充说明 (hint)',
        workflow_field_hint_placeholder: '可选 — 给转化 agent 的额外上下文',
        workflow_field_file: '规范文档',
        workflow_dialog_title: '定义工作流',
        workflow_uploading: '上传中…',
        workflow_upload_btn: '上传并转化',
        badge_ready: '已就绪',
        badge_converting: '转化中',
        converting_hint: '转化中 — agent 正在写入文件，稍后刷新。',
        btn_retry: '重试',
        btn_delete: '删除',
        btn_download: '下载',
        btn_cancel: '取消',
        empty_skills: '暂无 Skill。',
        empty_workflows: '暂无工作流。',
        error_prefix: '出错：{msg}',
        delete_confirm: '删除 Skill「{slug}」？此操作不可撤销。',
        usage_help_toggle: '什么时候用哪个？（Skill · SOP · 工作流应用场景）',
        usage_skill_label: '行业 Skill',
        usage_skill:
          '可复用的「能力 / 方法论」，转化后 agent 自动加载、跨对话反复运用（如合同审核、预算核算、招聘 JD）。',
        usage_sop_label: '部门 SOP',
        usage_sop:
          '部门「规范 / 制度原文」，仅归档（PDF / DOCX / MD，不转化）供 agent 查阅遵循。',
        usage_workflow_label: '工作流',
        usage_workflow:
          '一件事的「多步骤流程」编排（目标 / 触发 / 步骤 / 负责人），转化为 workflows/<名称>.md。',
        admin_only_badge: '仅组织管理员',
        loading: '加载中…',
        file_picker_default: '选择文件…',
        load_failed: '加载失败',
        upload_failed: '上传失败',
        download_failed: '下载失败',
        retry_failed: '重试失败',
        delete_failed: '删除失败',
        validate_slug_empty: 'Slug 不能为空',
        validate_select_spec: '请选择规范文档',
        validate_select_dept: '请选择部门',
        validate_select_sop: '请选择 SOP 文档',
        validate_name_empty: '名称不能为空',
      },
      badge: {
        collab: '协作项目',
        dev: '开发项目',
      },
      enter_conversation: {
        cta: '进入会话',
        cta_aria: '打开此项目的会话',
      },
      accessYaml: {
        // P-COND-CDD515B7ACD4 — 这张卡只管「进入工作区之后能写哪些目录」（路径授权链）。
        // 「谁能看到本项目」是另一条链，由下方 deptVisibility 区块负责。原标题
        // 「部门权限」把两件事混为一谈，是本次事故的直接诱因。
        title: '目录权限 (access.yaml)',
        sub: '给每个部门或成员设置进入本项目工作区「之后」可写 / 禁止的目录。不决定谁能看到本项目——可见性见下方「部门可见性」。保存时校验格式并与 ACCESS.md 做一致性检查（冲突会被拒绝）。',
        loading: '加载中…',
        warnings_label: '提示：',
        no_file: '尚无 access.yaml 文件，保存后将创建。',
        save_btn: '保存部门权限',
        saving: '保存中…',
        saved: '部门权限配置已保存',
        conflict_access_md: '配置与 ACCESS.md 存在冲突，已拒绝保存',
        conflict_stale: '文件已被其他人修改，请重新加载后再保存',
        invalid: 'access.yaml 格式无效 (请检查 YAML 语法与 tier 取值)',
      },
      // P-COND-CDD515B7ACD4 — 部门可见性授权 (projects.department_tiers)。
      // 与上方 access.yaml 正交：这里决定「谁能在侧边栏看到本项目」，
      // access.yaml 决定「进来之后能写哪些目录」。
      deptVisibility: {
        title: '部门访问权限',
        sub: '权限层级与目录授权统一管理 · 每个部门一行配置',
        col_dept: '部门',
        col_level: '权限层级',
        col_allow: '可写目录',
        col_deny: '禁止目录',
        col_model_select: '模型选择',
        model_select_inherit: '跟随项目默认',
        model_select_allow: '允许',
        model_select_deny: '禁止',
        col_status: '状态',
        mode_hidden: '不可见',
        level_read_only: '只读',
        level_code_changes: '可编辑',
        legacy_tier_label: '高级层级，请在 access.yaml 中调整',
        hint_not_visible: '不可见时权限不生效',
        scope_floor: '仅公共区',
        scope_all: '全部可写',
        scope_specific: '指定目录',
        scope_floor_note:
          '仅公共区（domains/shared、workflows、domains/_personal 可写），本部门目录不可写',
        scope_all_note:
          '全部可写（整个协作工作区，含各部门目录与 org-knowledge.md；代理规则、权限说明、审计记录除外）',
        hint_allow_paths: '选择可写目录',
        hint_allow_paths_empty: '留空 = 不可写任何目录（fail-closed）',
        hint_deny_paths: '选择禁止目录',
        hint_deny_paths_note: '禁止目录对读和写都生效，优先级高于可写目录',
        hint_readonly_no_paths: '只读层级无写工具，可写目录不适用',
        empty: '本组织尚未登记任何部门，可在「组织成员」页为成员设置部门后再来授权。',
        save_btn: '保存部门权限',
        saving: '保存中…',
        saved: '部门权限已保存',
        badge_granted: '可见',
        badge_paused: '部门已暂停',
        unknown_hint: '该部门已从组织移除；授权保留，不会自动清理',
        cases_title: '权限配置说明与案例',
        case1_title: '可编辑 · 全部可写',
        case1_effect:
          'Agent 有写工具，可写整个协作工作区（含各部门目录与 org-knowledge.md）；代理规则、权限说明、审计记录除外',
        case1_note: '适用：运维、技术等需全项目访问的部门',
        case2_title: '可编辑 · 指定可写目录',
        case2_effect: '写操作仅限可写目录；其余可读不可写。留空即完全不可写',
        case2_note: '适用：各部门只维护自己目录',
        case3_title: '可编辑 + 禁止目录',
        case3_effect: '全部可写，但禁止目录读写全拒（受保护文件始终不可写）',
        case3_note: '两列独立生效，可任意组合；禁止目录优先级最高',
        case4_title: '只读 + 禁止目录',
        case4_effect: '无写工具；禁止目录连读也拒绝，其余目录可读',
        case4_note: '除「不可见」外的任何层级都可设置禁止目录',
        template_title: '权限模板',
        template_current: '当前：{name}',
        template_custom: '自定义（每个部门单独设置目录）',
        template_a_name: 'A · 部门协作',
        template_a_default: 'A · 部门协作（默认）',
        template_a_desc: '编辑本部门工作文件，其他部门只读',
        template_b_name: 'B · 部门隔离',
        template_b_desc: '编辑本部门工作文件，其他部门默认不可读',
        template_sub: '选一个模板即可，例外用「调整」，特殊情况才「自定义目录」',
        template_hidden_label: '对所有部门隐藏',
        template_shared_label: '所有部门都可读',
        template_pick_dept: '+ 选择部门',
        template_none_selected: '未选择',
        template_picker_ok: '确定',
        template_apply_btn: '选用模板',
        template_apply_hint: '先填入草稿，点「保存部门权限」后生效。规范文件（standards）修改仍走审批',
        template_base_pending: '已选 {name}，点「选用模板」后切换',
        template_dirty: '未保存',
        template_dialog_title: '套用模板 {base} 到 {count} 个可见部门？',
        template_dialog_follow: '这些部门改为「跟随模板」：{list}',
        template_dialog_replaced: '会被替换：{list} 现在的自定义目录。需要保留的话，保存后把该行改回「自定义目录」',
        template_dialog_invisible: '不可见的部门（{list}）不会被开放',
        template_dialog_shared_readonly: '公共区将变为只读，除非指定了部门或人员',
        template_dialog_convert: '把 {count} 位「个人只读」成员改为跟随部门（推荐）',
        template_dialog_convert_hint: '不勾选：这 {count} 人仍只能读，不能写本部门',
        template_dialog_cancel: '取消',
        template_dialog_confirm: '填入草稿',
        template_col_scope: '可写范围',
        template_col_others: '其他部门',
        template_scope_dept: '本部门工作文件',
        template_scope_public: '公共区',
        template_scope_public_yes: '可改',
        template_scope_public_no: '只读',
        template_scope_follow: '跟随模板',
        template_scope_readonly: '只读，不能写任何文件',
        template_to_custom: '自定义目录',
        template_to_follow: '改为跟随模板',
        template_others_all: '全部可读',
        template_others_all_except: '全部可读，{list}除外',
        template_others_none: '不可读其他部门',
        template_others_some: '不可读；可读：{list}',
        template_others_custom: '自定义',
        template_adjust: '调整',
        template_adjust_title: '{dept} · 其他部门',
        template_adjust_hide_self: '对所有部门隐藏本部门',
        template_adjust_shared_self: '本部门所有部门都可读',
        template_adjust_extra_read: '本部门额外可读：',
        template_adjust_a_also_hidden: '其他已隐藏部门（取消勾选将对全部门解除隐藏）',
        template_people_title: '个人例外 · {count} 人',
        template_people_readonly: '个人只读',
        template_people_editable: '个人可编辑',
        template_people_full: '个人全权限',
        template_people_custom: '个人自定义目录',
        template_people_custom_note: '（公共区设置对他不生效）',
        template_people_denied: '拒绝访问',
        template_people_to_inherit: '改为跟随部门',
        template_people_keep: '保留',
        template_people_no_dept: '无部门',
        template_people_pending: '个人设置的修改会在点「保存部门权限」时一起保存',
        template_save_users_failed: '部门权限已保存，但个人设置保存失败：{error}',
        shared_write_label: '公共区可编辑',
        shared_write_none: '只读（默认）',
        shared_write_selected: '指定部门 / 人员',
        shared_write_all: '所有可编辑部门',
        shared_write_depts: '部门',
        shared_write_users: '人员',
        shared_write_pick_dept: '+ 选择部门',
        shared_write_pick_user: '+ 选择人员',
        shared_write_hint_none: '公共区 = 共享资料（shared）和流程（workflows）。全员只读（管理员和项目负责人除外）。',
        shared_write_hint_selected: '只有选中的部门和人员能改公共区，其他人仍可读。只读部门即使被选中也不能写；单独选中的人员不受部门层级限制。',
        shared_write_hint_all: '所有「可编辑」部门都能改公共区；只读部门仍只能读。',
        shared_write_hint_empty: '尚未选择部门或人员：保存后公共区仍为全员只读',
        shared_write_pick_dept_title: '可以改公共区的部门',
        shared_write_pick_user_title: '可以改公共区的人员',
        shared_write_pick_dept_hint: '只勾选部门名，不需要填目录。',
        shared_write_pick_user_hint: '选中的人不需要另建个人条目，原有的本部门权限保留。',
        shared_write_pick_empty: '暂无可选项',
      },
      orgTier: {
        label: '组织成员默认权限',
        deny: '禁止（不向组织成员开放）',
        read_only: '只读',
        code_changes: '可编辑（读写代码）',
        hint: '修改后立即生效，影响所有未被单独授权的组织成员',
      },
      audit_jump: {
        title: '审计日志',
        empty_title: '查看项目审计',
        empty_desc: '项目内成员/权限/调度的完整事件，已聚合到组织审计日志页面。',
        goto_btn: '前往审计日志 →',
      },
      status: {
        active: '活跃',
        archived: '已归档',
        planning: '规划中',
        suspended: '已停用',
      },
      lifecycle: {
        title: '生命周期管理',
        sub: '暂停后项目将拒绝新的派单；删除会进入 30 天回收期，期间可随时恢复。',
        status_active: '活跃',
        status_paused: '已暂停',
        status_pending_delete: '待删除',
        error_close: '关闭',
        processing: '处理中…',
        pending_banner: '该项目已被删除，将在约 {days} 天 {hours} 小时后永久清除（截止 {deadline}）。',
        pending_expired: '该项目的回收期已结束，可能已被永久删除。',
        restore_title: '恢复项目',
        restore_sub: '当前待删除，恢复后可正常使用。',
        restore_btn: '恢复项目',
        pause_row_title_active: '暂停项目',
        pause_row_title_paused: '恢复项目',
        pause_row_sub_active: '暂停后项目将拒绝新的派单，可随时恢复。',
        pause_row_sub_paused: '当前已暂停，恢复后可继续派单。',
        pause_btn: '暂停',
        resume_btn: '恢复',
        delete_title: '删除项目（可恢复）',
        delete_sub: '进入 30 天回收期，期间可随时恢复；逾期后将被永久清除。',
        delete_btn: '删除',
        confirm_delete: '确定要删除项目「{name}」吗？项目将进入 30 天回收期，期间可随时恢复。',
      },
      sharedReadonly: {
        title: '引用其他项目（只读）',
        sub_pre: '将其他项目的工作区以只读方式挂载到本项目的',
        sub_code: '/workspace/shared/',
        sub_post:
          '目录下，供本项目的智能体参考（不可写入）。可选范围包括本组织的项目，以及已授权本组织的其他组织的项目。',
        error_close: '关闭',
        select_label: '选择要引用的项目',
        select_placeholder_empty: '暂无可引用的项目',
        select_placeholder: '请选择项目…',
        // 项目名（组织全名 · slug）—— 组织限定词不是装饰：跨组织候选里可能出现同名
        // 项目，而组织全名没有唯一约束，只有 slug 能唯一区分。
        option_label: '{name}（{org} · {slug}）',
        add_btn: '添加只读引用',
        processing: '处理中…',
        unknown_project: '（未知项目）',
        mounted_pre: '挂载于 ',
        mounted_post: '（只读）',
        remove_btn: '移除',
        empty: '尚未引用任何项目。仅 Docker 家族项目支持挂载。',
        err_duplicate: '该项目已被引用。',
        err_cross_org: '对方组织尚未授权本组织引用其项目。',
        err_bad_request:
          '无法添加：不能引用项目自身；本项目须为 Docker 家族项目才能挂载引用；跨组织引用还要求双方位于同一台主机。',
        err_not_found: '源项目不存在或已被删除。',
        dept_section_label: '谁能访问这份数据？',
        dept_all_label: '所有人（默认）',
        dept_all_desc: '本项目所有部门、所有成员的 Agent 均可见此数据源',
        dept_specific_label: '指定部门或成员',
        dept_specific_desc: '只有选定部门的成员、或选定的个人，其 Agent 才能看到此路径',
        pick_depts_label: '部门',
        pick_users_label: '成员',
        no_members: '暂无可选成员',
        specific_or_note: '满足任一条件即可见：所在部门被勾选，或本人被勾选。引用内容始终只读。',
        chip_nobody: '无人可见',
        dept_no_depts: '暂无部门可选，请先在组织成员中设置部门',
        dept_chip_all: '所有人',
        edit_dept_btn: '修改权限',
        save_dept_btn: '保存',
        cancel_dept_btn: '取消',
      },
      branches: {
        title: '分支管理',
        subtitle: '退役后工作区立即删除、分支保留 {days} 天可恢复；到期自动彻底删除',
        tab_active: '活跃 {n}',
        tab_retired: '已退役 {n}',
        col_branch: '分支',
        col_commit: '最后提交',
        col_merged: '合并',
        col_size: '大小',
        col_conversations: '会话',
        col_actions: '标记与操作',
        merged_yes: '已合并',
        merged_no: '未合并 {n}',
        suggested: '建议退役',
        retire_btn: '退役',
        restore_btn: '恢复',
        retired_badge_days: '{n} 天后删除',
        retired_badge_hours: '{n} 小时后删除',
        retired_badge_due: '即将彻底删除',
        retired_badge_unknown: '已退役',
        reason: {
          default_branch: '默认/基线分支',
          inflight: '任务运行中',
          test_slot: '测试槽在用',
          dirty: '有 {n} 个未提交改动',
          checked_out_remote: '当前已检出',
          codex_admission: 'Codex 执行占用',
        },
        modal_title: '退役分支 {name}',
        modal_body: '工作区目录立即删除，分支保留 {days} 天后彻底删除。期间可随时恢复。',
        modal_conversations: '关联会话 {n} 个：退役期间这些会话不能再在该分支上派单，恢复后可继续。',
        modal_unmerged_ack: '我知道有 {n} 个未合并提交',
        confirm_btn: '确认退役',
        retiring: '退役中…',
        cancel_btn: '取消',
        conflict: {
          protected: '该分支当前受保护，无法退役：',
          unmerged: '该分支有未合并提交，请勾选确认后重试。',
          already_retired: '该分支已退役。',
          other: '退役被拒绝：',
        },
        empty_active: '暂无活跃分支',
        empty_retired: '暂无已退役分支',
        loading: '加载分支中…',
        degraded: '部分分支信息获取失败（远端不可达或超时），当前列表可能不完整。',
        error_load: '分支列表加载失败。',
        error_generic: '操作失败，请稍后重试。',
        error_not_found: '该分支已无法恢复（不存在或已超过保留期）。',
        retry_btn: '重试',
      },
    },
    accessYaml: {
      tier: {
        read_only: '只读 (read_only)',
        testing: '测试 (testing) · 旧层级，已停用',
        code_changes: '可改代码 (code_changes)',
        deploy: '可部署 (deploy) · 旧层级，已停用',
        full_autonomy: '完全自治 (full_autonomy)',
        inherit: '跟随部门 (inherit)',
      },
      collabTier: {
        read_only: '只读',
        code_changes: '可编辑',
        full_autonomy: '全权限',
        inherit: '跟随部门',
      },
      fullAutonomyDeptWarning:
        '该层级在 CLI 后端会绕过所有路径限制，跨部门隔离将失效；owner / 管理员经身份自动获得完全自治，请勿在此给部门授予。如只需放开写入，请用「可写目录」白名单。',
      section: {
        departments_title: '部门',
        departments_subject: '部门',
        departments_add: '+ 添加部门',
        users_title: '个人用户',
        users_subject: '用户',
        users_add: '+ 添加用户',
      },
      col: {
        tier: '权限层级',
        allow: '可写目录',
        deny: '禁止目录',
        source: '来源',
        deny_access: '拒绝访问',
      },
      chip: {
        add: '+ 添加',
        done: '完成',
        manual_glob: '高级：手动 glob',
        manual_glob_aria: '手动 glob',
        remove_aria: '移除 {item}',
        dir_aria: '目录 {dir}',
      },
      row: {
        empty: '尚未配置{subject}权限',
        // P-COND-CDD515B7ACD4 — 这些行大多由 `_maybe_reconcile_collab_departments`
        // 按全组织部门清单自动播种（opt-out 语义），叫「已显式配置」会让管理员
        // 误以为自己已经授过权。措辞必须反映真实来源。
        explicit_source: '继承自组织',
        inherited_source: '继承默认',
        // 协作项目：未在 access.yaml 配置的部门 —— 运行时不吃「项目默认档位」，
        // 一律落到协作底线（read_only + 三个共享目录），故不写「继承默认」。
        unconfigured_source: '未配置',
        unauthorized_tier: '未授权 · 只读（仅共享区）',
        floor_hint: '仅可写：',
        revoked_source: '已移除授权',
        revoked_title:
          '该部门已被显式取消授权（access.yaml 保留空条目，避免后台自动对账把它重新加回来）。如需重新授权，请改上方权限层级或添加可写目录。',
        tier_aria: '{key} 权限层级',
        delete_aria: '删除 {key}',
        delete_btn: '删',
        revoke_aria: '移除 {key} 的授权',
        revoke_btn: '移除授权',
        no_departments: '组织尚无部门，请先在「成员」页为成员设置部门后再来配置',
        select_subject_placeholder: '选择{subject}…',
        select_subject_aria: '选择{subject}',
        input_placeholder: '输入{subject}名称后回车',
        // AISS-464：access.yaml 的 `users:` 键必须是用户 UUID（users.id），
        // 后端按 `spec.users.get(user_id)` 查找；写用户名永远匹配不到任何人。
        // 现已改为「只能从组织成员里选」，UUID 由选择器写入，无法手打。
        no_users: '暂无可选成员（组织成员列表未能加载，或该组织成员均已配置）',
        unresolved_badge: '无效条目',
        unresolved_title:
          '该键不对应任何组织成员。access.yaml 的 `users:` 键必须是用户 UUID（users.id）；写用户名或姓名能保存、能通过校验，但永远授不到任何人。请删除本行，改用「+ 添加用户」重新选择。',
        deny_access_aria: '拒绝 {key} 访问',
        deny_access_title:
          '勾选 = 明确拒绝该成员访问本项目。优先级最高：先于部门授权与组织管理员的隐式权限生效。',
        allow_placeholder: '如 src/ 或 domains/eng/**',
        deny_placeholder: '如 secrets/**',
      },
      // collab-perm ST2：可写目录三选一（与「部门访问权限」表同一映射）。
      scope: {
        floor: '仅公共区',
        all: '全部可写',
        specific: '指定目录',
        floor_note: '仅公共区（domains/shared、workflows、domains/_personal 可写）',
        all_note:
          '全部可写（整个协作工作区，含各部门目录与 org-knowledge.md；代理规则、权限说明、审计记录除外）',
        specific_empty: '尚未选择目录 = 不可写任何目录（fail-closed）；要恢复公共区可写请选「仅公共区」',
      },
      note: '权限将在项目启用「协作 / 开发」工作模式后对子代理生效；未启用时此配置仅做保存。',
      policy: {
        summary: '权限说明（点击展开）',
        rw_intro: '先分清读和写：',
        read: '读取',
        read_desc: ' — 整个工作区默认都能读；只有「禁止目录」能挡读，「可写目录」不影响读。',
        write: '写入',
        write_desc: ' — 先由「权限层级」定基线，再被「可写目录」收窄。',
        tier_intro: '权限层级',
        tier_intro_desc: '（对所有目录生效的默认档）：',
        tier_readonly: '只读',
        tier_readonly_desc: ' — 全局能读、默认哪都不能写；要放开写，须在「可写目录」里列出目录。',
        tier_editable: '可编辑',
        tier_editable_desc:
          ' — 写入范围由「可写目录」决定：开发项目留空 = 整个工作区可写；协作项目三选一 —「仅公共区」只有 domains/shared/、workflows/、domains/_personal/ 可写，「全部可写」= 整个协作工作区（含各部门目录与 org-knowledge.md；代理规则、权限说明、审计记录除外），「指定目录」= 只写列出的目录。',
        tier_full: '全权限',
        tier_full_desc: ' — 不受「可写目录 / 禁止目录」限制（CLI 后端会绕过路径白名单，仅 owner / 管理员等特殊场景用）。',
        allow_intro: '可写目录',
        allow_intro_desc: '（只影响写、不影响读）：',
        allow_filled: ' 填了 = 写入只限这些目录；',
        allow_filled_strong: '没列出的目录仍可读、但不能改',
        allow_empty: ' 留空 = 不额外收窄，按权限层级：',
        allow_empty_strong: '只读层级仍不能写',
        allow_empty_tail: '；可编辑层级才是整个工作区可写（协作项目除外，见下）。',
        deny_intro: '禁止目录',
        deny_intro_desc: '（优先级最高）：列出的目录连读带写一起禁止，可用来藏机密目录。',
        no_config:
          '未配置部门且无个人条目：开发项目按项目默认权限档位；协作项目一律落到协作底线 —— 全工作区只读，仅共享区可写。',
        collab_unconfigured: '协作项目：未在下方授权的部门 = 未授权 —— 全工作区只读，仅这三个目录可写：',
        collab_unconfigured_tail:
          '。本项目默认权限档位对协作派单不生效；部门自己的 domains/<部门>/ 也必须在「可写目录」里显式列出才可写。',
        default_tier_prefix: '项目默认权限档位：',
        default_tier_suffix: '。下方未显式配置的部门以「继承默认」灰色行预填，编辑后才纳入保存。',
      },
      form_unavailable: '当前 access.yaml 含有表单暂不支持的写法（{error}）。请使用下方「高级」原始 YAML 编辑，保存时后端仍会校验。',
      parse: {
        expect_list: '期望 [ ] 列表',
        cannot_parse_line: '无法解析行: {line}',
        must_be_group: '{key} 必须为分组',
        unknown_top_field: '未知顶层字段: {key}',
        missing_section: '缺少所属分组',
        cannot_parse_entry: '无法解析条目: {entry}',
        missing_entry: '缺少所属条目',
        cannot_parse_list_item: '无法解析列表项: {item}',
        unknown_tier: '未知权限层级: {tier}',
        unknown_field: '未知字段: {key}',
        unindent_unrecognized: '缩进无法识别: {line}',
      },
      tier_hint: '多条规则同时命中时：权限层级取最具体（用户 > 部门 > 项目默认）；可写目录取最小范围；禁止目录叠加生效（任一条禁止即禁止）。',
      advanced_toggle: '⚙ 高级（原始 YAML）',
      reset_btn: '重置（重新载入）',
      advanced_hint: '直接编辑原始 YAML（懂行者可用，与上方表单等价）。',
    },
  },

  // ── Dispatch Approval Page ──────────────────────────────────────
  dispatch: {
    header: '\u6D3E\u53D1\u5BA1\u6279',
    nav_chat: '\u804A\u5929',
    tabs: {
      pending: '\u5F85\u5904\u7406',
      approved: '\u5DF2\u6279\u51C6',
      rejected: '\u5DF2\u62D2\u7EDD',
      closed: '\u5DF2\u7ED3\u675F',
      my_proposals: '\u6211\u7684\u63D0\u6848',
      all: '\u5168\u90E8',
    },
    empty: '\u6CA1\u6709\u5339\u914D\u6B64\u7B5B\u9009\u6761\u4EF6\u7684\u63D0\u6848\u3002',
    table: {
      proposal_id: '方案编号',
      title: '\u6807\u9898',
      project: '\u9879\u76EE',
      submitter: '\u63D0\u4EA4\u8005',
      status: '\u72B6\u6001',
      submitted: '\u63D0\u4EA4\u65F6\u95F4',
    },
    project_filter: '\u9879\u76EE\uFF1A',
    all_projects: '\u5168\u90E8\u9879\u76EE',
    date_filter: '\u65E5\u671F\uFF1A',
    clear_dates: '\u6E05\u9664',
    submitter_filter: '提交人：',
    submitter_placeholder: '搜索提交人',
    id_filter: '方案编号：',
    clear_all: '清除全部',
    sections: {
      submitted_by: '\u63D0\u4EA4\u8005',
      original_task: '\u539F\u59CB\u4EFB\u52A1',
      proposal: '\u63D0\u6848',
      source: '\u6765\u6E90',
      expires: '\u8FC7\u671F\u65F6\u95F4',
      review: '\u5BA1\u67E5',
      execution_result: '\u6267\u884C\u7ED3\u679C',
    },
    reviewer_note_placeholder: '\u5BA1\u67E5\u5907\u6CE8\uFF08\u53EF\u9009\uFF09',
    start_implementation: '\u5F00\u59CB\u5B9E\u65BD',
    starting: '\u542F\u52A8\u4E2D...',
    re_execute: '\u91CD\u65B0\u6267\u884C',
    executing: '\u6267\u884C\u4E2D...',
    execution_complete: '\u6267\u884C\u5B8C\u6210',
    reset: '\u91CD\u7F6E',
    reviewed_by: '\u5BA1\u67E5\u8005',
    project_prefix: '\u9879\u76EE\uFF1A',
    badges: {
      long_running: '\u957F\u65F6\u95F4\u8FD0\u884C',
    },
    operation_failed: '\u64CD\u4F5C\u5931\u8D25',
    stats_unavailable: '\u7EDF\u8BA1\u6570\u636E\u4E0D\u53EF\u7528\uFF08\u6743\u9650\u4E0D\u8DB3\uFF09',
    rollback_button: '回滚（已停用）',
    rollback_disabled_reason: '旧回滚会撤销共享工作区内同一时段的全部提交，无法确认只撤回本提案，已停用。需要撤回时请发起人工撤回提案。',
  },

  // ── Onboarding (M1: OnboardingPage / OnboardingSetupWizard / AcceptInvitePage) ──
  onboarding: {
    // OnboardingPage — three-pane chooser
    chooser: {
      brand_loading: '加载中',
      welcome_title: '欢迎加入 Conductor',
      welcome_desc:
        '您当前未归属任何组织。请选择以下一种方式开始 —— 邀请码、白名单匹配, 或创建您自己的工作区。',
      // Pane 1: invite code
      invite_icon_label: '邀请码',
      invite_title: '使用邀请码加入',
      invite_desc: '有组织管理员给您的邀请码? 输入即可加入。',
      invite_label: '邀请码',
      invite_placeholder: '粘贴邀请码',
      invite_redeeming: '核销中…',
      invite_submit: '加入组织',
      // Pane 2: whitelist (placeholder)
      whitelist_title: '白名单匹配',
      whitelist_badge: '即将推出',
      whitelist_desc:
        '如果您的邮箱属于已注册组织的域名, 管理员审核后将自动添加。请联系您的组织管理员邀请您。',
      whitelist_learn_more: '了解更多 →',
      // Pane 3: self-serve
      self_serve_title: '创建您的工作区',
      self_serve_desc: '立即开始 14 天免费试用, 默认接入 Claude 模型, 无需信用卡。',
      self_serve_slug_label: '工作区标识 (slug)',
      self_serve_slug_placeholder: 'my-workspace',
      self_serve_slug_hint:
        '小写字母 / 数字 / 短横线, 1-50 字符 (例: mayfair-hq), 创建后不可修改',
      self_serve_name_label: '显示名称 (可选)',
      self_serve_name_placeholder: '留空则使用「您的姓名的工作区」',
      self_serve_creating: '创建中…',
      self_serve_submit: '创建工作区',
      self_serve_note:
        '试用账户仅可创建 1 个工作区, 享 14 天免费试用; 付费账户 (标准 / 企业版) 可创建多个工作区, 新增工作区无试用期、须付费后启用并单独计费。24 小时内最多创建 3 个工作区。',
      // Slug validation (computed in component)
      slug_too_long: '最长 50 个字符',
      slug_invalid: '仅小写字母 / 数字 / 短横线, 首字符须为字母或数字',
      // Toast / result messages (parameterized)
      joined: '已加入「{org}」({role})',
      role_admin: '管理员',
      role_member: '成员',
      created_pending_payment:
        '「{name}」已创建。新增工作区无试用期, 为独立订阅实体, 需付费后启用',
      created_with_trial: '「{name}」已创建 (试用期至 {date})',
      created_no_trial: '「{name}」已创建',
      // Redeem error messages
      err_redeem_generic: '邀请码核销失败, 请重试',
      err_redeem_404: '邀请码不存在',
      err_redeem_410: '邀请码已过期',
      err_redeem_409: '邀请码已使用完, 或您已是成员',
      err_redeem_403: '此邀请码与您的账号 (邮箱/企业微信) 不匹配',
      // Create error messages
      err_create_generic: '创建工作区失败, 请重试',
      err_create_429: '24 小时内最多创建 3 个工作区, 请稍后再试',
      err_create_quota: '试用账户仅可创建 1 个工作区, 升级付费账户后可创建更多',
      err_create_409: 'Slug 已被占用, 请换一个',
      err_create_400: 'Slug 格式不正确',
    },
    // OnboardingSetupWizard — post-registration guided setup
    wizard: {
      loading: '加载中',
      progress_nav: '向导进度',
      step_invite: '1. 邀请同事',
      step_project: '2. 建首个项目',
      step_done: '3. 完成',
      invite_title: '邀请同事',
      invite_desc:
        '您可以现在邀请团队成员加入工作区，也可以稍后在组织设置中邀请。此步骤可跳过。',
      invite_skip: '跳过此步骤',
      project_title: '建首个项目',
      project_desc: '创建您的第一个项目，开始使用 Conductor 进行 AI 辅助开发或团队协作。',
      done_title: '设置完成',
      done_desc: '工作区已配置完毕。您现在可以开始使用 Conductor 了。',
      done_enter: '进入工作区',
    },
    // AcceptInvitePage — public invite redemption form
    accept: {
      // QR landing section
      landing_title: '邀请你加入',
      landing_subtitle_prefix: '邀请人',
      landing_subtitle_suffix: '邀请你加入其团队组织，一起使用 Conductor 协同工作。',
      highlight_multi: '一处对话，统一指挥多项目智能体',
      highlight_secure: '组织级权限与配额，安全可控',
      highlight_fast: '免安装，扫码即用，几分钟上手',
      landing_cta: '立即加入 →',
      landing_self_serve_subtitle: '创建您的专属工作区，几分钟即可上手 Conductor。',
      landing_self_serve_cta: '立即创建 →',
      // FORK A: self-serve workspace creation
      self_serve_title: '创建您的工作区',
      self_serve_subtitle: '填写以下信息，创建账号并开始您的专属工作区。',
      self_serve_submitting: '创建中…',
      self_serve_submit: '创建账号并开始',
      // FORK A: create-own-workspace dual entry (choose / login)
      self_serve_choose_subtitle: '创建一个全新的工作区，选择适合您的方式开始。',
      self_serve_choose_register_title: '注册新账号',
      self_serve_choose_register_desc: '还没有账号？注册并创建您的第一个工作区。',
      self_serve_choose_login_title: '使用已有账号',
      self_serve_choose_login_desc: '已有账号？登录后再创建一个新的工作区。',
      self_serve_choose_footnote: '每个工作区独立计费，可分别管理成员与项目。',
      self_serve_login_title: '登录并创建工作区',
      self_serve_login_subtitle: '使用已有账号登录，为其创建一个新的工作区。',
      self_serve_name_label: '工作区名称',
      self_serve_name_placeholder: '例如：我的团队',
      self_serve_slug_label: '工作区标识',
      self_serve_slug_placeholder: '例如：my-team（小写字母、数字、连字符）',
      self_serve_login_submitting: '登录并创建中…',
      self_serve_login_submit: '登录并创建工作区',
      self_serve_login_err_slug:
        '工作区标识格式无效，请使用小写字母、数字或连字符（最多 50 个字符）。',
      self_serve_login_err_409: '该工作区标识已被占用，请更换一个。',
      self_serve_login_err_429:
        '您在 24 小时内创建的工作区过多，请稍后再试。',
      self_serve_login_err_generic: '登录或创建工作区失败，请稍后重试。',
      // FORK B: bound-channel join
      bound_title: '加入组织',
      bound_subtitle: '您已通过企业渠道受邀，填写基本信息即可完成注册。',
      bound_hint_prefix: '此邀请通过',
      bound_hint_suffix: '渠道发送，无需填写邮箱或手机验证码。',
      bound_submitting: '提交中…',
      bound_submit: '创建账号并加入',
      // FORK C: legacy OTP form
      title: '加入组织',
      subtitle: '填写以下信息以创建账号并加入组织。',
      bound_email_hint: '此邀请已绑定邮箱，请使用受邀邮箱完成注册。',
      bound_sms_hint: '此邀请已绑定手机号，请使用受邀手机号完成注册。',
      // Shared form fields
      username_label: '用户名 *',
      username_placeholder: '小写字母/数字，至少 8 位',
      password_label: '密码 *',
      password_placeholder: '至少 8 位，需含字母和数字',
      display_name_label: '姓名 (可选)',
      display_name_placeholder: '真实姓名 / 昵称',
      email_label: '邮箱',
      email_label_required: '邮箱 *',
      email_label_optional: '邮箱 (可选)',
      email_placeholder: 'name@example.com',
      phone_label: '手机号',
      phone_label_required: '手机号 *',
      phone_placeholder: '手机号码',
      channel_label: '验证渠道',
      channel_locked_email: '邮箱（邀请已绑定）',
      channel_locked_sms: '短信（邀请已绑定）',
      channel_email: '邮箱',
      channel_sms: '短信',
      otp_label: '验证码',
      otp_placeholder: '输入收到的验证码',
      otp_sending: '发送中…',
      otp_resend: '重新发送',
      otp_resend_countdown: '重新发送 ({seconds}s)',
      otp_send: '发送验证码',
      submitting: '提交中…',
      submit: '创建账号并加入',
      // Validation hints
      hint_username_empty: '请输入用户名',
      hint_username_space: '用户名不能包含空格',
      hint_username_format: '用户名需为 8-50 个字符，只能包含小写字母、数字及 . _ @ + - 符号',
      hint_username_checking: '正在检查可用性…',
      hint_username_available: '该用户名可用',
      hint_username_taken: '该用户名已被使用，请换一个',
      hint_password_short: '密码至少需要 8 个字符',
      hint_password_format: '密码必须同时包含字母和数字',
      err_no_contact: '请至少填写邮箱或手机号',
      err_invalid_email: '请输入有效的邮箱地址',
      err_invalid_phone: '请输入有效的手机号',
      otp_sent_email: '验证码已发送至邮箱，请查收。',
      otp_sent_sms: '验证码已发送至手机，请查收。',
      err_send_otp: '验证码发送失败，请重试',
      // Error helper (extractError)
      err_missing_code: '邀请链接无效：缺少邀请码。',
      err_404: '邀请码不存在或已失效',
      err_410: '邀请码已过期',
      err_409: '邀请码已被使用，或该账号已存在',
      err_403: '验证失败 — 请确认验证码与联系方式正确',
      err_422: '请求字段不符合要求',
      err_500: '服务暂时不可用，请稍后重试',
      err_join_fallback: '加入失败，请重试',
      // FORK C dual-CTA — 注册新账户 / 以已有账户登录加入 (P-COND-8D5436930B90)
      choose_subtitle: '请选择加入此组织的方式。',
      choose_register_title: '注册新账户',
      choose_register_desc: '我是新用户，创建账号并加入。',
      choose_login_title: '以已有账户登录加入',
      choose_login_desc: '我已有 Conductor 账号，登录后加入此组织。',
      choose_footnote: '无论哪种方式，加入时都会复核手机/邮箱与邀请绑定一致。',
      back_to_choose: '← 返回，重新选择加入方式',
      // FORK C login (以已有账户登录加入)
      login_title: '登录加入',
      login_subtitle: '使用已有账户登录，登录后即可加入此组织。',
      login_username_label: '用户名 *',
      login_username_placeholder: '输入您的用户名',
      login_password_label: '密码 *',
      login_password_placeholder: '输入您的密码',
      login_submitting: '登录并加入中…',
      login_submit: '登录并加入',
      login_err_username: '请输入用户名',
      login_err_password: '请输入密码',
    },
  },

  // ── Sub-Agent (M2: SubAgentDrawer / SubAgentCard) ────────────────
  subagent: {
    drawer_title: '子智能体',
    empty: '暂无子智能体活动',
    status_running: '运行中',
    status_completed: '已完成',
    status_failed: '已失败',
    status_pending: '等待中',
    turns: '轮次',
    duration: '耗时',
    tokens: 'Token',
    cost: '费用',
    view_trace: '查看追踪',
    tool_calls: '工具调用',
    started_at: '开始时间',
    model: '模型',
    strip_title: '子代理',
    state_running: '运行中',
    state_finished: '已完成',
    roster_title: '子代理',
    roster_aria: '子代理花名册',
    roster_list_aria: '子代理列表',
    close: '关闭',
    roster_empty: '（暂无子代理）',
    placeholder: '选择一个子代理查看其过程',
    no_text_output: '（无文本输出）',
  },

  // ── Trace View (M2: TraceView) ───────────────────────────────────
  trace: {
    title: '执行追踪',
    empty: '暂无追踪事件',
    tool: '工具',
    input: '输入',
    output: '输出',
    result: '结果',
    error: '错误',
    thinking: '思考',
    expand: '展开',
    collapse: '收起',
    copy: '复制',
    copied: '已复制!',
    step: '步骤',
    steps_title: '执行步骤',
    stream_reconnecting: '由于网络问题，实时输出暂时中断，正在自动重连…',
    stream_interrupted: '实时连接中断，执行状态待确认',
    stream_recovering: '正在恢复实时连接…',
    stream_recover: '恢复实时连接',
    stream_content_error: '部分实时内容无法处理，正在继续接收',
    view_process: '查看研究过程',
    collapse_process: '收起研究过程',
    loading_process: '正在加载研究过程',
    load_failed: '加载研究过程失败',
    segment_suffix: '过程片段（只读回放）',
    empty_replay: '暂无可回放的过程（可能已过期）',
    footnote: '最终答案在上方对话气泡中单独显示（不在此时间线内）',
    main_text: '主代理 · 文本',
    sub_prefix: '子代理 · ',
    tool_call: '工具调用',
    status_done: '完成',
    status_error: '失败',
    status_running: '运行中',
    main_done: '主代理 · 结束',
    sub_done_suffix: ' · 结束',
    expired: '已过期',
    not_recorded: '未记录过程',
    load_more: '加载更多',
    head_truncated: '本轮前段过程较长已省略',
  },

  // ── Live stream (ST3: StreamingMessage truncation notice) ─────────
  stream: {
    truncated_notice: '前面的过程较长已省略',
    view_full: '查看完整过程',
  },

  // ── Stage (M3: StageProgressBar / StageAdvanceCard) ──────────────
  stage: {
    advance_title: '推进到下一阶段',
    advance_confirm: '确认推进',
    advancing: '推进中…',
    cancel: '取消',
    current_stage: '当前阶段',
    next_stage: '下一阶段',
    advance_hint: '推进阶段需要 full_autonomy 审批，且仅项目所有者可执行。',
    labels: {
      planning: '规划',
      requirements: '需求',
      design: '设计',
      implementation: '实施',
      testing: '测试',
      review: '评审',
      done: '完成',
      stage0: 'Stage 0（反向理解）',
      stage1: 'Stage 1',
      stage2: 'Stage 2',
    },
    short_labels: {
      planning: '规划',
      requirements: '需求',
      design: '设计',
      implementation: '实施',
      testing: '测试',
      review: '评审',
      done: '完成',
    },
    // StageProgressBar (M3) — S0-S4 短段标签，按后端 planning-stage 枚举键，
    // 以及进度条 aria-label。
    progress_aria: '项目阶段进度',
    progress: {
      planning_comprehension: 'S0 理解',
      planning_requirements: 'S1 需求',
      planning_product: 'S2 产品',
      planning_technical: 'S3 技术',
      planning_implementation: 'S4 实施',
    },
    // StageAdvanceCard (M3) — 各阶段完整文案，按后端 planning-stage 枚举键
    // （对应 new_project.py::STAGE_LABELS_ZH）。
    descriptions: {
      planning_comprehension: '阶段零：理解既有项目',
      planning_requirements: '阶段一：用户需求',
      planning_product: '阶段二：产品方案',
      planning_technical: '阶段三：技术方案',
      planning_implementation: '阶段四：实施计划',
    },
    // StageAdvanceCard (M3) — 推进确认卡控件。{label} 插值为本地化的
    // 当前/下一阶段标签。
    advance: {
      ready_title: '{label} 已达标，可进入下一阶段',
      summary_hint: '本阶段已收集字段摘要：',
      confirm_label: '确认进入「{label}」',
      decline_label: '继续完善本阶段',
      note: '点击确认等价于直接输入 yes；继续对话将自动收起本卡片。仅在后端 stage_confirm 信号存在时显示。',
    },
  },

  // ── Modals (M5a project/member modals + M5b org modals) ──────────
  modals: {
    // Shared error messages (reused across modals)
    err_field_invalid: '请求字段不符合要求',
    err_service_unavailable: '服务暂时不可用，请稍后重试',

    // P-COND-4E646C4E5E39 Sub-Task 4 — 「申请接入其他组织」 two-step dialog.
    // 中文文案与设计稿逐字一致（SOLE 设计契约）：
    //   planning/design/_sessions/31bfa815/P-COND-6D957190C0D9/org-grant-apply-dialog.html
    orgGrantApply: {
      title: '申请接入其他组织',
      hint: '请输入对方组织的唯一标识（slug），由对方管理员提供。组织名称可能重复，系统只以 slug 精确定位。',
      slug_label: '组织标识 slug',
      slug_placeholder: '例如 the-mayfair',
      resolving: '正在查找…',
      confirm_label: '已找到，请确认目标组织：',
      confirm_meta: 'slug：{slug} · 状态：{status}',
      // 设计稿红色 .err 框文案，逐字不可改。
      not_found: '未找到该组织标识。请向对方管理员核对 slug 的准确拼写。',
      reason_label: '申请事由',
      reason_placeholder: '说明用途，便于对方管理员判断',
      cancel: '取消',
      submit: '确认发送申请',
      submitting: '发送中…',
      // 查找阶段的非 404 失败：与拼写无关，单独措辞，避免用户白找拼写错误。
      err_403: '仅组织管理员可发起接入申请。',
      err_resolve_generic: '查找失败，请稍后重试。',
      // 发送阶段的失败，按后端 orgs.py::create_org_grant 的状态码分支。
      err_400_self: '不能申请接入本组织自身。',
      err_409: '已存在待确认或已生效的授权，无需重复申请。',
      err_404_submit: '目标组织不存在，或你不是本组织的管理员。',
      err_422: '请求字段不符合要求。',
      err_500: '服务暂时不可用，请稍后重试。',
      err_generic: '发送失败，请稍后重试。',
    },

    // M5a — CreateProjectModal
    createProject: {
      title: '新建项目',
      footer_cancel: '取消',
      footer_creating: '创建中…',
      footer_submit: '创建并开始 onboarding',
      name_label: '项目名称 *',
      name_placeholder: '例: 德高信集团',
      name_hint: '支持中文，≤100 字符；同一组织内唯一。系统会自动生成一个英文标识符用于派单与文件路径。',
      name_invalid: '项目名称不能为空，且不超过 100 字符',
      desc_label: '项目描述',
      desc_placeholder: '一句话说明项目用途',
      type_label: '项目类型 *',
      type_aria: '项目类型',
      type_hint_collab: '协作项目：面向多部门知识协作 — 上传规范/SOP、沉淀知识库、起草部门文档；无代码分支，开箱即用。',
      type_hint_dev: '开发项目：面向代码开发 — git 分支生命周期默认关闭，可在项目设置中开启。',
      collab_tier_label: '协同复杂度',
      collab_tier_aria: '协同复杂度',
      departments_label: '参与部门',
      departments_aria: '参与部门',
      departments_hint:
        '勾选的部门会各自获得独立的工作目录与写入权限；不做修改则默认全部加入。',
      origin_label: '项目来源 *',
      origin_aria: '项目来源',
      origin_hint: '接管已有项目将先进入 Stage-0 反向理解阶段，吸收已有代码与资料。',
      ingest_label: '资产接入方式',
      ingest_aria: '资产接入方式',
      git_url_label: 'Git 仓库地址 *',
      git_url_placeholder: '例: git@codeup...',
      git_url_required: 'Git 克隆需要填写仓库地址',
      ingest_hint: '资产接入仅支持本机 (local) 项目；远程项目请用项目 agent 在创建后接入。',
      access_method_remote_hint: '接入方式默认 ssh_docker；平台管理员可在项目设置中修改。',
      access_method_label: '接入方式 (access_method) *',
      access_method_aria: '接入方式',
      path_label: '项目路径 *',
      path_placeholder_local: '例: /home/ec2-user/myproject',
      path_placeholder_remote: '远程主机上的项目路径...',
      path_hint: '项目根目录路径 (后端必填)',
      ssh_host_label: 'SSH 主机 *',
      ssh_host_placeholder: '例: 18.142.225.133',
      ssh_port_label: 'SSH 端口',
      ssh_port_placeholder: '默认 22 (留空使用默认)',
      ssh_user_label: 'SSH 用户 *',
      ssh_user_placeholder: '例: ec2-user',
      ssh_key_label: 'SSH 私钥路径',
      ssh_key_placeholder: '例: /home/ec2-user/.ssh/id_ed25519 (可选)',
      api_host_label: 'API 隧道主机 *',
      api_host_placeholder: '例: 18.138.213.6 (Windows 主机的 SSH 入口)',
      api_user_label: 'API 隧道用户 *',
      api_user_placeholder: '例: Administrator',
      api_key_label: 'API 隧道私钥路径',
      api_key_placeholder: '可选 — 留空使用默认',
      api_inner_host_label: 'API 主机 (隧道内)',
      api_inner_host_placeholder: '隧道内的 HTTP 服务地址，例: 127.0.0.1 (可选)',
      api_inner_port_label: 'API 端口 (隧道内)',
      api_inner_port_placeholder: '例: 8081 (Windows Flask API 端口，可选)',
      ssh_docker_port_hint: '远程主机的 SSH 端口；其余连接信息可在项目创建后于详情页补充',
      need_approval_label: '实施前需要管理员审批',
      need_approval_yes: '是 — 方案须经管理员审批后才动手实施（推荐）',
      need_approval_no: '否 — 直接执行（仅低风险项目）',
      need_approval_hint_collab: '协作文档可一键回滚，默认免事前审批（可改回需要审批）',
      need_approval_hint_dev: '推荐开启：先出方案 → 管理员审批 → 再动手实施',
      default_tier_label: '组织成员默认权限',
      tier_deny: '禁止（不向组织成员开放）',
      tier_read_only: '只读（组织成员可查看内容）',
      tier_code_changes: '可编辑（组织成员可修改代码）',
      default_tier_hint:
        '控制未被单独邀请的组织成员对本项目的默认访问权限。可在项目管理中随时更改。',
      // ACCESS_METHODS const
      access_local_title: 'local',
      access_local_desc: 'Conductor 本机项目 (e.g. conductor 本身)',
      access_ssh_agent_title: 'ssh_agent',
      access_ssh_agent_desc: '远程 Linux 主机 (SSH key 鉴权)',
      access_api_title: 'api',
      access_api_desc: 'Windows / 第三方 HTTP API 对接 (通过 SSH 隧道)',
      access_docker_title: 'docker',
      access_docker_desc: '本机 Docker 容器项目',
      access_ssh_docker_title: 'ssh_docker',
      access_ssh_docker_desc: '远程 Linux + Docker 容器 (最常用)',
      access_desktop_title: 'desktop',
      access_desktop_desc: '我的电脑 (Conductor Desktop 守护进程，工具在本机执行)',
      // PROJECT_TYPES const
      type_collab: '工作协同',
      type_dev: '代码开发',
      // ORIGINS const
      origin_new_title: '全新',
      origin_new_desc: '全新项目，从零开始',
      origin_takeover_title: '接管已有',
      origin_takeover_desc: '接管已有代码 / 资料，先进行反向理解',
      // COLLAB_TIERS const
      tier_simple_title: '简单',
      tier_simple_desc: '仅 Stage 1，创建即可用',
      tier_general_title: '通用',
      tier_general_desc: 'Stage 1-2 协同 onboarding',
      // INGEST_METHODS const
      ingest_existing_title: '选择已有路径',
      ingest_existing_desc: '就地理解已存在的资产 (不复制)',
      ingest_git_title: 'Git 克隆',
      ingest_git_desc: '一次性克隆远程仓库到项目路径',
      // M1–M3 分步向导 (P-COND-6FF093311B58)
      // 文案来源: planning/design/_sessions/547a068b/P-COND-6FF093311B58/
      //           create-project-wizard-v2-step1.html
      wizard: {
        // 步骤标题 / 副标题
        step_type_title: '这个项目用来做什么？',
        step_type_desc: '选择最符合团队需求的工作方式，AI 能力和引导流程会据此调整',
        step_collab_config_title: '配置你的协作空间',
        step_collab_config_desc: '填写基本信息，完成后即可创建',
        step_dev_git_title: 'Git 版本控制',
        step_dev_git_desc:
          'Git 记录每次变更历史，支持分支工作流与审批；没有现成仓库也可跳过，创建后随时开启',
        step_dev_env_title: '开发环境',
        step_dev_env_desc: '选择代码运行的服务器环境；Conductor 平台无需配置，适合快速启动新项目',
        step_dev_confirm_title: '确认创建',
        step_dev_confirm_desc: '请确认以下配置，创建后可在项目设置中随时修改',
        // 步骤条 + 导航按钮
        bar_step_of: '第 {current} 步，共 {total} 步',
        nav_back: '← 上一步',
        nav_next: '下一步 →',
        nav_create: '✓ 创建项目',
        // 类型卡片
        card_collab_title: '协作空间',
        card_collab_desc: 'AI 直接读写内容，适合知识管理、设计创作、法务合规等非代码场景',
        card_collab_badge: '非代码场景',
        card_collab_chip_1: '知识库',
        card_collab_chip_2: '设计创作',
        card_collab_chip_3: '法务合规',
        card_collab_chip_4: '行业模板',
        card_dev_title: '代码开发',
        card_dev_desc: '完整工程管理体系，适合团队协作开发与全周期项目管控',
        card_dev_badge: '工程化开发',
        card_dev_chip_1: '版本控制',
        card_dev_chip_2: '多 Agent',
        card_dev_chip_3: '全周期管理',
        card_dev_chip_4: '开箱即用',
        // 亮点展开面板
        feats_expand: '了解亮点',
        feats_collapse: '收起亮点',
        feats_collab_1: 'AI 直读写 — 内容即时同步，无需手动导入',
        feats_collab_2: '行业模板 — 预配角色与技能集，开箱即用',
        feats_collab_3: '权限隔离 — 多部门独立知识空间',
        feats_collab_4: '版本快照 — 每次变更自动留痕',
        feats_dev_1: '全周期管理 — 开发·测试·运维一体',
        feats_dev_2: '开发管理体系 — Pre-read · 多 Agent 协同',
        feats_dev_3: '完整留痕沉淀 — 日志·历史·经验自动归档',
        feats_dev_4: '无经验友好 — 向导引导，开箱即用',
        // devConfirm 只读汇总
        confirm_section_basic: '基本信息',
        confirm_section_git: '版本控制',
        confirm_section_env: '开发环境',
        confirm_type: '工作方式',
        confirm_git: 'Git 来源',
        confirm_env: '环境类型',
        confirm_access: '接入方式',
        confirm_approval: '审批要求',
        confirm_note: '所有配置均可在创建后的「设置」页随时修改，不影响已有工作内容。',
        confirm_name_label: '项目名称 *',
        confirm_desc_label: '项目描述',
        // #s2c 模板选择步骤 (P-COND-F165C3ECC9FC)
        step_template_select_title: '选择项目模板',
        step_template_select_desc: '模板已预配 AI 角色和技能集，开箱即用；通用模板适合完全自定义',
        tpl_generic_title: '通用协作空间',
        tpl_generic_desc: '基础 AI 助手能力，不预设行业角色。适合已有工作流程或需要完全自定义的团队。',
        tpl_generic_badge: '通用',
        tpl_generic_chip_1: '完全自定义',
        tpl_generic_chip_2: '通用技能集',
        tpl_generic_chip_3: '灵活配置',
        tpl_overseas_title: '出海企业模板',
        tpl_overseas_desc: '为出海东南亚/中东/欧洲中小企业预配置：市场调研、多语言内容、合规初筛全流程',
        tpl_overseas_badge: '行业模板',
        tpl_overseas_chip_1: '✓ 8 个预置技能',
        tpl_overseas_chip_2: '✓ 3 份共享知识库',
        tpl_overseas_chip_3: '✓ 出海顾问角色',
        tpl_overseas_coming_soon: '即将上线',
        // #s2d Git 版本控制（开关 + 托管选择）
        git_toggle_label: '启用 Git 版本控制',
        git_conductor_title: 'Conductor 托管',
        git_conductor_badge: '推荐新项目',
        git_conductor_desc: '平台自动管理版本库，无需配置仓库地址或密钥，开箱即用',
        git_external_title: '外部仓库',
        git_external_badge: '需要配置',
        git_external_desc: '支持 GitHub · GitLab · Gitee · Codeup 及任意 Git 服务',
        git_off_info: '不启用 Git 仍可使用 AI 代码协作功能；可在项目创建后的「设置」页随时开启。',
        git_url_label_ext: '仓库地址（SSH 或 HTTPS）',
        // #s3d 开发环境（三选项）
        env_conductor_title: 'Conductor 平台',
        env_conductor_badge: '推荐',
        env_conductor_desc: '平台自动分配服务器资源，无需 SSH 配置或服务器管理经验',
        env_linux_title: '自有 Linux 服务器',
        env_linux_desc: '通过 SSH 连接你管理的 Linux 主机（支持所有主流发行版）',
        env_desktop_title: '我的电脑（Conductor Desktop）',
        env_desktop_desc: '在自己的电脑上运行 Conductor Desktop 守护进程，由它连接平台；代码与文件始终留在本机',
        env_desktop_path_placeholder: 'C:\\Users\\me\\projects\\myapp 或 /Users/me/projects/myapp',
        env_desktop_path_hint: '填你电脑上的项目目录；实际可读写范围由 Desktop 端的授权策略再次限定',
        env_windows_title: 'Windows 服务器',
        env_windows_badge: '即将支持',
        env_windows_desc: 'Windows 环境支持正在开发中，敬请期待',
        env_nonadmin_hint: '请联系平台管理员配置服务器连接信息',
        // #s4d 确认步骤新增文案
        confirm_git_conductor: '✓ Conductor 托管',
        confirm_git_external: '✓ 外部仓库',
        confirm_git_off: '未启用',
        confirm_env_conductor: '✓ Conductor 平台',
        confirm_env_linux: '✓ 自有 Linux 服务器',
        confirm_env_desktop: '✓ 我的电脑（Conductor Desktop）',
        confirm_note_ibox: '💡 所有配置均可在创建后的「设置」页随时修改，不影响已有工作内容。',
        // Git 认证字段 (P-COND-6AA599A6D939)
        git_auth_method_label: '认证方式',
        git_auth_ssh_key: 'SSH 密钥',
        git_auth_ssh_key_badge: '安全推荐',
        git_auth_token: 'Token',
        git_auth_token_badge: 'HTTPS 访问',
        git_auth_password: '密码',
        git_auth_password_badge: '用户名+密码',
        git_key_label: 'SSH 私钥',
        git_key_types: 'RSA · Ed25519 · ECDSA 均支持',
        git_key_upload: '上传文件',
        git_key_paste: '粘贴内容',
        git_key_path: '填写路径',
        git_key_upload_hint: '点击上传私钥文件（id_rsa · id_ed25519 · *.pem）',
        git_key_paste_placeholder: '-----BEGIN OPENSSH PRIVATE KEY-----\n（粘贴完整私钥内容）\n-----END OPENSSH PRIVATE KEY-----',
        git_key_path_placeholder: '~/.ssh/id_ed25519',
        git_key_path_hint: '填写 Conductor 服务器上私钥文件的绝对路径',
        git_key_detected: '已检测到私钥',
        git_token_placeholder: 'GitHub: ghp_xxxx · GitLab: glpat-xxxx · Codeup: ...',
        git_username_label: '用户名',
        git_password_label: '密码',
        git_pwd_warning: '⚠️ GitHub · GitLab · Gitee 等主流平台已停用密码登录，强烈建议改用 Token',
        git_proto_ssh: '🔒 SSH 协议',
        git_proto_https: '🔗 HTTPS 协议',
        // 开发环境 SSH 私钥 (P-COND-6AA599A6D939)
        env_ssh_key_label: 'SSH 私钥',
        env_ssh_key_types: 'RSA · Ed25519 · ECDSA 均支持',
        env_key_path_placeholder: '~/.ssh/id_ed25519',
      },
    },

    // M5a — AddMemberModal
    addMember: {
      title: '邀请成员加入组织',
      context_line: '你正在以组织管理员身份邀请新成员',
      footer_done: '完成',
      footer_later: '稍后再说',
      footer_cancel: '取消',
      footer_next: '下一步 · 生成邀请链接',
      footer_generating: '生成中…',
      footer_sending: '发送中…',
      // step indicator (P-COND-C7C2FA6D84CD 3-step)
      step_fill: '填写受邀人',
      step_links: '复制邀请链接',
      step_notify: '发送通知',
      // links stage (Requirement 3)
      links_banner:
        '✅ 已生成 {n} 份邀请。可先复制链接转发；点击「发送通知」将同步发送短信 / 邮件。',
      links_hint:
        '对方打开链接即可注册并加入，链接 7 天内有效。即使通知发送失败，此链接同样有效。',
      links_back: '← 返回修改受邀人',
      footer_later_close: '稍后发送，关闭',
      footer_send_notify: '发送通知 →',
      // done stage (Requirement 4)
      done_msg: '通知已发送',
      done_sub: '已向 {n} 位受邀人发送短信 / 邮件通知。对方点击链接即可注册并加入组织。',
      done_sub_fallback: '若通知未送达，受邀人仍可使用上一步复制的链接加入。',
      done_notify_failed:
        '部分通知发送失败，但邀请链接依然有效，可使用上一步复制的链接手动转发。',
      // extractApiError
      err_403: '权限不足 — 仅组织管理员可邀请',
      err_404: '组织不存在或已停用',
      err_409: '组织成员数已达上限，请先提高配额或联系平台管理员',
      err_generic: '邀请失败，请重试',
      // validateRow
      err_contact_empty: '联系方式不能为空',
      err_email_invalid: '邮箱格式无效',
      // links stage copy buttons
      success_copy_link: '复制链接',
      success_copied: '已复制 ✓',
      // input view
      contact_required_hint:
        '仅填写的邮箱 / 手机可接受邀请，作为限定邀约对象 —— 每位受邀人收到各自独立链接，请逐行填写，不能留空。',
      row_switch_hint:
        '📱 默认手机邀请，点击每行左侧图标可切换为邮箱（图标右下角 ⇄ 表示可切换）。右侧可选择受邀人所在部门（可留空）。',
      row_channel_to_email: '当前为手机，点击切换为邮箱',
      row_channel_to_phone: '当前为邮箱，点击切换为手机',
      channel_label: '邀请方式',
      channel_aria: '邀请方式',
      channel_email: '邮箱邀请',
      channel_phone: '手机邀请',
      channel_hint: '系统会向每位受邀人单独发送邀请链接，对方点击后自助加入。',
      grant_months_label: '赠送订阅月数',
      grant_months_hint: '受邀人接受邀请加入后，该组织将获得相应月数的付费订阅；填 0 表示不赠送（保持试用）。',
      invitees_label: '受邀人',
      invitees_count: '已添加 {n} 人',
      invitee_email_placeholder: '例：wangwu@mayfair.cn',
      invitee_phone_placeholder: '例：13800138000',
      contact_aria: '联系方式 {n}',
      remove_row_aria: '移除第 {n} 行',
      add_more: '＋ 再加一位',
      send_failed: '发送邀请至 {contact} 失败：{message}',
      // 3-step flow: step 1 only CREATES the invitation (delivery deferred to
      // step-3 "确认发送"), so a step-1 failure is a CREATE failure, not a send
      // failure — wording must not mislead (P-COND-C7C2FA6D84CD).
      create_failed: '创建 {contact} 的邀请失败：{message}',
      // already an active member of this org (P-COND-B7B74DECF7AA)
      already_member: '{contact} 已加入组织，无需邀请',
      // per-row optional department (P-COND-C7C2FA6D84CD)
      row_dept_none: '不指定',
      row_dept_aria: '部门 {n}',
    },

    // M5a — AddProjectMemberModal
    addProjectMember: {
      title: '添加项目成员',
      footer_cancel: '取消',
      footer_adding: '添加中…',
      footer_add: '添加',
      err_409: '该用户已是本项目的活跃成员。',
      err_400: '该用户不是本组织的活跃成员，无法添加。请先在「组织成员」页邀请。',
      select_label: '从组织成员中选择 *',
      select_placeholder: '— 请选择用户 —',
      select_hint: '仅可从当前组织成员中添加。新成员请先在「组织成员」页邀请。',
      select_unavailable_hint: '（组织成员列表暂不可用，已切换为手动输入 user_id。）',
      manual_placeholder: '输入 user_id',
      role_label: '项目角色 *',
      role_member: '成员 (member)',
      role_owner: '所有者 (owner) — 仅当无现任所有者时',
      tier_label: '权限层级 (permission_tier) *',
      tier_read_only: 'read_only — 只读，仅可使用规划模式（可写规划/文档/测试目录）',
      tier_testing: 'testing — 旧层级（已停用，按 read_only 生效）',
      tier_code_changes: 'code_changes — 可改源码 (需 need_approval 双阶段审批)',
      tier_deploy: 'deploy — 旧层级（已停用，按 read_only 生效）',
      tier_full_autonomy: 'full_autonomy — 完全自治，跳过审批',
      tier_hint: '控制 Claude agent 在此项目可执行的最高操作等级 (Blueprint §5.1)',
      // P-COND-CAAB7244BAE1 Sub-Task 2 — collab 项目上的存量 dev 层级徽标
      tier_legacy_dev_badge: '高级层级（dev 项目层级）',
      denyAccess: '拒绝访问 (access_denied) — 显式禁止该用户访问本项目',
      denyAccessHint:
        '勾选后该用户对本项目被显式拒绝：不再回落到部门、组织管理员或项目默认权限层级。与「移除成员」不同 — 移除会穿透到组织默认层级并重新放行。平台管理员不受此限制。',
      note_label: '备注 (本地存档，不发送)',
      note_placeholder: '例: 负责 {projectId} 项目的前端',
    },

    // M5a — EditProjectMemberModal
    editProjectMember: {
      title: '编辑项目成员',
      footer_cancel: '取消',
      footer_saving: '保存中…',
      footer_save: '保存',
      member_label: '成员',
      role_label: '项目角色 *',
      role_aria: '项目角色',
      role_member: '成员 (member)',
      role_owner: '所有者 (owner)',
      role_hint: '降级项目所有者会被后端拒绝 (409)，请先转移所有权。',
      tier_label: '权限层级 *',
      tier_hint: '权限层级控制 Claude agent 可执行的操作 (read_only → code_changes → full_autonomy)。read_only 仅可使用规划模式。',
      // P-COND-CAAB7244BAE1 Sub-Task 2 — collab 项目上的存量 dev 层级徽标
      tier_legacy_dev_badge: '高级层级（dev 项目层级）',
      // TIER_OPTIONS const
      tier_read_only: 'read_only — 只读，仅规划模式',
      tier_testing: 'testing — 旧层级（已停用，按 read_only 生效）',
      tier_code_changes: 'code_changes — 可改源码',
      tier_deploy: 'deploy — 旧层级（已停用，按 read_only 生效）',
      tier_full_autonomy: 'full_autonomy — 完全自治',
      // P-COND-FACB825338E0 — 显式个人拒绝（独立布尔，非 tier 取值）
      denyAccess: '拒绝访问 (access_denied) — 显式禁止该用户访问本项目',
      denyAccessHint:
        '勾选后该用户对本项目被显式拒绝：不再回落到部门、组织管理员或项目默认权限层级。与「移除成员」不同 — 移除会穿透到组织默认层级并重新放行。平台管理员不受此限制。',
      // extractApiError
      err_400: '角色或权限层级取值无效',
      err_404: '项目或成员不存在 / 已停用',
      err_409: '无法降级项目所有者 — 请先转移所有权',
      err_generic: '保存失败，请重试',
    },

    // M5a — EditMemberRoleModal
    editMemberRole: {
      title: '修改成员角色',
      footer_cancel: '取消',
      footer_saving: '保存中…',
      footer_save: '保存',
      member_label: '成员',
      owner_hint: '所有者角色不可修改 — 如需更换所有者，请使用「转移所有者」流程。',
      role_label: '组织角色 *',
      role_aria: '组织角色',
      role_member: '成员 (member)',
      role_admin: '管理员 (admin)',
      role_hint: '管理员可邀请/移除成员、修改成员资料、转移所有者。降级最后一名管理员会被后端拒绝 (409)。',
      // extractApiError
      err_403: '权限不足 — 仅组织管理员可修改角色',
      err_404: '组织或成员不存在 / 已停用',
      err_409: '无法降级最后一名管理员',
      err_generic: '保存失败，请重试',
    },

    // M5a — EditMemberMetadataModal
    editMemberMetadata: {
      title: '编辑成员信息',
      footer_cancel: '取消',
      footer_saving: '保存中…',
      footer_save: '保存',
      member_label: '成员',
      department_label: '部门',
      title_label: '职务',
      title_placeholder: '例: 高级工程师',
      title_hint: '留空将清除该字段。',
      manager_label: '直属上级',
      manager_none: '无',
      manager_hint: '仅本组织的活跃成员可作为上级。选择"无"将清除该字段。',
      // extractApiError
      err_403: '权限不足 — 仅组织管理员可编辑成员信息',
      err_404: '成员不存在或已被移除',
      err_400: '直属上级必须是本组织的活跃成员',
      err_generic: '保存失败，请重试',
    },

    // M5b — CreateOrgModal
    createOrg: {
      title: '新建组织',
      footer_cancel: '取消',
      footer_creating: '创建中…',
      footer_submit: '创建',
      name_label: '组织名称 *',
      name_placeholder: '例: 新事业部',
      slug_label: 'Slug (URL) *',
      slug_placeholder: '例: new-bu (小写、连字符)',
      slug_hint: '小写字母、数字、连字符；首字符必须是字母或数字 (1-50 字符)',
      slug_auto_hint: '将根据组织名称自动建议；您可手动覆盖',
      slug_invalid: 'Slug 格式无效 — 需匹配 ^[a-z0-9][a-z0-9-]{0,49}$',
      owner_label: '所有者 (将自动添加并赋权)',
      owner_fallback: '当前登录用户',
      owner_hint: '默认为创建人。创建后可通过「转移所有者」更改。',
      banner: '📌 创建后将自动添加您为唯一所有者，并提示您添加至少 1 名 admin 以避免单点锁定 (Blueprint §6.6)。',
      // extractApiError
      err_400_slug: 'Slug 格式无效 — 需小写字母、数字、连字符 (1-50 字符)',
      err_409: 'Slug 已被占用，请换一个',
      err_403: '仅平台管理员可创建组织',
      err_422: '请求字段不符合要求',
      err_500: '服务暂时不可用，请稍后重试',
      err_generic: '创建失败，请重试',
    },

    // M5b — TransferOrgModal
    transferOrg: {
      title: '转移组织所有者 — {name}',
      footer_cancel: '取消',
      footer_submitting: '提交中…',
      footer_send_code: '发送验证码',
      footer_later: '稍后处理',
      footer_next: '下一步',
      footer_done: '完成',
      // step rows
      step_select_title: '选定目标',
      step_select_selected: '已选: {id}',
      step_select_desc: '请选择本组织的现任管理员作为新所有者',
      step_verify_title: '企业微信 IM 双因素验证',
      step_verify_generated: '已生成验证 token，新所有者需在 12 小时内确认',
      step_verify_waiting: '等待您发起 — 后端将生成 12h 有效的转移 token',
      step_confirm_title: '目标用户确认接受',
      step_confirm_desc: '新所有者需在 12 小时内于 WeCom 接受 (POST /api/v1/orgs/{id}/transfer/confirm)',
      // step 1
      warn: '⚠️ 转移成功后您将自动降级为 admin，无法撤销该操作。',
      eligibility_owner: '仅当前所有者可发起转移。',
      eligibility_admin: '仅当前所有者或平台管理员可发起转移。',
      target_label: '目标新所有者 *',
      target_placeholder: '输入目标用户的 user_id',
      target_hint: '成员列表暂不可用 — 请直接填写本组织现任管理员的 user_id。',
      loading: '加载中…',
      select_placeholder: '请选择',
      admin_suffix: '(管理员)',
      target_admin_hint: '仅可转移给现任 admin。普通 member 需先升级为 admin。',
      reason_label: '原因 (可选)',
      reason_placeholder: '说明转移原因 (至少 10 字，便于审计追溯)',
      reason_too_short: '原因至少 10 个字符',
      // step 2
      token_generated: '已生成 12h 转移 token，请转发给新所有者，由其在 WeCom 确认接受。',
      token_label: '转移 Token',
      copy_token_aria: '复制 token',
      copied: '✓ 已复制',
      copy: '复制',
      expires_label: '过期时间',
      // step 3
      submitted: '转移已提交。新所有者收到 token 后在 WeCom 接受，转移即完成。',
      // extractApiError
      err_403: '权限不足 — 仅当前所有者可发起转移',
      err_404: '组织不存在或您无权访问',
      err_400: '目标用户必须是本组织的活跃管理员',
      err_500: '服务暂时不可用，请稍后重试',
      err_generic: '操作失败，请重试',
    },

    // M5b — DeactivateOrgModal
    deactivateOrg: {
      title: '停用组织',
      footer_cancel: '取消',
      footer_submitting: '停用中…',
      footer_submit: '停用组织',
      banner: '停用后组织进入隔离状态，可由平台管理员恢复。',
      name_label: '组织名称',
      impact: '将停用 {projectLabel} 个项目和 {memberLabel} 个成员。',
      confirm_label: '请输入组织名以确认 *',
      confirm_hint: '仅当输入的名称与上方完全一致时，"停用组织" 按钮才会启用。',
      // extractApiError
      err_403: '权限不足 — 仅组织所有者或平台管理员可停用组织',
      err_404: '组织不存在或已停用',
      err_409: '组织已处于停用状态',
      err_500: '服务暂时不可用，请稍后重试',
      err_generic: '停用失败，请重试',
    },

    // M5b — ForceSetOwnerModal
    forceSetOwner: {
      title: '更改组织所有者 — {name}',
      title_no_name: '更改组织所有者',
      footer_cancel: '取消',
      footer_submitting: '更改中…',
      footer_submit: '确认更改',
      hint: '强制将所有权转移给目标用户，目标将自动成为该组织的管理员。',
      owner_label: '新所有者 *',
      loading: '加载用户中…',
      select_placeholder: '— 选择新所有者 —',
      current_suffix: '（当前）',
      load_failed: '用户列表加载失败：{error}',
      reason_label: '变更原因（必填，{min}-{max} 字）*',
      reason_placeholder: '例如：原所有者已离职，由平台管理员紧急接管',
      reason_hint: '将记录到审计日志 platform_admin_force_action（已输入 {n}/{max} 字）',
      reason_invalid: '原因需为 {min}-{max} 字',
      banner: '⚠️ 此操作绕过常规转移确认流程，仅供平台管理员紧急使用。',
    },

    // M5b — RemoveMemberConfirmModal
    removeMember: {
      title: '移除组织成员',
      footer_cancel: '取消',
      footer_submitting: '移除中…',
      footer_submit: '确认移除',
      owner_hint: '所有者不可移除 — 请先通过"转移所有者"流程移交所有权。',
      member_label: '成员',
      role_label: '角色',
      warn: '此操作不可撤销，但成员可被重新邀请。',
      // roleLabel
      role_owner: '所有者',
      role_admin: '管理员',
      role_member: '成员',
      // extractApiError
      err_403: '权限不足 — 仅组织管理员可移除成员',
      err_404: '成员已不存在',
      err_409: '不可移除：所有者或仍有活跃项目归属该成员',
      err_500: '服务暂时不可用，请稍后重试',
      err_generic: '移除失败，请重试',
    },

    // M5b — EditOrgQuotaModal
    editOrgQuota: {
      title: '编辑组织配额',
      footer_cancel: '取消',
      footer_saving: '保存中…',
      footer_save: '保存',
      banner: '留空表示 "不限"。仅平台管理员可执行此操作。',
      project_limit_label: '项目上限',
      project_limit_placeholder: '不限',
      project_limit_invalid: '必须为非负整数（或留空表示不限）。',
      member_limit_label: '成员上限',
      token_budget_label: '月度 Token 预算 (USD)',
      token_budget_invalid: '必须为非负数字（或留空表示不限）。',
      derived_label: '派生额度（按月度自动计算）',
      derived_hint: '日额度 = 月额度 / 10；周额度 = 月额度 / 2。',
      derived_hint_live: '日额度 = 月额度 / 10 = {daily} · 周额度 = 月额度 / 2 = {weekly}',
      subscribe_title: '订阅 / 升级',
      current_tier: '当前套餐：{tier}',
      tier_label: '套餐等级',
      period_label: '订阅周期',
      subscribed: '已订阅',
      upgraded: '已升级',
      submitting: '提交中…',
      submit: '确认订阅 / 升级',
      price_prefix: ' · 价格 ',
      diff_prefix: ' · 差价 ',
      expiry_prefix: ' · 到期 ',
      expiry_dash: '—',
      // SUBSCRIBE_PERIODS const
      period_monthly: '月度',
      period_quarterly: '季度',
      period_half_year: '半年',
      period_yearly: '年度',
      // extractApiError
      err_403: '权限不足 — 仅平台管理员可编辑配额',
      err_404: '组织不存在',
      err_400: '输入值不合法（不能为负数或非数字）',
      err_500: '服务暂时不可用，请稍后重试',
      err_generic: '保存失败，请重试',
    },
  },

  // ── Skill Picker Panel ───────────────────────────────────────────
  skillPicker: {
    title: '\u6280\u80fd\u7ba1\u7406',
    sheetTitle: '技能管理',
    openCenter: "打开技能中心",
    footerHint: "点选技能 · 一次选用一个",
    plusTitle: "技能管理",
    plusAria: "打开技能管理面板",
    movedHint: "新建必装技能已移到「项目详情 → 项目技能」",
    installMore: "去技能中心安装更多技能",
    emptyInstalled: "还没有可用的技能，可以去技能中心安装",
    source: {
      mandatory: "必选",
      project: "项目技能",
      mine: "我的技能",
      installed: "{source} · 已安装",
    },
    close: '\u5173\u95ed',
    tabs: {
      inPicker: "可用技能",
      platform: '\u5e73\u53f0\u6280\u80fd',
      orgProject: '\u7ec4\u7ec7/\u9879\u76ee',
      favorites: '\u2605 \u6536\u85cf',
    },
    search: {
      placeholder: '\u641c\u7d22\u6280\u80fd\u540d\u79f0\u6216\u63cf\u8ff0...',
      ariaLabel: '\u641c\u7d22\u6280\u80fd',
    },
    loading: '\u52a0\u8f7d\u4e2d...',
    groups: {
      defaultActive: '\u9ed8\u8ba4\u6fc0\u6d3b \u00b7 Default',
      optional: '\u53ef\u9009\u5b89\u88c5 \u00b7 Optional',
      noMatch: '\u65e0\u5339\u914d\u6280\u80fd',
      admin: '\u7ba1\u7406\u5458\u547d\u4ee4 \u00b7 Admin',
      commands: '\u901a\u7528\u547d\u4ee4',
    },
    badges: {
      activated: '\u5df2\u6fc0\u6d3b',
      selected: '\u5df2\u9009\u7528',
      mandatory: '\u5f3a\u5236',
      default: '\u9ed8\u8ba4',
    },
    mandatory: {
      empty: '\u6682\u65e0\u5f3a\u5236\u6280\u80fd',
      create: '\uff0b \u521b\u5efa\u5f3a\u5236\u6280\u80fd',
      slugPlaceholder: 'slug (\u5b57\u6bcd\u6570\u5b57\u548c\u8fde\u5b57\u7b26)',
      descPlaceholder: '\u63cf\u8ff0 (\u53ef\u9009)',
      contentPlaceholder: 'SKILL.md \u5185\u5bb9',
      creating: '\u521b\u5efa\u4e2d...',
      createBtn: '\u521b\u5efa',
      errConflict: '名称已被平台技能或系统命令保留，或该技能已存在，请换一个名称',
      errInvalid: '名称格式不正确：只能用小写字母、数字和连字符',
      errGeneric: '操作失败，请稍后重试',
      errPlatformDelete: '平台技能不能在这里删除，请改用停用',
      cancel: '\u53d6\u6d88',
      delete: '\u5220\u9664',
    },
    favorites: {
      empty: '\u6536\u85cf\u6280\u80fd\u540e\u5c06\u51fa\u73b0\u5728\u5de5\u5177\u680f\u4e2d',
      unpinAriaLabel: '\u53d6\u6d88\u6536\u85cf {slug}',
      pinAriaLabel: '\u6536\u85cf {slug}',
    },
    install: {
      required: '\u5fc5\u88c5',
      installed: '\u2713 \u5df2\u5b89\u88c5',
      install: '\uff0b \u5b89\u88c5',
    },
    tip: '\u70b9\u51fb\u6280\u80fd\u884c = \u9009\u7528\uff08\u672c\u6b21\u53d1\u9001\uff09 \u00b7 \u2605 = \u6536\u85cf\u5230\u5de5\u5177\u680f',
    legend: {
      install: '\u5b89\u88c5=\u5199\u5165\u9879\u76ee\u6587\u4ef6',
      mandatory: '\ud83d\udd12=\u7ba1\u7406\u5458\u5f3a\u5236',
      favorites: '\u2605=\u6536\u85cf\u5230\u5de5\u5177\u680f',
    },
    removeFromToolbar: '\u4ece\u5de5\u5177\u680f\u79fb\u9664 /{cmd}',
    addToToolbar: '\u6dfb\u52a0 /{cmd} \u5230\u5de5\u5177\u680f',
    clickToDeselect: '\u70b9\u51fb\u53d6\u6d88\u9009\u7528 /{slug}',
    clickToSelect: '\u70b9\u51fb\u9009\u7528 /{slug}\uff08\u672c\u6b21\u53d1\u9001\uff09',
  },

  // ── Shared helper error fallbacks (hooks/services) ───────────────
  errors: {
    conversation: {
      load_failed: '\u52A0\u8F7D\u5BF9\u8BDD\u5931\u8D25\u3002',
      timeout: '\u8BF7\u6C42\u8D85\u65F6\uFF0C\u8BF7\u91CD\u8BD5\u3002',
      network: '\u7F51\u7EDC\u8FDE\u63A5\u65AD\u5F00\uFF0C\u8BF7\u68C0\u67E5\u7F51\u7EDC\u3002',
      server: '\u670D\u52A1\u5668\u9519\u8BEF\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002',
      forbidden: '\u65E0\u6743\u8BBF\u95EE\u3002',
      not_found: '\u5BF9\u8BDD\u672A\u627E\u5230\u3002',
    },
    project: {
      invalid: '\u8BF7\u6C42\u53C2\u6570\u65E0\u6548',
      forbidden_admin_only: '\u4EC5\u7EC4\u7EC7\u7BA1\u7406\u5458\u6216\u5E73\u53F0\u7BA1\u7406\u5458\u53EF\u6267\u884C\u6B64\u64CD\u4F5C',
      not_found: '\u8D44\u6E90\u4E0D\u5B58\u5728\u6216\u60A8\u6CA1\u6709\u8BBF\u95EE\u6743\u9650',
      quota_exceeded: '\u5DF2\u8FBE\u9879\u76EE\u6570\u91CF\u4E0A\u9650\uFF0C\u8BF7\u8054\u7CFB\u5E73\u53F0\u7BA1\u7406\u5458\u63D0\u5347\u914D\u989D',
      name_conflict: '\u9879\u76EE\u540D\u5DF2\u5B58\u5728\uFF08\u540C\u4E00\u7EC4\u7EC7\u5185\u552F\u4E00\uFF09',
      invalid_fields: '\u8BF7\u6C42\u5B57\u6BB5\u4E0D\u7B26\u5408\u8981\u6C42\uFF08\u68C0\u67E5\u5FC5\u586B\u9879\uFF09',
      unavailable: '\u670D\u52A1\u6682\u65F6\u4E0D\u53EF\u7528\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5',
      generic: '\u64CD\u4F5C\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5',
      create_pending: '项目可能已创建，请关闭后刷新页面确认',
    },
  },
  // ── Proposal layered view (P-COND-DA0631525AC2 ST2) ─────────────
  proposalView: {
    key_points: '方案要点',
    current: '问题背景',
    plan: '解决方案',
    outcome: '预期效果',
    expand_to_view: '展开查看',
    design: {
      title: '设计预览',
      open: '新窗口打开',
      count: '{count} 张设计稿',
    },
    review: {
      approved: '独立审查：已通过',
      approved_sub: '另一个 AI 已逐条核对代码引用',
      issues: '独立审查：发现 {count} 个问题',
      issues_one: '独立审查：发现 1 个问题',
      issues_sub: '批准前请先看一下',
      business_decision: '独立审查：需确认业务决策',
      business_decision_sub: '方案里有需要你拍板的业务选择',
      unknown: '独立审查：无法判定',
      unknown_sub: '复核未得出通过结论，批准前请看明细',
      unreviewed: '独立审查：未完成',
      unreviewed_sub: '本版未经独立复核，请人工判断',
      cancelled: '独立审查：你已停止',
      cancelled_sub: '你停止了本次独立审查，本版未经复核，请人工判断',
      user_decision: '独立审查：无阻断，需你裁决',
      user_decision_sub: '含业务决策，需由你决定',
      notes: '独立审查：通过，附补充意见',
      notes_sub: '没有阻塞问题，建议看一眼',
      none: '未经独立审查',
      details: '查看明细',
      hide_details: '收起明细',
      source: '来源：{origin}',
      source_inline: '来源：{origin} · {model} · 第{rev}版 · {resumed}',
      origin_inline: '边写边审',
      origin_posthoc: '事后复核',
      resumed_yes: '已续接',
      resumed_no: '未续接',
    },
    risk: {
      title: '风险评估',
      low: '低风险',
      mid: '中等风险',
      high: '高风险',
      reversal: '回滚方式',
    },
    lessons: {
      title: '历史教训参考',
      referenced: '已参考 {count} 条',
      avoided: '均已规避',
      na: '不适用',
      skipped: '已跳过',
    },
    checklist: {
      title: '检查清单落实',
      pass: '{count} 通过',
      skip: '{count} 跳过',
      na: '{count} 不适用',
      blocker: '{count} 阻塞',
      freeform: '已填写（非标准格式）',
      show_raw: '显示原始自检文本',
      hide_raw: '收起原始自检文本',
      item: {
        code_refs: '代码引用已核实',
        identifiers: '标识符已核实',
        numbers: '数字已对照源码核实',
        paths: '文件路径已核实',
        minimal: '遵循最小改动原则',
        lessons: '已查阅历史教训',
        flow_impact: '已声明流程影响',
        user_flow: '用户流程复现',
        recurrence: '已对照上一版方案',
        scope: '已给出范围评估',
        design_persist: '设计稿已保存',
        frontend_design: '前端设计稿已提供',
        multi_page: '多页面覆盖已核对',
        content_grep: '引用内容已逐项检索',
        plan_pack: '执行计划路径已声明',
      },
    },
    approach: {
      title: '实施步骤',
      subtasks: '{count} 个子任务',
      flows: '{count} 条流程影响',
      fallback: '展开查看',
      understanding: '需求理解',
      steps: '实施方案',
      flow_impact: '流程影响',
    },
    technical: {
      title: '技术细节（开发参考）',
      sections: '{count} 个章节',
    },
    guidance: {
      pending: '↓ 请在下方审批卡片中操作',
      done: '此方案已处理或已过期',
      neutral: '如需操作，请使用下方审批卡片或输入命令',
    },
    raw_commands: '文字命令（也可直接输入）',
  },
  // ── Proposal approval card (strings for ST3 ProposalApprovalCard) ─
  approvalCard: {
    aria_label: '方案审批卡片',
    title: '方案待你审批',
    title_need_approval: '方案待提交审批',
    revised: '已修改 {count} 次',
    expiry: '{hours} 小时内有效',
    help: '这是什么？',
    help_text: '这是 Agent 为你的任务给出的实施方案。只有你批准后它才会开始改代码；你也可以附带意见实施、要求修改、提问或先跑测试。点按钮等同于在输入框里发送对应的文字命令。',
    help_text_need_approval: '此项目需要审批人批准才能实施。点"提交审批"后，具有完全授权的审批人会审核这个方案；你也可以先要求修改或提问。',
    approve: '批准并开始实施',
    submit: '提交审批',
    proceed_with_notes: '附带意见后实施',
    revise: '修改方案',
    ask: '提问',
    run_tests: '先跑测试',
    full_proposal: '查看完整方案',
    cancel: '取消方案',
    // P-COND-368144D76579 — 更多操作 menu, editor hint/label, cancel dialog
    more: '更多操作',
    multi_review: '多模型复核',
    menu_proceed: '附带意见实施',
    hint_proceed: '意见将与当前方案一并提交，确认后开始实施。若要改变方案内容，请选择“修改方案”。',
    label_proceed: '实施意见（必填）',
    hint_test: '先验证当前方案，测试结束后仍由你决定是否实施。测试范围可以留空。',
    label_test: '测试范围（选填）',
    cancel_dialog_title: '确认取消当前方案？',
    cancel_dialog_body: '取消后，本次方案不再等待审批。已有会话记录仍保留。',
    cancel_dialog_review_note: '取消方案不会停止复核；如需停止，请使用「停止复核」。',
    cancel_dialog_confirm: '确认取消方案',
    cancel_dialog_back: '返回',
    placeholder_proceed: '写下实施时需要注意或调整的地方…',
    placeholder_revise: '写下希望怎样修改这个方案…',
    placeholder_ask: '写下你想问的问题…',
    send_proceed: '附带意见并实施',
    send_revise: '发送修改意见',
    send_ask: '发送问题',
    collapse: '收起',
    notes_required: '请先填写意见',
    question_required: '请先填写问题',
    send_hint: '发送后等同于输入 {command} 加上你的内容',
    footer_prefix: '点按钮等同于发送',
    footer_revise_example: '/revise 意见',
    footer_suffix: '等命令；也可以直接在输入框里打字。',
    sending: '发送中…',
    // P-COND-6E08B543DEA8 — card states (idle / filling / running / expired)
    reveal_composer: '改用输入框发送',
    // P-COND-42D22E812062 — composer mode: card collapses to one line
    mini_title: '方案待你审批',
    mini_hint: '在下方输入的内容会被当作对方案的提问',
    // 卡内复核进行中提示
    review_panel_pointer: '复核进行中，进度和停止见上方复核操作区',
    review_panel_ended: '复核已结束，结果见对话',
    review_running_short: '复核中',
    back_to_panel: '返回审批面板',
    placeholder_test: '可选：写下测试时需要关注的地方（留空直接跑测试）…',
    send_test: '开始测试',
    keys_hint: 'Ctrl+Enter 发送 · Esc 收起',
    placeholder_with_keys: '{text}（{keys}）',
    running_approve: '✓ 已批准，正在实施…',
    running_revise: '正在修改方案…',
    running_ask: '正在回答你的提问…',
    running_proceed: '已附带意见，正在实施',
    running_test: '正在测试，完成后继续等待你的审批',
    running_cancel: '正在取消…',
    running_other: '有任务正在运行',
    running_resume: '结束后可继续审批',
    expires_in_hours: '约 {hours} 小时后过期',
    expires_in_minutes: '约 {minutes} 分钟后过期',
    expired_notice: '方案 {id} 已过期，需要时请重新发起任务',
    dismiss: '关闭提示',
  },
  // ── PreflightBar ──────────────────────────────────────────────────
  preflight: {
    bar_label: '发送前设置',
    mode_branch_dev: '分支开发',
    mode_operation: '统筹',
    lock_hint: '发送后锁定',
  },

  // ── Conductor Desktop 下载页（/desktop/download）────────────────────
  desktop_download: {
    title: 'Conductor Desktop',
    subtitle:
      '一个跑在你自己电脑上的小型守护进程。装好并完成绑定后，Conductor 的 agent 就能在你授予的权限范围内读写这台机器上的文件。',
    back: '返回对话',
    loading: '正在载入安装包…',
    load_failed: '安装包列表载入失败',
    retry: '重试',
    current_version: '当前版本',
    platform_windows: 'Windows',
    platform_macos: 'macOS',
    file_label: '文件',
    size_label: '体积',
    sha256_label: 'SHA-256',
    platform_note_macos:
      '仅支持 Apple Silicon（M 系列芯片）的 Mac，Intel 芯片的 Mac 无法运行。',
    download: '下载',
    downloading: '下载中…',
    unavailable: '安装包尚未发布',
    unavailable_hint: '该平台的安装包还没有构建上传。这不是你这一侧的问题，请稍后再来。',
    download_failed: '下载失败，请重试。',
    downloading_pct: '下载中… {pct}%',
    downloading_bytes: '下载中… {mb} MB',
    download_stalled: '下载停滞（{seconds} 秒无数据），已中止。请检查网络后重试。',
    verify_title: '校验你下载到的文件',
    verify_body:
      '可选：把上面的 SHA-256 与你下载到的文件比对，一致即说明文件完整、未被替换。',
    verify_cmd_windows: 'certutil -hashfile <文件> SHA256',
    verify_cmd_macos: 'shasum -a 256 <文件>',
    unsigned_title: '安装包未签名——而且两个平台的表现并不一样',
    unsigned_intro:
      '安装包没有代码签名。Windows 只会提示警告，macOS 会直接拒绝打开并提示「已损坏」。安装前请看你所用平台的那一段。',
    unsigned_windows_title: 'Windows —— SmartScreen 只是警告，可以点过去',
    unsigned_windows_body:
      '首次运行时会弹出蓝色的「Windows 已保护你的电脑」窗口。点「更多信息」→「仍要运行」即可，安装随后正常进行，不需要其它操作。',
    unsigned_macos_title: 'macOS —— Gatekeeper 硬拒绝，且报「已损坏」',
    unsigned_macos_body:
      '从浏览器下载的安装包会被 macOS 标记为「隔离」。未签名的 app 被隔离后，打开时会提示「已损坏，无法打开」。文件并没有坏，只是被系统策略拦下。',
    unsigned_macos_way1:
      '第一次打开前，先把 app 拖到「应用程序」文件夹，然后在「终端」里执行下面这条命令（只需一次）：',
    unsigned_macos_cmd: 'xattr -dr com.apple.quarantine /Applications/ConductorDesktop.app',
    unsigned_macos_arch:
      '仅支持 Apple Silicon（M 系列芯片）的 Mac。',
    unsigned_macos_keychain:
      '升级后第一次启动时，系统会弹窗要求输入这台 Mac 的登录密码，以允许 ConductorDesktop 读取钥匙串里保存的登录信息。输入密码后请点「始终允许」；点「拒绝」会导致客户端无法登录。',
    autostart_title: '自启动是「登录时」触发，不是「开机时」触发',
    autostart_body:
      '客户端在你登录电脑账户后自动启动。电脑重启后停在锁屏界面时它还没有运行，登录之后才会连上；登录信息保存在你个人的钥匙串/凭据库里，没有登录就无法读取。',
    next_title: '装完之后',
    next_body:
      '绑定完成后，可在 Web Chat 的「我的设备」页面看到这台设备。绑定需要有人在电脑旁确认，无人值守的电脑无法完成。',
  },
  relay: {
    title: '个人中转站',
    subtitle: '仅自己可见 · 24 小时后删除',
    notice: '🔒 仅自己可见 · 不发给智能体 · 每条文字和文件发出 24 小时后永久删除，无法恢复',
    empty: '在这里发的文字和文件，\n你登录的其他设备都能立刻看到。\n每条内容 24 小时后自动删除，\n也可以点 ⋯ 随时删除。',
    placeholder: '输入文字，或拖入/粘贴文件',
    delete: '删除',
    delete_confirm: '永久删除这条内容（含附件）？此操作无法恢复',
    delete_failed: '删除失败，请稍后重试',
    clear: '清空',
    clear_title: '清空中转站的全部文字和文件',
    clear_confirm: '清空中转站的全部文字和文件？此操作无法恢复',
    clear_failed: '清空失败，请稍后重试',
    expires_in_hours: '{n} 小时后删除',
    expires_in_minutes: '{n} 分钟后删除',
    download_only: '中转站文件仅支持下载',
    pick_local: '📁 本机文件',
    pick_local_mobile: '📁 本机文件 / 拍照',
    pick_from_relay: '📥 从个人中转站选择',
    pick_title: '添加附件',
    pick_hint: '加入后按本会话规则保存，不再 24 小时删除',
    pick_empty: '中转站里还没有文件',
    pick_loading: '加载中…',
    pick_load_failed: '中转站文件加载失败，请稍后重试',
    pick_add: '添加 {n} 个',
    pick_cancel: '取消',
    pick_skipped: '{n} 个文件已过期或无法读取，已跳过',
    pick_unavailable: '找不到你的个人中转站',
    save_to_relay: '存到中转站',
    saved: '已存到中转站，24 小时后删除',
    save_failed: '存到中转站失败',
  },
  // ── 技能中心（SKC-T1.3 骨架；占位页） ──────────────────────────────
  skillCenter: {
    title: '技能中心',
    placeholder: '技能中心即将上线。',
    tabs: {
      library: '技能库',
      mine: '我的技能',
      guide: '使用指南',
      project: '项目技能',
      org: '组织管理',
    },
    create: {
      title: '创建技能',
      steps: {
        s1: '描述需求',
        s2: '对话完善',
        s3: '预览确认',
      },
      heading: '有想法，还不会写技能？',
      sub: '写一句话就行，Agent 会在一个只有你能看到的会话里帮你补全。',
      problem: '想解决什么问题',
      problemPlaceholder: '例如：每周五把本周会话整理成周报，按项目分组',
      required: '必填',
      project: '在哪个项目里完善',
      projectFromConv: '（从会话带入）',
      noProject: '你还没有可用的项目，无法开始完善会话',
      optional: '选填：名称、参考材料、高级选项',
      name: '技能名称（选填）',
      namePlaceholder: '例如：周报整理',
      materials: '参考材料（选填，可粘贴文字）',
      materialsPlaceholder: '粘贴模板、示例或要求，Agent 会参考它们',
      advanced: '高级',
      slug: '调用名称',
      slugHint: '自动生成，可修改。只能用小写字母、数字和连字符，例如 weekly-report。',
      slugInvalid: '调用名称只能用小写字母、数字和连字符（2–48 个字符，字母或数字开头）',
      backToCenter: '← 返回技能中心',
      backToOrigin: '返回原会话',
      leaveConfirm: '填写的内容还没有提交，确定离开吗？',
      start: '下一步：进入对话',
      starting: '正在创建会话…',
      saveOnly: '自己写（不进入对话）',
      startHint: '需求会自动发给助手，助手会问你几个问题再整理成技能。有未提交内容时离开会提示。',
      tooLarge: '内容超过上限（{size} / {max}），请精简后再试',
      failed: '创建失败，请稍后重试',
      off: '「我的技能」暂未开放',
      offBody: '组织还没有开启个人技能功能。你仍然可以在「技能库」里使用平台和组织提供的技能。',
      materialsHeading: '参考材料：',
      skeleton: {
        purpose: '## 用途',
        when: '## 何时使用',
        inputs: '## 需要提供',
        outputs: '## 产出',
        example: '## 示例',
      },
    },
    mine: {
      newSkill: '＋ 新建技能',
      intro: '我的技能只属于你自己，可以在你有权限的任何项目里使用。',
      inProgress: '进行中（未保存的草稿）',
      inProgressNote: '草稿保存在服务器上，刷新页面或换设备后都能接着改。放弃草稿不会删除完善会话。',
      saved: '已保存',
      untitled: '未命名草稿',
      kindNew: '新建技能 · 草稿',
      kindRevision: '修改第 {n} 版 · 草稿',
      size: '{size} / 上限 {max}',
      updated: '草稿最后更新 {time}',
      privateNote: '仅你可见',
      continue: '继续完善',
      edit: '手动编辑',
      editSave: '保存修改',
      editCancel: '取消',
      abandon: '放弃草稿',
      abandonConfirm: '确定放弃这份草稿？完善会话会保留。',
      convLink: '会话：{title} →',
      convUntitled: '完善会话',
      conflict: '这个技能已在别处更新到第 {n} 版。草稿已保留，请先查看差异再保存。',
      viewDiff: '查看差异（第 {n} 版 ↔ 你的草稿）',
      savedTag: '已保存 · 第 {n} 版',
      conflictTag: '重名冲突',
      conflictNote: '这个名字已被其他技能使用。改名之前不能在会话里使用，也不能发布。',
      useHere: '在当前会话使用',
      useElsewhere: '在会话中使用',
      revise: '修改内容',
      revisePending: '我想修改技能《{title}》，请先问我要改哪里',
      history: '版本历史（{n} 个版本）',
      historyLoad: '版本历史',
      historyNote: '版本只增不改；修改内容会生成新版本。',
      versionTag: '第 {n} 版',
      current: '当前',
      view: '查看',
      hide: '收起',
      emptyTitle: '你还没有自己的技能',
      emptyBody: '写一句话说明想解决什么问题，Agent 会在只有你能看到的会话里帮你补全。',
      loadFailed: '加载失败',
      retry: '重试',
      actionFailed: '操作失败，请稍后重试',
      publishBtn: '发布到组织',
      copyBtn: '复制到组织技能库',
      republishBtn: '重新申请发布',
      withdrawBtn: '撤回申请',
      withdrawConfirm: '确定撤回这次发布申请？',
      pubPending: '发布申请：待审批 · 第 {n} 版',
      pubRejected: '发布申请：已退回',
      pubWithdrawn: '发布申请：已撤回',
      pubApproved: '已发布到组织 · 第 {n} 版',
      pubTarget: '已申请发布到：{target} · 等待其他管理员审批',
      pubStale: '申请的是第 {n} 版，当前已有第 {m} 版；如需发布新版，请撤回后重新申请。',
      pubRejectNote: '退回意见：{note}',
      pubWithdrawnNote: '你在 {time} 撤回了发布申请，可以随时重新申请。',
      revisionConflict: '草稿已在别处更新，已载入最新内容，请重新修改',
    },
    refine: {
      banner: '技能完善会话 · 仅你可见',
      backToOrigin: '返回原会话',
      backToCenter: '← 返回技能中心',
      cardTitleRevision: '修改第 {n} 版',
      untitled: '未命名技能',
      status: {
        preparing: '助手正在准备第一个问题…',
        refining: '正在完善需求 · 回答助手的问题即可',
        refiningOr: '回答助手的问题，或',
        candidate: '草稿已生成，下一步 →',
        ready: '草稿已保存 {time} · 检查后即可创建',
        readyVersion: '草稿已保存 {time} · 检查后即可保存新版本',
        adoptConflict: '未保存成功（草稿已被修改）· 候选内容已保留',
        adoptTooLarge: '未保存成功（内容超过上限 {max}）· 候选内容已保留',
        adoptFailed: '未保存成功 · 候选内容已保留',
        createdNow: '已创建 v{n} · {title} /{slug}',
        savedNow: '已保存为 v{n}',
        createdCurrent: '已创建 · 技能当前版本 v{n}',
        savedCurrent: '已保存 · 技能当前版本 v{n}',
      },
      adopt: '采用并预览',
      adopting: '正在写入…',
      quickDraft: '请根据目前的信息直接生成技能草稿',
      quickDraftBtn: '直接生成草稿',
      previewConfirm: '预览并确认创建',
      previewConfirmVersion: '预览并保存新版本',
      useInConversation: '在会话中使用 /{slug}',
      viewPreview: '查看预览',
      hidePreview: '收起预览',
      viewDiff: '查看差异',
      hideDiff: '收起差异',
      adoptDiffTitle: '差异（当前草稿 ↔ 候选内容）',
      continueEdit: '继续修改',
      slugLabel: '调用名',
      previewNote: '「继续修改」会收起预览并回到输入框；试一下不会创建版本；内容更新后需重新勾选。',
      empty: 'Agent 还没有写出草稿。回答它的问题后，草稿会出现在这里。',
      loading: '正在读取草稿…',
      loadFailed: '草稿读取失败',
      retry: '重试',
      edit: '手动编辑',
      editAria: '手动编辑草稿',
      editHint: '改完会更新草稿；保存为技能前仍需勾选「我已检查内容」。',
      editSave: '更新草稿',
      editCancel: '取消',
      trial: '用示例试一下',
      trialPlaceholder: '示例输入，例如：/weekly-report 本周 conductor 项目',
      trialAria: '试用的示例输入',
      trialHint: '在本会话里用示例输入试一次，不会保存，也不会生成新版本；不满意就继续在会话里修改。',
      trialSend: '发送试用',
      confirm: '我已检查内容',
      saveNew: '确认创建技能',
      saveVersion: '保存新版本',
      saving: '保存中…',
      openMine: '查看我的技能',
      conflict: '该技能已在别处更新到第 {n} 版。草稿已保留，请先查看差异再保存。',
      diffTitle: '差异（第 {n} 版 ↔ 你的草稿）',
      rebase: '基于第 {n} 版保存',
      revisionConflict: '草稿刚被 Agent 或其他设备更新，已载入最新内容；你的修改仍在编辑框里。',
      tooLarge: '草稿超过上限（{size} / {max}），请精简后再保存',
      saveFailed: '保存失败，请稍后重试',
      size: '{size} / 上限 {max}',
    },
    slash: {
      aria: '技能补全',
      hintNav: '↑↓ 选择',
      hintEnter: 'Enter 确认',
      hintEsc: 'Esc 关闭',
      empty: '没有匹配的技能',
      src: {
        platform: '平台',
        team: '团队',
        personal: '个人',
        command: '审批命令',
      },
    },
    org: {
      title: '组织技能',
      closedTitle: '组织技能尚未开放',
      closedBody: '组织还没有开启技能发布功能。',
      tabs: {
        library: '组织技能库',
        approvals: '发布审批',
      },
      adminNote: '管理员直接新建、修改组织技能不需要审批，操作会记入审计。',
      memberNote: '你是组织成员，可以浏览组织技能库。想把自己的技能共享给组织，请在「技能中心 → 我的技能」提交发布申请。',
      newSkill: '＋ 新建组织技能',
      empty: '组织技能库还没有技能。',
      loadFailed: '加载失败',
      retry: '重试',
      scopeOrg: '全组织',
      scopeDept: '部门',
      mandatoryTag: '必装 · {n} 个项目',
      versionTag: '第 {n} 版',
      archivedTag: '已停用',
      archivedOn: '第 {n} 版 · {time} 停用',
      edit: '编辑（出新版本）',
      archive: '停用',
      unarchive: '重新启用',
      archiveConfirm: '确定停用 /{slug}？停用后各项目里的文件会被收回，技能库显示「已停用」。',
      mandatoryLock: '已在 {n} 个项目设为必装，不能停用。请先在项目详情里取消必装。',
      mandatoryConflict: '这个技能在项目里设为必装，不能停用。请先在项目详情里取消必装。',
      archivedNote: '停用后各项目里的文件会被收回，技能库显示「已停用」',
      defaultInstall: '组织内默认安装',
      defaultInstallHint: '成员自动获得，可自行卸载',
      form: {
        createTitle: '新建组织技能',
        slug: '调用名称',
        slugHint: '小写字母、数字和短横线，例如 weekly-report',
        name: '名称',
        description: '一句话说明',
        scope: '在哪里可用',
        scopeOrg: '整个组织',
        body: '技能正文',
        bodyNoPrefill: '列表没有返回当前正文，请粘贴完整的新内容。',
        create: '创建',
        saveVersion: '保存为第 {n} 版',
        cancel: '取消',
        required: '请填写调用名称和正文',
        slugInvalid: '调用名称格式不对',
        conflict: '这个技能已在别处更新到第 {n} 版。你的内容还在编辑框里，查看差异后再保存。',
        failed: '保存失败：{msg}',
      },
      sync: {
        ok: '已送达 {n} 个项目',
        failed: '{n} 个项目送达失败：{list}',
        none: '已保存（还没有分配到项目）',
      },
      approvals: {
        empty: '暂无发布申请',
        memberEmpty: '你还没有提交过发布申请',
        status: { pending: '待审批', approved: '已通过', rejected: '已退回', withdrawn: '已撤回' },
        meta: '申请版本：第 {n} 版 · 申请人：{who}',
        metaTarget: ' · 发布到：{target}',
        you: '你',
        unknownVersion: '?',
        lockNote: '审批只针对申请时锁定的第 {n} 版；申请人之后改出的新版本不在这次申请里。不共享申请人的完善会话。',
        viewBody: '查看这一版的完整内容',
        noBody: '这一版的内容加载失败，请稍后再试。',
        notePlaceholder: '退回时必须填写意见',
        noteRequired: '退回必须填写意见',
        approve: '通过',
        reject: '退回',
        withdraw: '撤回申请',
        selfReason: '不能审批自己的申请，请其他管理员处理',
        decidedNote: '退回意见：{note}',
        alreadyDecided: '这条申请已经处理过了，已刷新列表。',
        failed: '操作失败：{msg}',
      },
    },
    publish: {
      title: '申请转出 /{slug}',
      copyTitle: '转移 /{slug}',
      intro: '提交后由组织管理员审批（项目技能也可由该项目的完全自主成员审批）；通过后技能转为项目或组织技能。',
      copyIntro: '你是管理员，直接转移（记入审计），不需要也不能自批。转为组织技能后本组织所有项目都能使用；转为项目技能后项目成员都能使用。',
      copyIntroProject: '你是该项目的完全自主成员，直接转为项目技能（记入审计），不需要审批。转移后项目成员都能使用。',
      versionTag: '第 {n} 版',
      onlyVersion: '只发布第 {n} 版。',
      lockNote: '申请提交时就锁定这一版；如果你之后又改出新版本，审批会被拒绝，需要撤回后重新申请。你的完善会话不会被共享。',
      copyLockNote: '整个技能连同全部版本一起转移，当前是第 {n} 版。',
      target: '转为',
      targetProject: '项目技能',
      projectPick: '选择项目',
      projectNone: '没有可选的项目',
      targetOrg: '整个组织：{org}',
      targetOrgPlain: '整个组织',
      reviewNote: '需项目完全自主成员或组织管理员审批（组织技能只由组织管理员审批）。你不能审批自己的申请；退回时审批人会写明原因。审批前你可以随时撤回申请。',
      cancel: '取消',
      submit: '提交申请',
      copySubmit: '直接转移',
      submitting: '提交中…',
      noOrg: '请先在顶栏选择一个组织',
      noVersion: '这个技能还没有保存过版本，不能发布',
      failed: '提交失败：{msg}',
      done: '已提交发布申请',
      copied: '已转移，技能已从「我的技能」移走，版本历史和创建者保留',
    },
    tabsAria: "技能中心页签",
    loading: "加载中…",
    closed: {
      title: "技能中心尚未开放",
      body: "功能还在准备中，开放后这里会显示技能库。你仍可以在会话里照常使用已安装的技能。",
    },
    back: "← 返回会话",
    backWithTitle: "← 返回会话：{title}",
    context: {
      project: "当前项目",
      mode: "模式",
      fromConv: "从会话带入，可切换",
      noProject: "你还没有可用的项目",
      modeDev: "dev 模式",
      modeCollab: "collab 模式",
    },
    intro: {
      title: "三步上手",
      s1: "1 搜索或筛选",
      s2: "2 展开说明，看适不适合",
      s3: "3 点「在当前会话使用」",
      guide: "查看使用指南",
      close: "关闭引导",
    },
    library: {
      search: "搜索技能名称、用途……",
      searchAria: "搜索技能",
      statusAria: "筛选",
      status: {
        all: "全部",
        available: "可用",
        favorites: "★ 收藏",
      },
      sourceAria: "来源",
      source: {
        all: "全部来源",
        platform: "平台技能",
        team: "团队技能",
        mine: "我的技能",
      },
      teamHint: "团队技能 = 组织、项目技能；卡片上的小标签写明在哪些项目可用。",
      useHere: "在当前会话使用",
      useElsewhere: "在会话中使用",
      pin: "收藏 /{slug}",
      unpin: "取消收藏 /{slug}",
      mandatory: "必装",
      expand: "展开说明",
      collapse: "收起说明",
      empty: "没有符合条件的技能",
      error: "技能列表加载失败",
      retry: "重试",
      attachOnly: "本项目以派单附带方式使用",
      install: "去安装",
      where: {
        org: "全组织",
        department: "部门",
        project: "本项目",
        personal: "在你有权限的项目可用",
      },
      fields: {
        purpose: "用途",
        when: "何时使用",
        inputs: "需要提供",
        outputs: "产出",
        example: "示例",
        note: "说明",
      },
      exampleText: "/{slug} 加上你的具体要求",
      mandatoryNote: "必装只是不能卸载，不会自动运行",
      deliveryFailed: "第 {n} 版送达失败，项目仍在使用第 {prev} 版",
      retrySync: "重试",
      retrying: "重试中…",
      retryFailed: "重试失败，请稍后再试",
      reasons: {
        not_installed: "本项目未启用这个项目技能 · 需管理员在项目详情中启用",
        name_conflict: "重名冲突 · 和其他技能同名，暂不可用",
        mode_mismatch: "模式不符 · 当前模式不适用这个技能",
        permission_denied: "权限不足 · 你没有使用这个技能的权限",
        archived: "已停用 · 组织管理员已停用这个技能",
        not_delivered: "未送达 · 还没有成功送达这个项目，管理员可在项目详情里重试",
        unknown: "暂不可用",
      },
    },
    drawer: {
      title: "技能详情",
      close: "关闭",
      notFound: "没有找到这个技能",
    },
    handoff: {
      dialogTitle: "在会话中使用 /{slug}",
      dialogBody: "你是从导航进入技能中心的，请选择要在哪个会话里使用。",
      step1: "1 选择项目",
      step2: "2 选择会话",
      recent: "最近会话：{title}",
      untitled: "未命名会话",
      newConv: "＋ 新建会话（自动选中这个项目）",
      loading: "加载会话…",
      loadFailed: "会话列表加载失败",
      cancel: "取消",
      confirm: "前往并选上技能",
      failed: "操作失败，请稍后重试",
      writeFailed: "无法保存交接信息（浏览器存储不可用）",
    },
    composer: {
      selected: "已从技能中心选上 /{slug}，确认后再发送",
      unavailable: "/{slug} 在这个会话的项目里不可用：{reason}",
      notFound: "/{slug} 在这个会话的项目里找不到，未选上",
      checkFailed: "无法确认 /{slug} 是否可用，未选上，请稍后在 ＋ 面板里手动选择",
      replaceAsk: "已选用 /{current}，要替换为 /{slug} 吗？",
      replace: "替换",
      keep: "保留当前",
      dismiss: "关闭提示",
    },
    guide: {
      intro: "技能是一份写好的做事方法。选上它，Agent 就会按这个方法帮你完成任务。",
      use: {
        title: "在会话里用技能",
        sub: "找到合适的技能，带回会话使用。",
        s1t: "找技能",
        s1d: "在「技能库」搜索，或按「可用 / 收藏」与来源筛选。",
        s2t: "看说明",
        s2d: "展开卡片，看用途、何时使用、需要提供什么、会得到什么。",
        s3t: "在会话中使用",
        s3d: "点「在当前会话使用」回到原会话，技能已经选上，不会自动发送。",
        cta: "去技能库",
      },
      make: {
        title: "做一个自己的技能",
        sub: "不会写也没关系，Agent 会一步步问你。",
        s1t: "写一句话",
        s1d: "说明想解决什么问题，其他都可以不填。",
        s2t: "回答几个问题",
        s2d: "在只有你能看到的会话里，Agent 会问清楚细节。拿不准就选「我还不确定」。",
        s3t: "检查后保存",
        s3d: "看过草稿、勾选「我已检查内容」，就能保存为你的技能。想让同事也用，可以申请发布到组织。",
        cta: "新建技能",
        off: "你所在的组织还没有开启个人技能功能。需要的话请联系组织管理员。",
      },
      faqTitle: "常见问题",
      faq: {
        q1: "「必装」的技能会自动运行吗？",
        a1: "不会。必装只表示这个项目里一定装好、不能卸载。你仍然需要在会话里选上它，它才会生效。",
        q2: "为什么有些技能是灰色的，点不了？",
        a2: "卡片下方会写原因，常见的有：你还没安装、本项目未启用、和其他技能重名、当前模式不适用、你没有权限。平台技能和组织技能在技能库里自己安装即可；项目技能需管理员在项目详情里启用。",
        q3: "一条消息能同时用几个技能？",
        a3: "一次只能用一个。选了另一个会替换当前选中的技能。",
        q4: "我做的技能，别人能看到吗？",
        a4: "默认只有你自己能看到和使用。申请发布并经组织管理员审批通过后，组织里的同事才能看到。发布的只是你申请时的那一版。",
        q5: "完善技能的那个会话，谁能看到？",
        a5: "只有你自己。组织管理员和平台管理员都看不到。",
        q6: "发布申请被退回了怎么办？",
        a6: "在「我的技能」里能看到管理员写的退回意见。按意见修改后，可以重新申请发布。",
      },
      manualText: "想了解更多，比如技能怎么写得更好用？",
      manualLink: "打开使用手册 →",
    },
    project: {
      title: "项目技能",
      sub: "决定这个项目里哪些技能已经装好、哪些可以选用。保存后立即送达；失败会显示原因，可立即重试；每晚自动补齐。",
      add: "＋ 添加技能",
      addPick: "选择要添加的技能",
      addConfirm: "添加",
      addNone: "没有可添加的技能",
      legend: {
        mandatory: "一定安装，项目内不能停用（必装不等于自动运行）",
        default: "已安装，可以停用",
        available: "成员能看到，管理员安装后才能用",
      },
      modes: {
        mandatory: "必装",
        default: "默认",
        available: "可选",
      },
      modeAria: "安装方式",
      win: "这个项目运行在 Windows 电脑上：只能追加安装。停用后技能不再出现在列表里，但已送达的文件不会自动删除。",
      readOnly: "你是这个项目的成员，可以查看技能安装情况。如需安装或调整，请联系组织管理员。",
      sources: {
        platform: "平台技能",
        org: "组织技能",
        department: "部门技能",
        project: "项目技能",
        personal: "个人技能",
      },
      version: "第 {n} 版",
      status: {
        delivered: "✓ 已送达",
        installed: "✓ 已安装",
        notInstalled: "未安装",
        inactive: "已停用",
        filesKept: "（文件保留）",
        notDelivered: "未送达（从未成功送达，会话里暂不可选）",
        failed: "第 {n} 版送达失败，项目仍在使用第 {prev} 版",
        attachOnly: "本项目以派单附带方式使用",
        archived: "已停用（组织管理员停用）",
        conflict: "重名冲突",
        unavailable: "暂不可用",
      },
      deactivate: "停用",
      reactivate: "重新启用",
      install: "安装",
      retry: "重试",
      mandatoryLocked: "必装技能不能停用。要停用，请先改成「默认」。",
      saving: "保存中…",
      saveFailed: "保存失败，请稍后重试",
      loadFailed: "项目技能加载失败",
      empty: "这个项目还没有安装技能",
      result: {
        title: "保存后的送达结果",
        delivered: "✓ {project}：已送达",
        failed: "✕ {project}：送达失败（{error}）",
        attach: "{project}：本项目以派单附带方式使用（选中时随派单带上正文）",
        windows: "{project}：Windows 只能追加（停用不会删除已送达的文件）",
        unknownError: "未知原因",
      },
      create: {
        summary: "＋ 新建必装技能",
        hint: "新建的技能只属于这个项目，并直接设为必装。",
        slug: "调用名称",
        desc: "一句话说明",
        descPlaceholder: "例如：现场巡检前的检查清单",
        body: "说明正文",
        bodyHint: "正文按固定小标题填写，技能库展开时会按这些小标题显示。名称不能和平台技能重名。",
        submit: "创建并设为必装",
        submitting: "创建中…",
        cancel: "取消",
      },
    },
    help: "使用帮助",
    helpTitle: "技能中心使用帮助",
    newSkill: "＋ 新建技能",
    currentProject: "当前项目",
    modeLabel: "会话模式",
    projectsLoadFailed: "项目列表加载失败",
    projectType: {
      dev: "开发项目",
      collab: "协作项目",
      both: "两种模式",
      unset: "未设置类型",
    },
    projectUnsetHint: "项目未设置类型，以下为全部技能",
    orgTab: {
      library: "组织技能",
      approvals: "发布审批",
    },
    status: {
      ready: "可使用",
      readyMandatory: "已安装 · 必装",
      installable: "可安装",
      pending: "安装中 / 待处理",
      failed: "安装失败",
      stale: "新版本待生效",
      versionUnknown: "运行版本待核实",
      attach: "可使用",
      notInstalled: "未安装",
      userInstalled: "已安装",
      mandatoryProject: "本项目必选",
      projectSkill: "项目技能",
    },
    card: {
      expand: "展开说明",
      learnMore: "了解更多 →",
      learnMoreShort: "了解更多",
      use: "在会话中使用",
      install: "安装到项目",
      installPersonal: "安装",
      uninstall: "卸载",
      installed: "已安装",
      retry: "重试安装",
      manage: "管理",
      favorite: "收藏",
      unfavorite: "取消收藏",
      guidePending: "说明待补充",
      authorUnrestricted: "作者未限定类型",
      when: "什么时候用",
      inputs: "需要准备",
      output: "预期结果",
      failReason: "失败原因：{msg}",
      scope: {
        dev: "开发项目适用",
        collab: "协作项目适用",
        both: "开发与协作通用",
      },
    },
    guideModal: {
      what: "能帮你做什么",
      when: "什么时候使用",
      inputs: "开始前准备",
      how: "如何使用",
      howDefault: "在会话中选入此技能，补充你的要求，检查后发送。",
      output: "预期得到什么",
      example: "你可以这样说",
      notes: "使用须知",
      version: "说明对应第 {n} 版",
      pendingVersion: "第 {n} 版待生效",
      close: "关闭",
      loadFailed: "说明加载失败",
    },
    errors: {
      host_unconfigured: "这个项目还没有配置服务器连接，暂时无法安装，请联系管理员",
      write_failed: "技能文件没能写入项目，请稍后重试；多次失败请联系管理员",
      remove_failed: "技能文件没能从项目中移除，请稍后重试；多次失败请联系管理员",
      check_failed: "暂时无法检查项目里的技能文件，请稍后重试",
      file_ops_unavailable: "暂时连不上项目所在的服务器，请稍后重试；多次失败请联系管理员",
      unmanaged_file_exists: "项目里已有同名的技能文件（不是技能中心装的），没有覆盖；请管理员先处理这个文件",
      template_missing: "找不到这个平台技能的文件，请联系管理员",
      not_installed: "请先安装这个技能，再收藏或在会话中使用",
      mandatory: "这是本项目必选的技能，不能卸载",
      version_changed: "技能已更新到新版本，请刷新后重试",
      not_found: "找不到这个技能，或你没有使用它的权限",
      bad_target: "请求有误，请刷新页面后重试",
      mandatory_only: "组织技能只能设为本项目必选",
      default_install_org_only: "只有组织技能可以设为组织内默认安装",
      department_retired: "部门技能已停用，请改为组织或项目技能后重新提交",
      generic: "服务暂时不可用，请稍后重试",
    },
    source: {
      platform: "平台",
      conductor: "组织技能",
      org: "组织技能",
      orgDefault: "组织默认",
      project: "项目技能",
      department: "部门技能",
      personal: "我的技能",
    },
    transfer: {
      toProject: "转为项目技能",
      toOrg: "转为组织技能",
      toDepartment: "转为部门技能",
      confirm: "将转移第 {n} 版。转移后会从「我的技能」移走，版本历史和创建者保留。",
      done: "已转移",
      removedHint: "通过后会从「我的技能」移走，版本历史和创建者保留",
      errors: {
        forbidden: "只有组织管理员可以直接转移，请改为提交申请",
        use_copy_to_org: "你是管理员，请直接转移，不需要提交申请",
        name_conflict: "目标位置已有同名技能，请先给技能改名",
        slug_taken: "目标位置已有同名技能，请先给技能改名",
        project_skill_conflict: "这个项目里已有同名的项目技能，请先给技能改名",
        already_transferred: "这个技能已经转出，请刷新页面",
        project_gone: "目标项目已不存在，请换一个项目",
        pending_exists: "这个技能已有一个待审批的申请，请先撤回",
        project_required: "请选择一个项目",
        project_not_found: "找不到这个项目，或你没有这个项目的权限",
        project_not_allowed: "这个项目不属于当前组织，不能转入",
        version_changed: "技能已更新到新版本，请刷新后重试",
        check_failed: "暂时无法检查项目里的技能文件，请稍后重试",
      },
    },
    projectTab: {
      notice: "这里只显示本项目的技能：项目专属技能和本项目必选的技能。平台技能和组织技能请在技能库里自己安装。",
      addFromLibrary: "＋ 从技能库添加",
      mandatorySection: "本项目必选",
      manageTitle: "管理 /{slug}",
      setMandatory: "设为必装",
      setDefault: "设为默认",
      setAvailable: "设为可选",
      disable: "停用",
      enable: "启用",
      summary: "已安装 {n} 项，{m} 项需处理",
      manageLink: "管理技能 →",
      assignedSection: "本项目技能",
      mandatoryEmpty: "本项目还没有必选技能",
      addMandatory: "＋ 设为本项目必选",
      addMandatoryTitle: "设为本项目必选",
      addMandatoryHint: "设为必选后，本项目所有成员都会自动使用这个技能，不能自行卸载。",
      addMandatoryEmpty: "没有可以设为必选的技能",
      addMandatoryAction: "设为必选",
      saveFailed: "保存失败：{msg}",
    },
    empty: {
      noMatch: "没有找到匹配的技能",
      noSkills: "没有适用的技能",
      noPermission: "没有项目权限",
      loadFailed: "加载失败",
      retry: "重试",
      createSkill: "创建技能",
    },
    copy: {
      confirmVersion: "将复制第 {n} 版",
      versionChanged: "技能已更新到新版本，请刷新后重试",
    },
    favoriteFailed: "收藏失败，已恢复原状态",
  },
  // ── MCP Center (M3-3 / P-COND-ACDA06F07BFD) — consent.* / handoff.* are M3-5 ──
  mcpCenter: {
    picker: {
      title: "连接（MCP）",
      openAria: "选择本次消息使用的 MCP 连接",
      modeAuto: "自动：允许使用当前可用连接",
      modeSelected: "仅使用我选定的连接",
      modeNone: "本次不用 MCP 中心连接",
      shared: "共享连接",
      personal: "个人连接",
      usable: "可用",
      go: "去处理",
      manage: "管理连接",
      apply: "应用到本次",
      applyHint: "请至少勾选一个连接",
      maxHint: "每条消息最多选 {n} 个连接",
      loading: "正在读取连接…",
      loadFailed: "连接列表读取失败，请稍后重试",
      empty: "本项目暂无可选的连接",
      summary: {
        auto: "连接 · 自动",
        selected: "连接 · 已选 {n}",
        none: "本次不用",
      },
      chipSelected: "仅使用：{names}",
      chipNone: "本次不用 MCP 连接",
      chipReset: "恢复自动",
      sendBlocked: "「仅使用选定连接」还没有勾选任何连接：请勾选连接或改为自动后再发送",
    },
    title: "MCP 中心",
    subtitle: "把外部服务（MCP 连接）安全地交给项目使用：申请、审批、账号连接都在这里完成。",
    loading: "加载中…",
    closed: {
      title: "MCP 中心尚未开放",
      body: "平台还没有开启 MCP 中心，请联系平台管理员。",
    },
    tabsAria: "MCP 中心分区",
    tabs: {
      effective: "项目可用连接",
      requests: "申请与审批",
      org: "组织连接",
      catalog: "平台目录",
      inbox: "待办",
    },
    project: {
      label: "当前项目",
      none: "当前组织下没有你可访问的项目",
      loadFailed: "项目列表加载失败",
    },
    retry: "重试",
    refresh: "刷新",
    cancel: "取消",
    confirm: "确认",
    close: "关闭",
    loadFailed: "加载失败：{msg}",
    scope: {
      platform: "平台目录",
      org: "组织连接",
      project: "项目私有",
    },
    mode: {
      none: "无需账号",
      shared: "组织共享账号",
      personal: "每人登录本人账号",
    },
    auth: {
      none: "无认证",
      api_key: "API key",
      oauth: "OAuth 登录",
    },
    connection: {
      not_required: "无需账号",
      not_connected: "账号未连接",
      connecting: "连接中",
      valid: "账号有效",
      expired: "账号已过期",
      reauth_required: "需要重新登录",
      disconnected: "账号已断开",
    },
    health: {
      unchecked: "未检查",
      ok: "正常",
      unavailable: "服务不可用",
      incompatible: "版本不兼容",
    },
    lifecycle: {
      draft: "草稿",
      published: "已上架",
      install_frozen: "停止新建连接",
      disabled: "已停用",
    },
    requestStatus: {
      draft: "草稿",
      pending: "待审批",
      approved: "已批准",
      rejected: "已拒绝",
      withdrawn: "已撤回",
      superseded: "已被新申请取代",
      none: "无申请",
    },
    usable: "可以使用",
    unusable: "暂不可用",
    reasons: {
      not_granted: "你还没有获得本项目对这个连接的使用权，可以提交申请",
      project_disabled: "本项目尚未启用这个连接，需项目负责人或组织管理员启用",
      request_pending: "使用申请正在等待审批",
      account_not_connected: "账号还没有连接（共享账号由维护者连接，个人连接需你本人登录）",
      account_expired: "账号登录已过期，需要重新连接",
      consent_required: "个人账号的结果会写入会话，需先确认一次结果可见范围后才能使用",
      runtime_unsupported: "本项目的运行环境暂不支持 MCP 连接（首版仅支持本机与 Docker 环境）",
      unhealthy: "外部服务当前不可用，请联系连接维护者",
      version_pending: "服务有新版本等待审批，当前版本暂不可用",
      definition_disabled: "平台已停用该服务",
      local_runtime_restricted: "本地运行的项目默认不开放外部连接",
    },
    reasonUnknown: "其他原因（{code}）",
    versionNo: "第 {n} 版",
    actions: {
      request: "申请使用",
      withdraw: "撤回申请",
      approve: "批准",
      reject: "拒绝",
      enable: "启用本项目",
      connect: "连接账号",
      reconnect: "重新连接",
      disconnect: "断开账号",
      manage: "管理",
      review: "审阅",
      revoke: "撤销本项目授权",
      grantEnable: "授权并启用本项目",
      resolve: "标记已处理",
      open: "查看",
    },
    consentHint: "个人连接首次使用前，请在本页确认一次结果可见范围。",
    effective: {
      empty: "本项目还没有可见的 MCP 连接。",
      rowMeta: "{scope} · {mode}",
      manageHint: "授权范围：项目全部有效成员，工具为连接已启用的全部工具。",
      revokeHint: "撤销后本项目的后续调用立即停止；已进入会话的内容不会撤回。",
      revokeUnavailable: "未找到本项目的授权记录（只有组织管理员能看到授权编号），请到「组织连接」处理。",
      enabled: "已启用本项目",
      revoked: "已撤销本项目授权",
      addPrivate: "添加项目私有连接",
    },
    requestForm: {
      title: "申请使用：{name}",
      purpose: "用途说明",
      purposePh: "例如：查询本项目已批准的资料",
      tools: "需要的工具（可选，逗号分隔）",
      toolsPh: "留空表示由审批人决定",
      submit: "提交申请",
      submitted: "申请已提交，等待审批",
      duplicate: "已有相同的待审批申请，未重复提交",
      noSecret: "申请不收集任何密钥。",
    },
    requests: {
      empty: "本项目暂无 MCP 申请。",
      applicantMe: "我",
      applicantOther: "其他成员",
      applicant: "申请人",
      created: "提交时间",
      decided: "处理时间",
      purpose: "用途",
      tools: "工具",
      toolsAll: "由审批人决定",
      rejectNote: "拒绝原因",
      target: "申请对象",
      targetCatalog: "平台目录：{name}",
      unknownTarget: "（已不可见的连接）",
      filterPending: "只看待审批",
    },
    approval: {
      title: "审阅申请",
      approveHint: "批准后申请人获得使用权；已有授权只会扩大，不会收窄成员或工具。",
      widenAll: "同时开放给本项目全部有效成员",
      rejectNote: "拒绝原因（必填，申请人可见）",
      rejectNotePh: "例如：用途说明不足，请补充需要访问的资源",
      rejectNoteRequired: "请填写拒绝原因",
      withdrawHint: "只能撤回你本人在本项目尚未处理的申请。",
      stale: "申请已发生变化，已刷新为最新状态，请重新审阅。",
      approved: "已批准",
      rejected: "已拒绝",
      withdrawn: "已撤回",
      handoffShared: "下一步：由连接维护者连接组织共享账号。",
      handoffPersonal: "下一步：每位获准成员各自登录本人账号。",
      readOnly: "你可以查看这条申请，但没有可执行的操作。",
    },
    org: {
      needOrg: "请先在顶部选择一个组织。",
      noPermission: "只有组织管理员可以管理组织连接。",
      empty: "组织还没有 MCP 连接。",
      newInstallation: "新建组织连接",
      grants: "已授权项目",
      noGrants: "尚未授权任何项目",
      allMembers: "项目全部成员",
      listedMembers: "指定成员 {n} 人",
      tools: "工具：{list}",
      toolsAll: "全部已启用工具",
      maintainer: "账号维护者",
      revokeConfirm: "确认撤销该项目的授权？",
    },
    catalog: {
      empty: "平台目录还没有服务。",
      noVersion: "尚无可安装的版本",
      requestForProject: "为当前项目申请",
      newDefinition: "新增目录服务",
      newVersion: "发布新版本",
      endpoint: "服务地址",
      tools: "工具 {n} 个",
    },
    editor: {
      orgTitle: "新建组织连接",
      projectTitle: "新建项目私有连接",
      catalogTitle: "新增平台目录服务",
      versionTitle: "发布新版本：{name}",
      definition: "目录服务",
      pickDefinition: "请选择目录服务",
      displayName: "显示名称（可选）",
      credentialMode: "账号方式",
      grantProjects: "同时授权给这些项目（全部有效成员）",
      noProjects: "当前组织没有项目",
      source: "来源",
      sourceCatalog: "从平台目录选择",
      sourceSelf: "自建远程服务（HTTP）",
      name: "服务名称",
      endpoint: "服务地址（https）",
      authKind: "认证方式",
      purpose: "用途说明",
      lifecycle: "上架状态",
      tools: "工具清单（JSON 数组，每项须有 name）",
      authCaps: "认证参数（JSON 对象，OAuth 需 authorize_url / token_url / client_id）",
      invalidJson: "JSON 格式不正确：{field}",
      required: "请填写必填项",
      create: "创建",
      created: "已创建",
      selfNote: "自建服务只在本项目可见；创建后仍需启用本项目才能使用。",
    },
    credential: {
      sharedKey: "组织共享 API key",
      sharedKeyPh: "粘贴 API key",
      saveKey: "保存密钥",
      keySaved: "共享账号已连接，密钥不会再次显示",
      keyHint: "密钥只写入服务器加密保存，保存后任何页面都不会再显示。",
      oauth: "通过服务商登录",
      redirecting: "正在跳转到服务商登录…",
      disconnectConfirm: "确认断开？只影响当前项目的这个连接，已进入会话的内容不会删除。",
      disconnected: "账号已断开",
      noBinding: "没有找到可断开的账号绑定（只有账号维护者或本人能看到），请刷新后重试。",
      authUnknown: "无法确认该连接的认证方式，请选择：",
    },
    oauthResult: {
      connected: "账号已连接，可以回到会话使用。",
      cancelled: "你取消了服务商登录，账号未连接。",
      expired: "登录已超时（10 分钟），请重新连接。",
      user_mismatch: "登录回来的 Conductor 账号与发起连接的账号不一致，未连接。请用发起连接的账号重新操作。",
      login_required: "无法确认这次登录是从本浏览器发起的（可能换了浏览器或清除了 Cookie），未连接。请在本页面重新点击连接。",
      forbidden: "你已无权为这个连接登录（授权可能已变化），未连接。",
      failed: "连接失败，请稍后重试或联系连接维护者。",
    },
    inbox: {
      empty: "没有待办。",
      open: "待处理",
      resolved: "已处理",
      showResolved: "显示已处理",
      kind: {
        mcp_request: "MCP 申请",
        mcp_enable: "MCP 启用",
        mcp_account_setup: "账号待连接",
      },
    },
    errors: {
      mcp_not_found: "对象不存在或你无权查看",
      mcp_forbidden: "你没有执行该操作的权限",
      mcp_stale_revision: "数据已变化，已刷新，请重新查看后再操作",
      mcp_invalid_state: "当前状态不允许该操作",
      mcp_runtime_unsupported: "该运行环境暂不支持 MCP",
      mcp_config_conflict: "MCP 配置存在同名冲突",
      mcp_consent_required: "需要先确认个人结果可见范围",
      mcp_ssrf_blocked: "服务地址不被允许（内网地址或重定向）",
      generic: "操作失败，请稍后重试",
      withMessage: "{base}：{msg}",
    },
    // M3-5 (§9.8): personal-result consent (D3) + conversation strip / handoff
    consent: {
      action: "确认结果可见范围",
      title: "确认个人连接「{name}」的结果可见范围",
      body: "个人账号查到的结果会写入会话，项目中能看这个会话的成员和平台管理员都能看到",
      scope: "确认一次后，本项目所有会话都可直接使用；你断开或重新连接账号，或本项目授权被撤销后需重新确认。群聊与企业微信会话不使用个人连接。",
      confirm: "我已了解，确认",
      done: "已确认，个人连接「{name}」现在可以在本项目会话中使用",
    },
    handoff: {
      label: "MCP",
      usable: "可用：{names}",
      noneUsable: "暂无可用连接",
      needs: "{n} 个需处理",
      hideNeeds: "收起",
      go: "去处理",
      goAll: "打开 MCP 中心",
      back: "返回会话",
      need: {
        group: "群聊中不使用个人连接",
        runtime: "运行环境不支持",
        pending: "等待审批",
        connect: "需连接账号",
        consent: "需确认结果可见范围",
        request: "可申请使用",
        unavailable: "暂不可用",
      },
      ready: "「{name}」现在可以使用了，草稿已保留，发送时会自动带上。",
      still: "「{name}」仍未就绪：{need}。草稿已保留。",
      summary: "已返回会话：{usable} 个连接可用，{needs} 个需处理。草稿已保留。",
      notFound: "之前处理的连接已不在本项目中。草稿已保留。",
      dismiss: "关闭提示",
      stripAria: "本会话的 MCP 连接状态",
    },
  },
  // ── Observability center · 自动处理 (AF-T8) ──────────────────────
  autofix: {
    tab: '自动处理',
    title: '自动处理',
    subtitle: '夜间自动修复的批次、每个问题的处理结果与上线状态；可按问题撤回或恢复',
    date: '日期',
    refresh: '↻ 刷新',
    loading: '加载中…',
    loadError: '加载失败，请稍后重试。',
    empty: '当天没有自动处理批次。',
    batchTitle: '批次 {date}',
    releaseStagesTitle: '发布阶段',
    noRuns: '本批次没有处理记录。',
    scopeNote: '撤回只保证不撤回其他提交；功能上依赖本修复的其他修复，撤回后会跑依赖验收。',
    col: {
      issue: '问题',
      result: '结果',
      live: '上线状态',
      action: '操作',
    },
    fixTargetLabel: '修复对象',
    stageLabel: '阶段',
    handoffLabel: '交接原因',
    labelSep: '：',
    chip: {
      merged: '已入 master',
      frontendLive: '前端已上线',
      backendLive: '后端已上线',
    },
    mergedValue: {
      effective: '是',
      reverted: '已撤回',
      not_merged: '否',
    },
    liveValue: {
      live: '是',
      not_live: '否',
      unknown: '无法确认',
    },
    liveText: {
      live: '已上线',
      not_live: '未上线',
      unknown: '无法确认（按已上线处理）',
    },
    action: {
      revert: '撤回',
      restore: '恢复',
      unavailable: '撤回不可用',
      checking: '核对中…',
      detailError: '无法读取撤回条件',
    },
    reason: {
      not_implemented: '撤回功能尚未启用',
      not_merged: '尚未合入 master',
      not_effective: '当前不是生效状态',
      not_reverted: '当前不是已撤回状态',
      in_flight: '已有撤回或恢复操作在进行',
      needs_reconcile: '状态待核对，需人工核对 git 历史',
      migration_refused: '含数据库迁移，需人工处理',
      live_unprovable: '无法确认是否已上线，需人工核对',
      stale_preview: '内容已变化，请重新预览',
      policy_revoked: '授权已变更',
      not_on_master: '目标提交不在 master 上',
      other: '不可用（{code}）',
    },
    batchState: {
      open: '进行中',
      integrating: '集成中',
      merged: '已合入 master',
      failed: '失败',
      skipped: '观察模式（无合入）',
    },
    releaseStage: {
      frontend_sg: '前端（新加坡入口）',
      frontend_cn: '前端（中国入口）',
      backend_stage: '后端准备',
      backend_promote: '后端切换',
    },
    releaseResult: {
      running: '进行中',
      succeeded: '成功',
      failed: '失败',
      skipped: '已跳过',
      none: '无记录',
    },
    fixTarget: {
      conductor_platform: '平台代码',
      project_env: '项目环境',
      project_content: '项目内容',
      none: '无需修复',
      undetermined: '未判定',
    },
    stage: {
      queued: '排队中',
      investigating: '调查中',
      deciding: '决策中',
      implementing: '实施中',
      verifying: '验收中',
      awaiting_integration: '等待集成',
      integrated: '已集成',
      closed: '已结束',
    },
    outcome: {
      pending: '待定',
      fixed: '已修复',
      no_change: '无需改动',
      needs_human: '待人工处理',
      failed: '失败',
      skipped_budget: '预算不足，已跳过',
      observed_only: '仅观察',
    },
    handoff: {
      none: '无',
      migration: '含数据库迁移',
      frontend_change: '含前端改动（不自动合入）',
      revert_conflict: '撤回冲突',
      root_conflict: '仓库根目录冲突',
      test_failed: '测试未通过',
      budget: '预算不足',
      project_env_change: '项目环境变更单',
      needs_reconcile: '状态待核对',
    },
    execState: {
      pending: '排队中',
      checking: '影响检查',
      reverting: '执行撤回',
      testing: '核心测试',
      merging: '并入 master',
      succeeded: '已完成',
      conflict: '有冲突，已转人工',
      test_failed: '测试未通过，master 未改变',
      migration_refused: '含数据库迁移，已拒绝',
      root_conflict: '仓库根目录冲突，已转人工',
      stale_preview: '状态已变化，请重新预览',
      refused: '已拒绝',
      needs_reconcile: '状态待核对',
      failed: '失败',
    },
    dialog: {
      previewNote: '撤回前影响预览（执行时会重新核验）',
      titleRevert: '撤回 {id} 的修复',
      titleRestore: '恢复 {id} 的修复',
      targetSha: '目标提交',
      files: '涉及文件',
      filesCount: '{n} 个（含前端 {fe} 个）',
      migration: '数据库迁移',
      migrationYes: '涉及（不能自动撤回）',
      migrationNo: '不涉及',
      later: '之后改过同一文件的提交',
      laterCount: '{n} 个，可能冲突',
      laterNone: '无',
      frontend: '前端',
      backend: '后端',
      shipTitle: '完成后何时发布',
      shipNext: '随下次 03:00 发布（前端会直接生效，后端等你切换）',
      shipImmediate: '立即发布',
      immediateWarn: '立即发布会马上重建两个前端并准备后端（后端仍需你切换），并且会带上 master 上目前所有已合入的改动，不只是这次撤回。',
      staleRefreshed: '内容已变化，已刷新预览',
      notAllowed: '当前不能执行：{reason}',
      failNote: '冲突、测试失败或状态变化时，master 不变，转「待人工处理」或重新预览。',
      cancel: '取消',
      close: '关闭',
      confirmRevert: '确认撤回',
      confirmRestore: '确认恢复',
      submitting: '提交中…',
      progress: '执行进度',
      stepShip: '发布',
      opId: '操作编号 {id}',
      done: '已完成，结果提交 {sha}',
      failed: '未完成：{state}',
      errorDetail: '错误信息：{error}',
      requestError: '提交失败：{message}',
      previewError: '预览加载失败，请稍后重试。',
      loadingPreview: '正在生成预览…',
      pollError: '暂时读不到进度，稍后自动重试',
      pollGaveUp: '无法获取进度，请稍后刷新',
      pollRetry: '重试',
      releaseTitle: '发布记录',
      releaseNext: '将随下次 03:00 发布',
    },
    handoffs: {
      title: '自动处理交接',
      sub: '自动处理转给人工的事项，包括由管理员执行的项目环境变更单',
      empty: '暂无自动处理交接事项。',
      loadError: '交接事项加载失败，请稍后重试。',
      createdAt: '转交时间',
      changeOrder: '变更单',
      project: '项目',
      summary: '说明',
      steps: '执行步骤',
    },
  },
} as const;

export default zh;
